import { filter } from 'rxjs/operators';
import { InventoryService } from './../../../apps/inventory/inventory.service';
import { LayoutService } from './../../layout.service';
import {
  RecordModel,
  RecordLine,
  RecordCategory,
  RecordProperties,
} from './../../record-model';
import {
  Section,
  Values,
  SectionAdditionalInformation,
  ModuleInventoryDirection,
  Field,
} from './../../../models/module-structure';
import { ModuleStructure } from 'src/app/models/module-structure';
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import * as g from 'src/app/globals';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import * as moment from 'moment';
import { NzSelectComponent } from 'ng-zorro-antd/select';
import * as accounting from 'accounting';
import { NzModalService } from 'ng-zorro-antd/modal';
import { FieldValueChangedArgs } from '@app/layout/field-value-changed-args';
import { AbstractControl, FormControl } from '@angular/forms';
import { Observable, Observer } from 'rxjs';
import { VoiceService } from '@app/voice-service.service';
import { LineAttachmentsComponent } from '@app/layout/record-page/custom-buttons/line-attachments/line-attachments.component';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { RecordPageComponent } from '@app/layout/record-page/record-page.component';

interface ScanStep {
  value: string; // the scanned value
  status?: 'P' | 'S' | 'E'; // Pending, Success, Error
  scanControl: FormControl;
  quantityControl: FormControl;
  serialNumberControl: FormControl;
}
@Component({
  selector: 'app-lines-template-section',
  templateUrl: './lines-template-section.component.html',
  styleUrls: ['./lines-template-section.component.less'],
})
export class LinesTemplateSectionComponent implements OnInit {
  @ViewChild('quantityControl') quantityControl: ElementRef;
  @ViewChild('serialNumberControl') serialNumberControl: ElementRef;
  @ViewChild('scanBatchControl') scanBatchControl: ElementRef;
  @ViewChild('scanBinControl') scanBinControl: ElementRef;

  @ViewChild('scanOffLoadingItemControl') scanOffLoadingItemControl: ElementRef;
  @ViewChild('scanOffLoadingUOMControl')
  scanOffLoadingUOMControl: NzSelectComponent;
  @ViewChild('offloadQuantityControl') offloadQuantityControl: ElementRef;

  codes: string[] = [
    'A00001',
    'A00002',
    'A00003',
    'A00004',
    'A00005',
    'AG00001',
    'AG00002',
    'AG00003',
    'C00001',
    'C00002',
    'C00003',
    'C00004',
    'C00005',
    'C00006',
    'C00007',
    'C00008',
    'C00009',
    'C00010',
    'C00011',
    'C00012',
    'C00013',
    'C00014',
    'COW_0001',
    'COW_0002',
    'COW_0003',
    'COW_0004',
    'COW_0005',
    'COW_0006',
    'COW_0007',
    'COW_0008',
    'COW_0009',
    'COW_0010',
    'COW_0011',
    'COW_0012',
    'COW_0013',
    'COW_0014',
    'COW_0015',
    'COW_0016',
    'COW_0017',
    'COW_0018',
    'COW_0019',
    'COW_0020',
    'COW_0021',
    'COW_0022',
    'COW_0023',
    'COW_0024',
    'COW_0025',
    'COW_0026',
    'COW_0027',
    'COW_0028',
    'COW_0029',
    'COW_0030',
    'CustomerPortal',
    'D00001',
    'D00002',
    'Grub1',
    'Grub2',
    'Grub3',
    'I00001',
    'I00002',
    'I00003',
    'I00004',
    'I00005',
    'I00006',
    'I00007',
    'I00008',
    'I00009',
    'I00010',
    'I00011',
    'I00012',
    'integration_service',
    'L10001',
    'LB0002',
    'LM4029ACA',
    'LM4029APCD',
    'LM4029D',
    'LM4029MC',
    'LM4029PH',
    'LM4029SB',
    'MonthlyItem',
    'MonthlyItem - noti',
    'MonthlyItem - noti - u',
    'MonthlySub',
    'MonthlySub-u',
    'MRP_Artikel1',
    'MRP_Artikel2',
    'MRP_Artikel3',
    'MRP_Artikel4',
    'MRP_Artikel5',
    'MRP_Artikel6',
    'MRP_Artikel8',
    'MRP_Child2',
    'MRP_Grandchild',
    'OPFS10',
    'OPFS11',
    'OPFS12',
    'OPFS13',
    'OPFS14',
    'P10010',
    'P10011',
    'P10012',
    'R00001',
    'R00002',
    'SHEEP_0001',
    'SHEEP_0002',
    'SHEEP_0003',
    'SHEEP_0004',
    'SHEEP_0005',
    'SHEEP_0006',
    'SHEEP_0007',
    'SHEEP_0008',
    'SHEEP_0009',
  ];
  fieldsToRenderInCard: Field[];

  hideDetailsButtonInCardsSection = g.hideDetailsButtonInCardsSection;
  //shouldFocusOnScanControl: boolean;
  shouldFocusOnScanControlModuleId: number = 100008;
  hideDeleteButtonInCardsSection = g.hideDeleteButtonInCardsSection;

  processCode(scanControl, quantityControl, serialNumberControl, code: string) {
    scanControl.value = code;

    // call your function
    this.executeScan(scanControl, quantityControl, serialNumberControl);
  }

  // Sleep utility
  sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // Loop with delay
  runSequentially(scanControl, quantityControl, serialNumberControl) {
    for (const code of this.codes) {
      this.processCode(scanControl, quantityControl, serialNumberControl, code); // run your function here
      setTimeout(() => {}, 100); // wait 500ms
    }
  }

  @Input() moduleStructure: ModuleStructure;
  @Input() section: Section;
  @Input() recordModel: RecordModel;
  @Input() defaultVals: Values;
  @Input() actionType = '';
  @Input() parentComponent: any;

  formatPercent = (percent: number) => `${Number(percent).toFixed(1)} %`;

  InventoryDirection = ModuleInventoryDirection;
  autoIncrease = false;
  isReverse = false;
  lines: RecordLine[] = [];
  visibleLines: RecordLine[] = [];
  deletedLines: RecordLine[] = [];
  fieldsToRender: any[] = [];
  quantityField: any;
  countedField: any;
  openQuantityField: any;
  quantityFieldTitle = 'Quantity';
  openQuantityFieldTitle = 'Open Qty';
  quantityFieldPropertyName = 'Quantity';
  warehouseCodeField: any;
  fromWarehouseField: any;
  tableWidth = 0;
  maxLineNum = 0;
  screenSize = '';
  openQuantityToWorkWith: RecordProperties;
  itemCodeToWorkWith: RecordProperties;
  itemDescriptionToWorkWith: RecordProperties;
  scanMode: string;
  batchNumberAvaQty: number;
  unitsPerMeasureToWorkWith: RecordProperties;
  displayMode = true;
  displayActionForLine = false;

  global = g;

  isProcessingScan: boolean = false;
  isNewItemScan: boolean = false;
  newItemReview: string = '';
  currentScanIndex: number = 0;
  scansToApply: ScanStep[] = [];

  get additionalInformation(): SectionAdditionalInformation {
    return this.section.AdditionalInformationParsed;
  }

  batchScanFieldVisible = false;
  binScanFieldVisible = false;

  // offloading
  offLoadingItemScanFieldVisible = false;
  offLoadingUOMScanFieldVisible = false;
  offLoadingQtyScanFieldVisible = false;
  offLoadingUOMOptions: any[];
  offLoadingUOM: string;
  offLoadingPallet: string;
  offLoadingManageByBatch = false;
  offLoadingManageBySerial = false;
  //end

  sourceLines: any;
  rowToWorkWithVal: RecordLine;
  quantityToWorkWith: RecordProperties;
  lastScannedRow: RecordLine;
  lastScannedLineInfoVisible = false;
  get rowToWorkWith(): RecordLine {
    return this.rowToWorkWithVal;
  }

  set rowToWorkWith(val: RecordLine) {
    this.rowToWorkWithVal = val;
    if (this.rowToWorkWith == null || this.rowToWorkWith === undefined) {
      this.batchNumberAvaQty = 0;
      this.scanControl.nativeElement.disabled = false;
      this.quantityToWorkWith = null;
    } else {
      this.quantityToWorkWith = this.rowToWorkWith.Properties.find(
        (p) => p.Name === 'Quantity' || p.Name == 'PickedQuantity',
      );

      this.openQuantityToWorkWith = this.rowToWorkWith.Properties.find(
        (p) => p.Name === 'OpenQty' || p.Name == 'ReleasedQuantity',
      );

      this.itemCodeToWorkWith = this.rowToWorkWith.Properties.find(
        (p) => p.Name === 'ItemCode',
      );

      this.itemDescriptionToWorkWith = this.rowToWorkWith.Properties.find(
        (p) => p.Name === 'ItemDescription',
      );

      this.unitsPerMeasureToWorkWith = this.rowToWorkWith.Properties.find(
        (p) => p.Name === 'UnitsOfMeasurment',
      );

      if (
        this.recordModel.ObjectKey === 'InventoryCounting' ||
        this.recordModel.ObjectKey === 'InventoryPosting'
      ) {
        this.unitsPerMeasureToWorkWith = this.rowToWorkWith.Properties.find(
          (p) => p.Name === 'NumInCnt',
        );
      }

      if (this.batchNumberAvaQty !== 0) {
        let upm =
          this.unitsPerMeasureToWorkWith == null ||
          this.unitsPerMeasureToWorkWith === undefined
            ? 0
            : Number(this.unitsPerMeasureToWorkWith.ValueAsObject);
        this.batchNumberAvaQty = this.batchNumberAvaQty / (upm === 0 ? 1 : upm);
      }

      if (
        this.recordModel.ObjectKey === 'InventoryCounting' ||
        this.recordModel.ObjectKey === 'InventoryPosting'
      ) {
        this.quantityToWorkWith = this.rowToWorkWith.Properties.find(
          (prop) => prop.Name === 'UoMCountedQuantity',
        );
      }

      this.lastScannedRow = val;
    }
  }

  isNew = false;
  //quickScan = false;
  scannedQty: number;
  serialNumber: string;
  batchNumber: string;
  fromBinOptions: any[];
  fromBinCode: string;
  binOptions: any[];
  binCode: string;

  //new
  //toBinOptions: any[];
  //toBinCode: string;

  isModalOpen = false;

  fields: any[];
  fieldGroups: any;
  thereIsCenter: boolean;
  fieldGroupCount: number;
  fieldGroupKeys: any[];
  innerWidth = 0;
  cumulativeModeForNormalItems = false;
  fullBatchQtyMode = false;
  setCountedAsChecked = false;
  enableReverseMode = false;
  enableBatchAllocation = false;
  disableAddingNewLines = false;
  enableAutoIncreaseMode = false;
  enableMovingLineInUpdateMode = true;
  uniqueBatchModeCounting = false;
  uniqueBatchModeGoodIssue: boolean = g.uniqueBatchModeGoodIssue;
  allowAddNewItemsInPackage: boolean = false;
  //uniqueBatchModeTransfer: boolean = g.uniqueBatchModeGoodIssue;

  enablePaginationInLineSection: boolean = g.enablePaginationInLineSection;
  pageSizeInLineSection: number = g.pageSizeInLineSection;
  currentPage: number = 1;
  paginatedLines: any[] = [];
  scanFieldPlaceholder = 'Scan barcode here';

  @ViewChild('binLocationFrom') binLocationFrom: NzSelectComponent;
  @ViewChild('binLocationTo', { static: true })
  binLocationTo!: NzSelectComponent;
  @ViewChild('binLocationToS', { static: true })
  binLocationToS!: NzSelectComponent;

  @ViewChild('scanControl') scanControl: ElementRef;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }
  constructor(
    private layoutService: LayoutService,
    private drawerService: NzDrawerService,
    private message: NzMessageService,
    private inventoryService: InventoryService,
    private notificationService: NzNotificationService,
    private modal: NzModalService,
    private voiceService: VoiceService,
  ) {
    this.innerWidth = window.innerWidth;
    inventoryService.clearScanCache();

    layoutService.fieldValueChanged.subscribe((args: FieldValueChangedArgs) => {
      try {
        const currentObject = args.recordModel.ObjectKey;
        if (currentObject === 'ITM_WMS_DEL_PLT') {
          console.log(args);
          if (args.recordProperty.Name === 'SSCC_CITY') {
            if (args.recordProperty.ValueAsObject !== '') {
              this.scanControl.nativeElement.focus();
              //this.shouldFocusOnScanControl = true;
            }
          }
        } else if (currentObject === 'ITM_WMS_BOX_DCLR') {
          if (args.recordProperty.Name === 'U_ITEM_CODE') {
            if (args.recordProperty.ValueAsObject !== '') {
              //this.scanControl.nativeElement.focus();
              //this.shouldFocusOnScanControl = true;
              const element = document.querySelector(
                '.-link-U_SSCC_CODE',
              ) as HTMLElement;

              if (element) {
                element.focus();
              } else {
                console.error('Element with class .my-element not found.');
                this.scanControl.nativeElement.focus();
                //this.shouldFocusOnScanControl = true;
              }
            }
          }
          if (args.recordProperty.Name === 'U_SSCC_CODE') {
            if (args.recordProperty.ValueAsObject !== '') {
              this.scanControl.nativeElement.focus();
              //this.shouldFocusOnScanControl = true;
            }
          }
        } else if (currentObject === 'ITM_WMS_BOX_DCLR_1') {
          if (args.recordProperty.Name === 'U_ITEM_CODE') {
            if (args.recordProperty.ValueAsObject !== '') {
              //this.scanControl.nativeElement.focus();
              //this.shouldFocusOnScanControl = true;
              const element = document.querySelector(
                '.-link-U_SSCC_CODE',
              ) as HTMLElement;

              if (element) {
                element.focus();
              } else {
                console.error('Element with class .my-element not found.');
              }
            }
          }
          if (args.recordProperty.Name === 'U_SSCC_CODE') {
            if (args.recordProperty.ValueAsObject !== '') {
              this.scanControl.nativeElement.focus();
              //this.shouldFocusOnScanControl = true;
            }
          }
        } else if (currentObject === 'ITM_WMS_SSCC') {
          if (args.recordProperty.Name === 'U_SSCC') {
            //if (args.recordProperty.ValueAsObject !== '') {
            this.scanControl.nativeElement.focus();
            //this.shouldFocusOnScanControl = true;
            //}
          }
        } else if (currentObject === 'oOrders') {
          if (args.recordProperty.Name === 'CardCode') {
            if (args.recordProperty.ValueAsObject !== '') {
              this.scanControl.nativeElement.focus();
              //this.shouldFocusOnScanControl = true;
            }
          }
        }
      } catch (e) {
        console.log('An error occured while trying to execute oWMS', args, e);
      }
    });
  }

  ngOnInit(): void {
    var docsToCheck = g.enableBatchAllocationForDocuments.split(',');
    this.enableBatchAllocation =
      docsToCheck.indexOf(this.recordModel.ObjectKey) !== -1;

    docsToCheck = g.disableAddingNewLinesForDocuments.split(',');
    this.disableAddingNewLines =
      docsToCheck.indexOf(this.recordModel.ObjectKey) !== -1;

    this.inventoryService.clearScanCache();
    this.scansToApply = [];
    const moduleApp =
      this.moduleStructure.module.AdditionalInformationParsed.ModuleApp;
    if (this.innerWidth > 992 && moduleApp !== 'itm-wms-360') {
      this.displayMode = false;
    } else {
      this.displayMode = true;
    }

    if (!this.section.AdditionalInformationParsed.AllowScan) {
      //expense
      this.displayMode = true;
    }

    this.screenSize = this.layoutService.screenSize;
    this.layoutService.screenSizeEmitter.subscribe((d) => {
      this.screenSize = d;
    });

    this.lines = this.getSectionCategory().Lines;
    this.visibleLines = [];
    this.fieldsToRender = this.getFieldsToRender();
    this.prepareSectionFields();

    if (this.section.AdditionalInformationParsed.AdditionalCSS != null) {
      this.scanFieldPlaceholder =
        this.section.AdditionalInformationParsed.AdditionalCSS;
    }

    setInterval(() => {
      if (
        //this.shouldFocusOnScanControl == true &&
        this.moduleStructure.module.Id === this.shouldFocusOnScanControlModuleId
      ) {
        //this.scanControl.nativeElement.focus();
        //this.scanControl.nativeElement.focus();
        //this.scanControl.nativeElement.select();
      }
    }, 500);

    setTimeout(() => {
      const currentObject = this.recordModel.ObjectKey;
      if (
        currentObject === 'ITM_WMS_BOX_DCLR' ||
        currentObject === 'ITM_WMS_BOX_DCLR_1'
      ) {
        const element = document.querySelector(
          '.-link-U_ITEM_CODE',
        ) as HTMLElement;

        if (element) {
          element.focus(); // Set focus on the element
        } else {
          console.error('Element with class .my-element not found.');
        }
      } else if (currentObject === 'ITM_WMS_SSCC') {
        const headerLine = this.recordModel.Categories.find(
          (c) => c.Id === 'ITM_WMS_SSCC',
        ).Lines[0];
        const sscc = headerLine.Properties.find(
          (p) => p.Name === 'U_SSCC',
        ).ValueAsObject;

        const element = document.querySelector(
          '.-string-U_SSCC',
        ) as HTMLElement;

        if (element && (sscc == null || sscc === undefined || sscc === '')) {
          element.focus(); // Set focus on the element
        } else {
          this.scanControl.nativeElement.focus();
          //this.shouldFocusOnScanControl = true;
        }
      } else if (currentObject === 'oOrders') {
        const headerLine = this.recordModel.Categories.find(
          (c) => c.Id === 'Documents',
        ).Lines[0];
        const cardCode = headerLine.Properties.find(
          (p) => p.Name === 'CardCode',
        ).ValueAsObject;

        const element = document.querySelector(
          '.-link-CardCode',
        ) as HTMLElement;

        if (
          element &&
          (cardCode == null || cardCode === undefined || cardCode === '')
        ) {
          element.focus(); // Set focus on the element
        } else {
          this.scanControl.nativeElement.focus();
          //this.shouldFocusOnScanControl = true;
        }
      } else {
        this.scanControl.nativeElement.focus();
        //this.shouldFocusOnScanControl = true;
      }
      this.scanControl.nativeElement.scrollIntoView(true);
    }, 200);

    this.layoutService
      .getConfiguration('config_cumulative_qty')
      .subscribe((response) => {
        this.cumulativeModeForNormalItems = response === 'Y' || response == '';
      });

    this.layoutService
      .getConfiguration('config_full_batch_qty')
      .subscribe((response) => {
        this.fullBatchQtyMode = response === 'Y' || response == '';
      });

    this.layoutService
      .getConfiguration('config_set_counted_after_scan')
      .subscribe((response) => {
        this.setCountedAsChecked = response === 'Y' || response == '';
      });

    this.layoutService
      .getConfiguration('config_counting_unique_batch')
      .subscribe((response) => {
        this.uniqueBatchModeCounting =
          response === 'Y' || g.uniqueBatchModeCounting;
      });

    this.layoutService.linesChanged.subscribe(
      (recordCategory: RecordCategory) => {
        this.lines = [...recordCategory.Lines];

        this.updatePaginatedLines();
      },
    );

    this.updatePaginatedLines();

    this.displayActionForLine =
      this.moduleStructure.buttons.filter(
        (button) =>
          button.SectionId == this.section.Id &&
          button.AdditionalInformationParsed.OnLineLevel,
      ).length !== 0;

    this.enableReverseMode = g.enableReverseMode;
    this.enableAutoIncreaseMode = g.enableAutoIncreaseMode;
    this.enableMovingLineInUpdateMode = g.enableMovingLineInUpdateMode;
    this.autoIncrease = g.autoIncreaseActivatedByDef;

    this.fieldsToRenderInCard = this.section.Fields.filter(
      (field) => field.AdditionalInformationParsed.SendToMobileApp,
    );

    /*#setTimeout(() => {
      this.runSequentially(
        this.scanControl,
        this.quantityControl,
        this.serialNumberControl
      );
    }, 5000);*/

    if (this.recordModel.ObjectKey === 'ITM_OFF_LOAD_DEF') {
      this.scanFieldPlaceholder = 'Scan Pallet';
    }
  }

  palletNumber = '';
  ScanNewOffLoadingPallet() {
    if (this.palletNumber === '') {
      this.palletNumber = Math.floor(Date.now() / 1000).toString();
    }
    this.scanControl.nativeElement.value = this.palletNumber;
    this.processCode(
      this.scanControl,
      this.quantityControl,
      this.serialNumberControl,
      this.palletNumber,
    );
  }

  private parseAttachmentsText(text: string): string[] {
    // newline separated; trim empty lines
    return (text || '')
      .split(/\r\n|\n|\r/)
      .map((s) => (s || '').trim())
      .filter((s) => s.length > 0);
  }

  resetScan(scanControl: HTMLInputElement) {
    if (this.recordModel.ObjectKey === 'ITM_OFF_LOAD_DEF') {
      this.resetScanFields(undefined, scanControl);
      this.isProcessingScan = false;
      this.offLoadingPallet = '';
      this.palletNumber = '';
    } else {
      scanControl.value = '';
      this.rowToWorkWith = null;
      scanControl.disabled = false;
      scanControl.focus();
    }
  }

  resetScanAndNew(scanControl: HTMLInputElement) {
    if (this.recordModel.ObjectKey === 'ITM_OFF_LOAD_DEF') {
      this.resetScanFields(undefined, scanControl);
      this.isProcessingScan = false;
      this.offLoadingPallet = '';
      this.ScanNewOffLoadingPallet();
    } else {
      scanControl.value = '';
      this.rowToWorkWith = null;
      scanControl.disabled = false;
      scanControl.focus();
    }
  }

  FinishScanOffLoadingPallet(scanControl, quantityControl) {
    if (
      this.palletNumber == null ||
      this.palletNumber === undefined ||
      this.palletNumber === ''
    ) {
      return;
    }
    const currentPallet = this.palletNumber;
    this.palletNumber = '';
    const drawerRef = this.drawerService.create<
      LineAttachmentsComponent,
      {
        attachmentsText: string;
        readOnly: boolean;
        required: boolean;
        isImage: boolean;
        allowUploadFile: boolean;
        allowSignature: boolean;
        allowUsingCamera: boolean;
      },
      string
    >({
      nzContent: LineAttachmentsComponent,
      nzWrapClassName: 'drawer-size-3x',
      nzTitle: 'Pallet images',
      nzContentParams: {
        attachmentsText: '',
        readOnly: false,
        required: true,
        isImage: true,
        allowUploadFile: true,
        allowSignature: false,
        allowUsingCamera: true,
      },
    });

    drawerRef.afterClose.subscribe((result: string) => {
      if (typeof result === 'string') {
        //recordProperty.ValueAsObject = result;
        //recordProperty.Value = result;
        //add new line to attachment section
        let lines = this.parseAttachmentsText(result);

        let section = this.moduleStructure.module.Sections.find(
          (sec) => sec.XmlTagName === 'ITM_OFF_LOAD_ATT',
        );
        let recordCategory = this.recordModel.Categories.find(
          (cat) => cat.Id === 'ITM_OFF_LOAD_ATT',
        );
        for (let index = 0; index < lines.length; index++) {
          const line = lines[index];
          RecordModel.addLineToTable(
            this.recordModel,
            section,
            recordCategory,
            this.defaultVals,
            recordCategory.Lines,
            this.layoutService,
            this.moduleStructure,
            undefined,
          );

          const newLine = recordCategory.Lines[recordCategory.Lines.length - 1];
          const fileProp = newLine.Properties.find(
            (p) => p.Name === 'U_ATT_PATH',
          );
          fileProp.ValueAsObject = fileProp.Value = line;

          const palletNumber = newLine.Properties.find(
            (p) => p.Name === 'U_PLT_NUMBER',
          );
          palletNumber.ValueAsObject = palletNumber.Value = currentPallet;
        }
      }
    });

    this.resetScanFields(quantityControl, scanControl);
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.updatePaginatedLines();
  }

  updatePaginatedLines(): void {
    if (this.enablePaginationInLineSection) {
      const startIndex = (this.currentPage - 1) * this.pageSizeInLineSection;
      const endIndex = startIndex + this.pageSizeInLineSection;
      if (this.checkHideLinesWithZeroQtyForDocsRule()) {
        this.visibleLines = this.lines.filter(
          (line) =>
            line.QuantityProp !== undefined &&
            line.QuantityProp.ValueAsObject != 0,
        );
        this.paginatedLines = this.visibleLines.slice(startIndex, endIndex);
      } else {
        this.visibleLines = this.lines;
        this.paginatedLines = this.lines.slice(startIndex, endIndex);
      }
      this.paginatedLines = [...this.paginatedLines];
    } else {
      //this.paginatedLines = [...this.lines];
      if (this.checkHideLinesWithZeroQtyForDocsRule()) {
        this.visibleLines = this.lines.filter(
          (line) =>
            line.QuantityProp !== undefined &&
            line.QuantityProp.ValueAsObject != 0,
        );
        this.paginatedLines = [...this.visibleLines];
      } else {
        this.visibleLines = this.lines;
        this.paginatedLines = [...this.lines];
      }
    }
  }

  prepareSectionFields() {
    this.fields = this.section.Fields.sort((a, b) => a.SortOrder - b.SortOrder);
    for (let i = 0; i < this.moduleStructure.module.Sections.length; i++) {
      var section = this.moduleStructure.module.Sections[i];
      if (section.XmlTagName == this.section.XmlTagName) {
        section = this.section;
        break;
      }
    }

    this.fieldGroups = this.fields.reduce(function (acc, obj) {
      var key = obj['PCAlignment'];
      if (key == 0) {
        key = 1;
      }
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});

    this.thereIsCenter =
      this.fields.filter((obj) => obj.PCAlignment === 4).length > 0;

    this.fieldGroupCount = Object.keys(this.fieldGroups).length;

    this.fieldGroupKeys = Object.keys(this.fieldGroups);

    for (const key of this.fieldGroupKeys) {
      this.fieldGroups[key] = this.fieldGroups[key].sort((field1, field2) => {
        return this.layoutService.compareObjects(field1, field2, 'SortOrder');
      });
    }
  }

  getSpanVal(fieldKey: number): number {
    if (fieldKey === 3 || this.fieldGroupCount === 1) {
      return 24;
    } else {
      if (this.thereIsCenter) {
        return 8;
      } else {
        return 12;
      }
    }
  }

  getPushVal(fieldKey: number): number {
    if (this.fieldGroupCount === 1) {
      return 0;
    } else {
      if (this.thereIsCenter && fieldKey === 2) {
        return 8;
      } else {
        return 0;
      }
    }
  }

  getPullVal(fieldKey: number): number {
    if (this.fieldGroupCount === 1) {
      return 0;
    } else {
      if (this.thereIsCenter && fieldKey === 4) {
        return 8;
      } else {
        return 0;
      }
    }
  }

  addLineToTable(): number {
    let recordCategory: RecordCategory = null;
    this.recordModel.Categories.forEach((category) => {
      if (category.Id === this.section.XmlTagName) {
        recordCategory = category;
        return;
      }
    });

    if (recordCategory == null) {
      recordCategory = {
        Id: this.section.XmlTagName,
        Lines: [],
        DeletedLines: [],
      };
      this.recordModel.Categories.push(recordCategory);
    }
    if (recordCategory.Lines.length !== 0 && this.maxLineNum === 0) {
      if (
        this.recordModel.ObjectKey === 'InventoryCounting' ||
        this.recordModel.ObjectKey === 'InventoryPosting'
      ) {
        this.maxLineNum =
          Math.max.apply(
            Math,
            recordCategory.Lines.map(
              (o) =>
                o.Properties.find((prop) => prop.Name === 'LineNumber')
                  .ValueAsObject,
            ),
          ) + 1;
      } else if (
        this.recordModel.ObjectKey === 'ITM_WMS_PLT_BOX' ||
        this.recordModel.ObjectKey === 'ITM_WMS_BOX_DCLR' ||
        this.recordModel.ObjectKey === 'ITM_WMS_BOX_DCLR_1' ||
        this.recordModel.ObjectKey === 'ITM_WMS_NON_PRDUCD'
      ) {
        this.maxLineNum =
          Math.max.apply(
            Math,
            recordCategory.Lines.map(
              (o) =>
                o.Properties.find((prop) => prop.Name === 'LineId')
                  .ValueAsObject,
            ),
          ) + 1;
      } else {
        this.maxLineNum =
          Math.max.apply(
            Math,
            recordCategory.Lines.map(
              (o) =>
                o.Properties.find(
                  (prop) => prop.Name === 'LineNum' || prop.Name === 'LineId',
                ).ValueAsObject,
            ),
          ) + 1;
      }
    } else {
      this.maxLineNum++;
    }

    let recordLine: RecordLine = null;
    recordLine = {
      Id: recordCategory.Lines.length,
      MaxIndex: this.maxLineNum,
      Properties: [],
    };

    console.log(recordLine);

    RecordModel.refineTheRecordModelLine(
      this.layoutService,
      this.section,
      recordLine,
      this.defaultVals,
    );

    this.layoutService.lineAdded.emit({
      recordLine,
      moduleStructure: this.moduleStructure,
      section: this.section,
      recordModel: this.recordModel,
    });

    recordCategory.Lines = [...recordCategory.Lines, recordLine];
    this.lines = recordCategory.Lines;

    for (const property of recordLine.Properties) {
      const field = this.section.Fields.find(
        (p) => p.PropertyName === property.Name,
      );
      if (field.ParentProperties != null && field.ParentProperties !== '') {
        let queryIdToExecute = field.SQLStatementParentChanged;
        if (queryIdToExecute == null || queryIdToExecute === 0) {
          queryIdToExecute = field.SQLStatementId;
        }

        if (queryIdToExecute != null && queryIdToExecute !== 0) {
          this.layoutService.getFieldValueOnParentChange(
            this.recordModel,
            recordCategory,
            recordLine,
            property,
            queryIdToExecute,
            field,
            this.moduleStructure,
            true,
          );
        }
      }
    }

    this.updatePaginatedLines();
    return this.lines.length - 1;
  }

  getSectionCategory(): RecordCategory {
    let recordCategory: RecordCategory = null;
    this.recordModel.Categories.forEach((category) => {
      if (category.Id === this.section.XmlTagName) {
        recordCategory = category;
      }
    });

    if (recordCategory == null) {
      recordCategory = {
        Id: this.section.XmlTagName,
        Lines: [],
        DeletedLines: [],
      };
      this.recordModel.Categories.push(recordCategory);
    }
    return recordCategory;
  }

  getFieldsToRender(): any {
    this.section.Fields.forEach((field) => {
      if (
        field.AdditionalInformation !== undefined &&
        field.AdditionalInformation != null &&
        field.AdditionalInformation !== ''
      ) {
        const additionalInformation = JSON.parse(field.AdditionalInformation);
        if (
          additionalInformation.VisibleInDialogOnly !== undefined &&
          additionalInformation.VisibleInDialogOnly
        ) {
          field.AdditionalInformationParsed.Visible = false;
        }
      }
    });

    this.quantityFieldPropertyName =
      this.section.AdditionalInformationParsed.QuantityFieldPropertyName;
    if (
      this.quantityFieldPropertyName == null ||
      this.quantityFieldPropertyName === undefined ||
      this.quantityFieldPropertyName === ''
    ) {
      this.quantityFieldPropertyName = 'Quantity';
    }
    this.quantityField = this.section.Fields.find(
      (prop) => prop.PropertyName === this.quantityFieldPropertyName, //'Quantity'
    );
    if (
      this.recordModel.ObjectKey === 'InventoryCounting' ||
      this.recordModel.ObjectKey === 'InventoryPosting'
    ) {
      this.quantityField = this.section.Fields.find(
        (prop) => prop.PropertyName === 'UoMCountedQuantity',
      );
      this.countedField = this.section.Fields.find(
        (prop) => prop.PropertyName === 'Counted',
      );

      this.quantityFieldTitle = 'Counted Base Units';
    } else if (this.recordModel.ObjectKey === 'oPickLists') {
      this.quantityField = this.section.Fields.find(
        (prop) => prop.PropertyName === 'PickedQuantity',
      );
      this.quantityFieldTitle = 'Picked';
    }
    this.openQuantityField = this.section.Fields.find(
      (prop) => prop.PropertyName === 'OpenQty',
    );

    if (this.recordModel.ObjectKey === 'oPickLists') {
      this.openQuantityField = this.section.Fields.find(
        (prop) => prop.PropertyName === 'ReleasedQuantity',
      );
      this.openQuantityFieldTitle = 'Released Quantity';
    }
    this.fromWarehouseField = this.section.Fields.find(
      (prop) => prop.PropertyName === 'FromWarehouse',
    );
    this.warehouseCodeField = this.section.Fields.find(
      (prop) => prop.PropertyName === 'WarehouseCode',
    );

    return this.section.Fields.filter(
      (field) =>
        field.DataType !== 11 && field.AdditionalInformationParsed.Visible,
    ).sort((field1, field2) => {
      return this.layoutService.compareObjects(field1, field2, 'SortOrder');
    });
  }

  thereIsSerial(line) {
    return (
      line.Properties.find((p) => p.Name === 'ITMSerialNumber')
        .ValueAsObject !== ''
    );
  }

  getSerialData(line) {
    if (line.ManBtchNum === 'Y') {
      return line.Properties.find((p) => p.Name === 'ITMSerialNumber')
        .ValueAsObject;
    } else if (line.ManSerNum === 'Y') {
      return line.Properties.find((p) => p.Name === 'ITMSerialNumber')
        .ValueAsObject;
    }
  }

  sectionTotals(): string {
    let totalQuantities = 0;
    if (this.displayMode) {
      for (let i = 0; i < this.visibleLines.length; i++) {
        totalQuantities += Number(
          this.visibleLines[i].QuantityProp === undefined
            ? 0
            : this.visibleLines[i].QuantityProp.ValueAsObject,
        );
      }
    } else {
      for (let i = 0; i < this.lines.length; i++) {
        totalQuantities += Number(
          this.lines[i].QuantityProp === undefined
            ? 0
            : this.lines[i].QuantityProp.ValueAsObject,
        );
      }
    }
    return (
      this.layoutService.translate('Total lines:') +
      ' ' +
      (this.displayMode ? this.visibleLines.length : this.lines.length) +
      (totalQuantities === 0
        ? ''
        : ', ' +
          (this.layoutService.translate('Total quantities:') +
            ' ' +
            totalQuantities))
    );
  }

  lastScannedLineInfo(): string {
    if (this.lastScannedRow == null || this.lastScannedRow === undefined) {
      this.lastScannedLineInfoVisible = false;
      return '';
    }
    let itemDescription = this.lastScannedRow.Properties.find(
      (prop) =>
        prop.Name === 'ItemDescription' ||
        prop.Name === 'ItemName' ||
        prop.Name == 'ItemDesc',
    ).ValueAsObject;
    this.lastScannedLineInfoVisible = true;
    let template = `<strong>
  ${itemDescription}
</strong>
<br />
<span style="font-size: 16px;">
  ${this.lastScannedRow.ItemCodeProp.ValueAsObject}
</span>
<nz-row class="ant-row ng-star-inserted" style="padding-top: 5px; margin-left: -8px; margin-right: -8px;">
   <nz-col class="ant-col ant-col-12" style="padding-left: 8px; padding-right: 8px;">
      <nz-statistic>
         <div class="ant-statistic">
            <div class="ant-statistic-content">
               <nz-statistic-number>
                  <span class="ant-statistic-content-value">
					        <span class="ant-statistic-content-value-int ng-star-inserted">${this.lastScannedRow.QuantityProp.ValueAsObject}</span>
                  </span>
               </nz-statistic-number>
            </div>
         </div>
      </nz-statistic>
   </nz-col>
</nz-row>
`;
    /*return (
      this.layoutService.translate('Scanned Item Code: ') +
      this.lastScannedRow.ItemCodeProp.ValueAsObject +
      ', Item Name: ' +
      itemDescription +
      ', Qty: ' +
      this.lastScannedRow.QuantityProp.ValueAsObject
    );*/
    return template;
  }

  loadQuantity(lineId, checked) {
    let recordCategory: RecordCategory = null;
    this.recordModel.Categories.forEach((category) => {
      if (category.Id === this.section.XmlTagName) {
        recordCategory = category;
      }
    });

    const line = recordCategory.Lines.find((d) => d.Id === lineId);

    if (!checked) {
      line.Properties.find((p) => p.Name === 'Quantity').ValueAsObject =
        line.Properties.find((p) => p.Name === 'TempQuantity').ValueAsObject;
    } else {
      line.Properties.find((p) => p.Name === 'Quantity').ValueAsObject = 0;
    }
  }

  /*
  getRecordHtml(record) {
    const template = Handlebars.compile(
      this.section.AdditionalInformationParsed.LineTemplate
    );
    const html = template(record);
    return html;
  }
  */

  executeNextScanStep() {
    if (this.currentScanIndex >= this.scansToApply.length) {
      this.isProcessingScan = false;
      return;
    }

    this.isProcessingScan = true;

    const scanStep = this.scansToApply[this.currentScanIndex];
    const { scanControl, quantityControl, serialNumberControl, value } =
      scanStep;

    scanStep.value = value;
    //scanControl.disabled = true;

    this.inventoryService
      .getScannedValueType(value, this.recordModel.ObjectKey)
      .subscribe({
        next: (result: string) => {
          this.scanMode = result;
          if (
            this.scanFieldPlaceholder === 'Scan Pallet' &&
            result !== 'off_pallet'
          ) {
            this.message.error(
              this.layoutService.translate(
                `We couldn't find any result for the scanned value ${value}. `,
              ),
              { nzDuration: 5000 },
            );
            this.playErrorVoice();
            this.resetScanFields(
              scanStep.quantityControl,
              scanStep.scanControl,
            );
            scanStep.status = 'E';
            this.moveToNextScan();
            return;
          }
          let scan$: Observable<any>;
          try {
            switch (result) {
              case 'Item':
                scan$ = this.executeScanOfItem(
                  value,
                  scanStep.scanControl,
                  scanStep.quantityControl,
                  scanStep.serialNumberControl,
                );
                break;
              case 'Serial':
                scan$ = this.executeScanOfSerial(value, scanStep.scanControl);
                break;
              case 'Batch':
                scan$ = this.executeScanOfBatch(
                  value,
                  scanStep.scanControl,
                  scanStep.quantityControl,
                );
                break;
              case 'Barcode':
                scan$ = this.executeScanOfBarCode(
                  value,
                  scanStep.scanControl,
                  scanStep.quantityControl,
                  scanStep.serialNumberControl,
                );
                break;
              case 'SSCC':
                scan$ = this.executeScanOfSSCC(
                  value,
                  scanStep.scanControl,
                  scanStep.quantityControl,
                  scanStep.serialNumberControl,
                );
                break;
              case 'Bin':
                scan$ = this.executeScanOfBin(
                  value,
                  scanStep.scanControl,
                  scanStep.quantityControl,
                );
                break;
              case 'Box':
              case 'NewBox':
                scan$ = this.executeScanOfBox(
                  value,
                  scanStep.scanControl,
                  scanStep.quantityControl,
                  result === 'NewBox',
                );
                break;
              case 'Pallet':
                scan$ = this.executeScanOfPallet(
                  value,
                  scanStep.scanControl,
                  scanStep.quantityControl,
                  true,
                );
                break;
              case 'QR':
                scan$ = this.executeScanOfQR(
                  scanStep.value,
                  scanStep.scanControl,
                  scanStep.quantityControl,
                );
                break;
              case 'off_pallet':
                scan$ = this.executeScanOffLoadPallet(
                  //value,
                  scanStep.scanControl,
                  scanStep.quantityControl,
                );
                break;
              default:
                this.message.error(
                  this.layoutService.translate(
                    `We couldn't find any result for the scanned value ${value}. `,
                  ),
                  { nzDuration: 5000 },
                );

                // modal for error
                /*this.modal.error({
                  nzTitle: this.layoutService.translate(
                    `We couldn't find any result for the scanned value ${value}. `,
                  ),
                  nzContent: '',
                  nzCancelText: null,
                });*/
                /*alert(
                  this.layoutService.translate(
                    `We couldn't find any result for the scanned value ${value}. `,
                  ),
                );*/

                (document.activeElement as HTMLElement)?.blur();
                this.isModalOpen = true;
                this.modal.error({
                  nzTitle: this.layoutService.translate(
                    `We couldn't find any result for the scanned value ${value}. `,
                  ),
                  nzContent: '',
                  nzCancelText: null,
                  nzMaskClosable: false,
                  nzKeyboard: false,
                  nzClosable: false,
                  nzOkText: 'OK',
                  nzAutofocus: 'ok',
                  nzOnOk: () => {
                    this.isModalOpen = false;
                    setTimeout(() => {
                      this.scanBatchControl?.nativeElement.focus();
                    },500);
                  },
                });

                this.playErrorVoice();
                this.resetScanFields(
                  scanStep.quantityControl,
                  scanStep.scanControl,
                );
                scanStep.status = 'E';
                this.moveToNextScan();
                return;
            }

            if (scan$) {
              scan$.subscribe({
                next: () => {
                  scanStep.status = 'S';
                  console.log('here');
                  setTimeout(() => {
                    this.updatePaginatedLines();
                  }, 2000);
                },
                error: () => {
                  scanStep.status = 'E';
                  this.moveToNextScan();
                },
                complete: () => {
                  this.moveToNextScan();
                },
              });
            } else {
              // If scan$ is undefined or null
              scanStep.status = 'E';
              this.isProcessingScan = false;
            }
          } catch (switchErr) {
            console.error('Error in scan step execution logic:', switchErr);
            scanStep.status = 'E';
            this.isProcessingScan = false;
          }
        },
        error: () => {
          scanStep.status = 'E';
          this.message.error('Scan type detection failed', {
            nzDuration: 5000,
          });
          this.moveToNextScan();
        },
      });
  }

  moveToNextScan() {
    this.currentScanIndex++;

    if (this.currentScanIndex < this.scansToApply.length) {
      this.executeNextScanStep();
    } else {
      this.isProcessingScan = false;
    }
  }

  executeScan(
    scanControl,
    quantityControl,
    serialNumberControl,
    key = undefined,
  ) {
    if (key !== undefined && key.keyCode !== 13) {
      return;
    }

    if (scanControl.value !== '' && !this.isReverse) {
      this.scansToApply.push({
        value: scanControl.value,
        scanControl,
        quantityControl,
        serialNumberControl,
        status: 'P',
      });
      if (this.autoIncrease) {
        this.resetScanFields(quantityControl, scanControl);
      }

      // Only start if not already running
      if (!this.isProcessingScan) {
        this.executeNextScanStep();
      }
    } else if (scanControl.value !== '' && this.isReverse) {
      this.executeReverseScan(quantityControl, scanControl);
    }

    /* scanControl.disabled = this.autoIncrease;
    if (scanControl.value !== '' && !this.isReverse) {
      scanControl.disabled = true;
      this.inventoryService
        .getScannedValueType(scanControl.value)
        .subscribe((result: string) => {
          this.scanMode = result;
          switch (result) {
            case 'Item':
              this.executeScanOfItem(
                scanControl,
                quantityControl,
                serialNumberControl
              );
              break;
            case 'Serial':
              if (this.recordModel.ObjectKey === 'oInventoryGenEntry') {
                this.message.error(
                  this.layoutService.translate(
                    `We couldn't find any result for the scanned value ${value}. `
                  )
                );
                this.playErrorVoice();
                this.resetScanFields(quantityControl, scanControl);
                return;
              }
              this.executeScanOfSerial(scanControl);
              break;
            case 'Batch':
              if (this.recordModel.ObjectKey === 'oInventoryGenEntry') {
                this.message.error(
                  this.layoutService.translate(
                    `We couldn't find any result for the scanned value ${value}. `
                  )
                );
                this.playErrorVoice();
                this.resetScanFields(quantityControl, scanControl);
                return;
              }
              this.executeScanOfBatch(scanControl, quantityControl);
              break;
            case 'SSCC':
              this.executeScanOfSSCC(
                scanControl,
                quantityControl,
                serialNumberControl
              );
              break;
            case 'Barcode':
              this.executeScanOfBarCode(
                scanControl,
                quantityControl,
                serialNumberControl
              );
              break;
            case 'Bin':
              this.executeScanOfBin(scanControl, quantityControl);
              break;
            case 'Box':
              this.executeScanOfBox(scanControl, quantityControl);
              break;
            case 'NewBox':
              this.executeScanOfBox(scanControl, quantityControl, true);
              break;
            case 'Pallet':
              this.executeScanOfPallet(scanControl, quantityControl, true);
              break;
            default:
              this.message.error(
                this.layoutService.translate(
                  `We couldn't find any result for the scanned value ${value}. `
                )
              );
              this.playErrorVoice();
              this.resetScanFields(quantityControl, scanControl);
              break;
          }
        });
    } else if (scanControl.value !== '' && this.isReverse) {
      this.executeReverseScan(quantityControl, scanControl);
    } */
  }

  playErrorVoice() {
    let audio = new Audio('assets/audio_file.mp3');
    audio.load();
    audio.play();
  }

  executeReverseScan(quantityControl, scanControl) {
    for (let i = 0; i < this.lines.length; i++) {
      const properties = this.lines[i].Properties;
      const itemProp = properties.find((p) => p.Name === 'ItemCode');

      if (
        itemProp != null &&
        itemProp !== undefined &&
        scanControl.value === itemProp.ValueAsObject
      ) {
        this.rowToWorkWith = this.lines[i];
        break;
      }
    }

    if (this.rowToWorkWith == null || this.rowToWorkWith === undefined) {
      let found = false;
      for (let i = 0; i < this.lines.length; i++) {
        if (found) {
          break;
        }
        const properties = this.lines[i].Properties;
        const itemProp = properties.find((p) => p.Name === 'ItemCode');

        let numPerSale = 1;
        if (
          properties.find(
            (p) => p.Name === 'UnitsOfMeasurment' || p.Name === 'NumInCnt',
          ) === undefined
        ) {
          numPerSale = 1;
        } else {
          numPerSale = properties.find(
            (p) => p.Name === 'UnitsOfMeasurment' || p.Name === 'NumInCnt',
          ).ValueAsObject as number;
        }

        let itmSerialNumber = properties.find(
          (prop) => prop.Name === 'ITMSerialNumber',
        )?.ValueAsObject as string;

        if (itmSerialNumber == null || itmSerialNumber === undefined) {
          itmSerialNumber = '';
        }
        let valueToSave = itmSerialNumber;

        const batchNumbersTemp = JSON.parse(`[${itmSerialNumber}]`);
        if (batchNumbersTemp.length === 0) {
          continue;
        } else {
          let batchTemp = batchNumbersTemp.findIndex(
            (b) =>
              (this.moduleStructure.module.ObjectType !== 'oReturns' &&
                (b.BatchNumber === scanControl.value ||
                  b.MnfSerial === scanControl.value)) ||
              (this.moduleStructure.module.ObjectType === 'oReturns' &&
                b.BatchNumber !== '-' &&
                b.BatchNumber === scanControl.value) ||
              (b.BatchNumber === '-' && b.MnfSerial === scanControl.value),
          );

          if (batchTemp != -1) {
            found = true;

            const foundedBatch = batchNumbersTemp.find(
              (b) =>
                (this.moduleStructure.module.ObjectType !== 'oReturns' &&
                  b.BatchNumber === scanControl.value) ||
                (this.moduleStructure.module.ObjectType === 'oReturns' &&
                  b.BatchNumber !== '-' &&
                  b.BatchNumber === scanControl.value) ||
                (b.BatchNumber === '-' && b.MnfSerial === scanControl.value),
            );

            this.modal.confirm({
              nzTitle: this.layoutService
                .translate(
                  'You are deleting batch:_BATCH_ for item:_ITEM_CODE_, do you want to continue?',
                )
                .replace('_ITEM_CODE_', itemProp.ValueAsObject)
                .replace('_BATCH_', scanControl.value),
              nzContent: '',
              nzOnOk: () => {
                if (this.recordModel.ObjectKey === 'InventoryCounting') {
                  foundedBatch.Quantity = 0;
                } else {
                  batchNumbersTemp.splice(batchTemp, 1);
                }

                const jsonToSave = JSON.stringify(batchNumbersTemp);
                valueToSave = jsonToSave.substring(1, jsonToSave.length - 1);

                const itmSerialNumberTemp = JSON.parse(`[${valueToSave}]`);

                let tempQty = 0;
                itmSerialNumberTemp.forEach((bn) => {
                  tempQty += Number(bn.Quantity / numPerSale);
                });

                if (this.recordModel.ObjectKey === 'InventoryCounting') {
                  properties.find(
                    (p) => p.Name === 'UoMCountedQuantity',
                  ).ValueAsObject = tempQty;
                } else {
                  properties.find(
                    (p) => p.Name === this.quantityFieldPropertyName,
                  ).ValueAsObject = tempQty;
                }

                properties.find(
                  (prop) => prop.Name === 'ITMSerialNumber',
                ).ValueAsObject = valueToSave;

                if (tempQty === 0) {
                  if (this.recordModel.ObjectKey !== 'InventoryCounting') {
                    this.modal.confirm({
                      nzTitle: this.layoutService
                        .translate(
                          'You arrived zero quantity for item:_ITEM_CODE_, do you want to delete it?',
                        )
                        .replace('_ITEM_CODE_', itemProp.ValueAsObject),
                      nzContent: '',
                      nzOnOk: () => {
                        this.rowToWorkWith = this.lines[i];
                        this.deleteItemWhenReverseScan(
                          quantityControl,
                          scanControl,
                        );
                      },
                      nzOnCancel: () => {
                        this.resetScanFields(quantityControl, scanControl);
                      },
                    });
                  } else {
                    this.lines[i].Properties.find(
                      (p) => p.Name === 'Counted',
                    ).Value = 'N';
                    this.lines[i].Properties.find(
                      (p) => p.Name === 'Counted',
                    ).ValueAsObject = 'N';
                    this.resetScanFields(quantityControl, scanControl);
                  }
                } else {
                  this.resetScanFields(quantityControl, scanControl);
                }
              },
              nzOnCancel: () => {
                this.resetScanFields(quantityControl, scanControl);
              },
            });
          } else {
            continue;
          }
        }
      }
      if (!found) {
        this.message.error(
          this.layoutService.translate(
            `We couldn't find any result for the scanned value ${scanControl.value}. `,
          ),
          { nzDuration: 5000 },
        );

        this.playErrorVoice();
        this.resetScanFields(undefined, scanControl);
      }
    } else {
      //item found
      if (
        this.global.inCountingDeleteNormalItemAllowChooseQty &&
        this.recordModel.ObjectKey === 'InventoryCounting'
      ) {
        const comp = this;
        setTimeout(function () {
          comp.focusAfterScanReverse(quantityControl);
        }, 1000);
      } else {
        this.modal.confirm({
          nzTitle: this.layoutService
            .translate(
              'You are deleting item:_ITEM_CODE_, do you want to continue?',
            )
            .replace('_ITEM_CODE_', scanControl.value),
          nzContent: '',
          nzOnOk: () => {
            if (this.recordModel.ObjectKey !== 'InventoryCounting') {
              this.deleteItemWhenReverseScan(quantityControl, scanControl);
            } else {
              this.rowToWorkWith.Properties.find(
                (p) => p.Name === 'UoMCountedQuantity',
              ).ValueAsObject = 0;

              this.rowToWorkWith.Properties.find(
                (p) => p.Name === 'Counted',
              ).Value = 'N';
              this.rowToWorkWith.Properties.find(
                (p) => p.Name === 'Counted',
              ).ValueAsObject = 'N';
              this.resetScanFields(quantityControl, scanControl);
            }
          },
          nzOnCancel: () => {
            this.resetScanFields(quantityControl, scanControl);
          },
        });
      }
    }
  }

  executeScanOfItem(
    value,
    scanControl: FormControl,
    quantityControl: FormControl,
    serialNumberControl: FormControl,
    scannedBarcode?: string,
  ): Observable<any> {
    return new Observable((observer) => {
      console.log('scan item');

      if (this.recordModel.ObjectKey === 'ITM_WMS_NON_PRDUCD') {
        // If it's a non-produced item, wrap and call existing logic
        this.executeScanOfNonProducedItem(value, scanControl, quantityControl);
        observer.next('Non-produced item scanned');
        observer.complete();
        return;
      }

      this.inventoryService.getItemNumberDetailsAfterScan(value).subscribe({
        next: (d) => {
          this.rowToWorkWith = null;

          const itemCode = d[0]['ItemCode'];
          const managedBySerial = d[0]['ManSerNum'];
          const managedByBatch = d[0]['ManBtchNum'];

          const executeAndComplete = () => {
            this.doExecuteScanOfItem(
              value,
              itemCode,
              scanControl,
              quantityControl,
              managedBySerial,
              managedByBatch,
              scannedBarcode,
            );
            observer.next({ itemCode }); // You can pass richer data if needed
            observer.complete();
          };

          if (
            managedByBatch === 'N' &&
            managedBySerial === 'N' &&
            this.showConfirmationForNormalItem()
          ) {
            this.modal.confirm({
              nzTitle: this.layoutService
                .translate(
                  'you scanned item:_ITEM_CODE_, do you want to continue?',
                )
                .replace('_ITEM_CODE_', value),
              nzContent: '',
              nzOnOk: () => {
                executeAndComplete();
              },
              nzOnCancel: () => {
                this.resetScanFields(quantityControl, scanControl);
                observer.error('Scan cancelled by user');
              },
            });
          } else {
            executeAndComplete();
          }
        },
        error: (err) => {
          this.message.error('Failed to get item details', {
            nzDuration: 5000,
          });
          this.playErrorVoice();
          this.resetScanFields(quantityControl, scanControl);
          observer.error(err);
        },
      });
    });
  }

  // executeScanOfPallet(scanControl, quantityControl, newBox = false) {
  //   console.log('scan pallet');
  //   if (this.recordModel.ObjectKey !== 'ITM_WMS_DEL_PLT') {
  //     this.message.error(
  //       this.layoutService.translate(
  //         `We couldn't find any result for the scanned value ${value}. `
  //       )
  //     );
  //     this.playErrorVoice();
  //     this.resetScanFields(undefined, scanControl);

  //     return;
  //   }

  //   this.inventoryService
  //     .getPalletDetailsAfterScan(scanControl.value)
  //     .subscribe((d: any[]) => {
  //       this.rowToWorkWith = null;

  //       if (d.length == 0) {
  //         this.message.error(
  //           this.layoutService.translate(
  //             `We couldn't find any result for the scanned value, or the pallet is not available`
  //           )
  //         );
  //         this.playErrorVoice();
  //         this.resetScanFields(undefined, scanControl);
  //         return;
  //       }

  //       const headerLine = this.recordModel.Categories.find(
  //         (cat) => cat.Id === 'ITM_WMS_DEL_PLT'
  //       ).Lines[0];

  //       const headerCanton = headerLine.Properties.find(
  //         (p) => p.Name === 'SSCC_CITY'
  //       ).ValueAsObject;

  //       const palletSSCC = d[0].U_PLT_SSCC;
  //       const palletStatus = d[0].U_PLT_STATUS;
  //       const palletCanton = d[0].U_SSCC_CITY;
  //       const boxCount = d[0].BoxCount;

  //       if (headerCanton !== palletCanton) {
  //         this.message.error(
  //           this.layoutService.translate(
  //             `The scanned pallet is generated for another canton`
  //           )
  //         );
  //         this.playErrorVoice();
  //         this.resetScanFields(undefined, scanControl);
  //         return;
  //       }

  //       if (palletStatus === 'D' || boxCount === 0) {
  //         this.message.error(
  //           this.layoutService.translate(
  //             `The scanned pallet is already delivered`
  //           )
  //         );
  //         this.playErrorVoice();
  //         this.resetScanFields(undefined, scanControl);
  //         return;
  //       }

  //       this.rowToWorkWith = null;

  //       for (let i = 0; i < this.lines.length; i++) {
  //         const properties = this.lines[i].Properties;
  //         const palletProp = properties.find((p) => p.Name === 'PLT_SSCC');

  //         if (
  //           palletProp != null &&
  //           palletProp !== undefined &&
  //           palletSSCC === palletProp.ValueAsObject
  //         ) {
  //           this.rowToWorkWith = this.lines[i];
  //           this.message.error(
  //             this.layoutService.translate(
  //               `You already scan the pallet with SSCC`
  //             ) +
  //               ' ' +
  //               palletSSCC
  //           );
  //           this.playErrorVoice();
  //           this.resetScanFields(undefined, scanControl);
  //           return;
  //         }
  //       }

  //       this.isNew = false;
  //       this.addLineToTable();

  //       const palletCodeEle = this.lines[this.lines.length - 1].Properties.find(
  //         (p) => p.Name === 'PLT_SSCC'
  //       );

  //       palletCodeEle.ValueAsObject = palletSSCC;

  //       this.layoutService.triggerFieldValueChanged({
  //         recordProperty: palletCodeEle,
  //         formId: '',
  //         line: this.lines[this.lines.length - 1].Id,
  //         recordModel: this.recordModel,
  //         sectionTagName: this.section.XmlTagName,
  //         moduleStructure: this.moduleStructure,
  //       });

  //       this.rowToWorkWith = this.lines[this.lines.length - 1];
  //       this.isNew = true;

  //       this.rowToWorkWith['isNew'] = true;

  //       this.rowToWorkWith['ManBtchNum'] = 'N';
  //       this.rowToWorkWith['ManSerNum'] = 'N';

  //       if (this.rowToWorkWith['ScannedQty'] === undefined) {
  //         this.rowToWorkWith['ScannedQty'] = 0;
  //       }

  //       const boxCounteEle = this.lines[this.lines.length - 1].Properties.find(
  //         (p) => p.Name === 'BOXES_COUNT'
  //       );
  //       boxCounteEle.ValueAsObject = boxCount;
  //       this.layoutService.triggerFieldValueChanged({
  //         recordProperty: boxCounteEle,
  //         formId: '',
  //         line: this.lines[this.lines.length - 1].Id,
  //         recordModel: this.recordModel,
  //         sectionTagName: this.section.XmlTagName,
  //         moduleStructure: this.moduleStructure,
  //       });

  //       const headerTotalPalletsProp = headerLine.Properties.find(
  //         (p) => p.Name === 'PLT_TO_DELIVER'
  //       );
  //       const headerScannedPalletsProp = headerLine.Properties.find(
  //         (p) => p.Name === 'SCANNED_PLT'
  //       );

  //       headerTotalPalletsProp.ValueAsObject =
  //         Number(headerTotalPalletsProp.ValueAsObject) - 1;

  //       headerScannedPalletsProp.ValueAsObject =
  //         Number(headerScannedPalletsProp.ValueAsObject) + 1;

  //       this.resetScanFields(quantityControl, scanControl);
  //     });
  // }

  executeScanOfPallet(
    value,
    scanControl: FormControl,
    quantityControl: FormControl,
    newBox = false,
  ): Observable<any> {
    return new Observable((observer) => {
      if (this.recordModel.ObjectKey !== 'ITM_WMS_DEL_PLT') {
        this.message.error(
          this.layoutService.translate(
            `We couldn't find any result for the scanned value ${value}. `,
          ),
          { nzDuration: 5000 },
        );

        this.playErrorVoice();
        this.resetScanFields(undefined, scanControl);
        observer.error('Invalid object key for pallet scan');
        return;
      }

      this.inventoryService
        .getPalletDetailsAfterScan(value)
        //.getPalletDetailsAfterScan(scanControl.value)
        .subscribe({
          next: (d: any[]) => {
            if (d.length === 0) {
              this.message.error(
                this.layoutService.translate(
                  `We couldn't find any result for the scanned value, or the pallet is not available`,
                ),
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Pallet not found');
              return;
            }

            const headerLine = this.recordModel.Categories.find(
              (cat) => cat.Id === 'ITM_WMS_DEL_PLT',
            ).Lines[0];
            const headerCanton = headerLine.Properties.find(
              (p) => p.Name === 'SSCC_CITY',
            ).ValueAsObject;

            const palletSSCC = d[0].U_PLT_SSCC;
            const palletStatus = d[0].U_PLT_STATUS;
            const palletCanton = d[0].U_SSCC_CITY;
            const boxCount = d[0].BoxCount;

            if (headerCanton !== palletCanton) {
              this.message.error(
                this.layoutService.translate(
                  `The scanned pallet is generated for another canton`,
                ),
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Canton mismatch');
              return;
            }

            if (palletStatus === 'D' || boxCount === 0) {
              this.message.error(
                this.layoutService.translate(
                  `The scanned pallet is already delivered`,
                ),
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Pallet delivered or empty');
              return;
            }

            const duplicate = this.lines.find(
              (line) =>
                line.Properties.find((p) => p.Name === 'PLT_SSCC')
                  ?.ValueAsObject === palletSSCC,
            );

            if (duplicate) {
              this.message.error(
                this.layoutService.translate(
                  `You already scan the pallet with SSCC`,
                ) +
                  ' ' +
                  palletSSCC,
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Duplicate pallet');
              return;
            }

            this.isNew = false;
            this.addLineToTable();

            const newLine = this.lines[this.lines.length - 1];
            const palletCodeEle = newLine.Properties.find(
              (p) => p.Name === 'PLT_SSCC',
            );
            palletCodeEle.ValueAsObject = palletSSCC;

            this.layoutService.triggerFieldValueChanged({
              recordProperty: palletCodeEle,
              formId: '',
              line: newLine.Id,
              recordModel: this.recordModel,
              sectionTagName: this.section.XmlTagName,
              moduleStructure: this.moduleStructure,
            });

            this.rowToWorkWith = newLine;
            this.isNew = true;
            newLine['isNew'] = true;
            newLine['ManBtchNum'] = 'N';
            newLine['ManSerNum'] = 'N';

            if (newLine['ScannedQty'] === undefined) {
              newLine['ScannedQty'] = 0;
            }

            const boxCounteEle = newLine.Properties.find(
              (p) => p.Name === 'BOXES_COUNT',
            );
            boxCounteEle.ValueAsObject = boxCount;

            this.layoutService.triggerFieldValueChanged({
              recordProperty: boxCounteEle,
              formId: '',
              line: newLine.Id,
              recordModel: this.recordModel,
              sectionTagName: this.section.XmlTagName,
              moduleStructure: this.moduleStructure,
            });

            const headerTotalPalletsProp = headerLine.Properties.find(
              (p) => p.Name === 'PLT_TO_DELIVER',
            );
            const headerScannedPalletsProp = headerLine.Properties.find(
              (p) => p.Name === 'SCANNED_PLT',
            );

            headerTotalPalletsProp.ValueAsObject =
              Number(headerTotalPalletsProp.ValueAsObject) - 1;
            headerScannedPalletsProp.ValueAsObject =
              Number(headerScannedPalletsProp.ValueAsObject) + 1;

            this.resetScanFields(quantityControl, scanControl);
            observer.next({ palletSSCC });
            observer.complete();
          },
          error: (err) => {
            this.message.error('Error scanning pallet', { nzDuration: 5000 });
            this.playErrorVoice();
            observer.error(err);
          },
        });
    });
  }

  executeScanOffLoadPallet(
    //value,
    scanControl: FormControl,
    quantityControl: FormControl,
  ): Observable<any> {
    return new Observable((observer) => {
      if (this.recordModel.ObjectKey !== 'ITM_OFF_LOAD_DEF') {
        this.message.error(
          this.layoutService.translate(
            `We couldn't find any result for the scanned value ${scanControl.value}. `,
          ),
          { nzDuration: 5000 },
        );

        this.playErrorVoice();
        this.resetScanFields(undefined, scanControl);
        observer.error('Invalid object key for pallet scan');
        return;
      }

      this.offLoadingPallet = scanControl.value;
      this.offLoadingItemScanFieldVisible = true;
      setTimeout(() => {
        const quantityToWorkWith = this.lines[
          this.lines.length - 1
        ]?.Properties?.find((p) => p.Name === 'U_QTY');
        console.log('quantityToWorkWith', quantityToWorkWith);
        console.log(
          'quantityToWorkWith?.DialogVisible',
          quantityToWorkWith?.DialogVisible,
        );
        if (
          quantityToWorkWith == null ||
          quantityToWorkWith === undefined ||
          quantityToWorkWith?.DialogVisible == null ||
          quantityToWorkWith?.DialogVisible === undefined ||
          !quantityToWorkWith?.DialogVisible
        ) {
          this.scanOffLoadingItemControl.nativeElement.focus();
        }
        observer.complete();
      }, 1000);
    });
  }

  executeScanOffLoadingItem(scanControl) {
    let scanValue = scanControl.value;
    this.inventoryService
      .getItemNumberDetailsAfterScan(scanValue, /*100087*/ 100012)
      .subscribe({
        next: (itemDetails) => {
          if (itemDetails.length === 0) {
            this.playErrorVoice();
            this.modal.confirm({
              nzTitle: this.layoutService.translate(
                `We couldn't find any result for the scanned value, do you want to add a new item review`,
              ),
              nzContent: '',
              nzOnOk: () => {
                RecordPageComponent.openRecordPage(this.drawerService, {
                  drawerTitle: this.layoutService.translate(
                    'Create a new inbound review',
                  ),
                  moduleId: /*100021*/ 100003,
                  inDrawer: true,
                  recordId: '',
                  recordModel: undefined,
                  actionType: 'Add',
                  parentComponent: this,
                });
              },
              nzOnCancel: () => {
                this.resetScanFields(undefined, scanControl);
                this.isProcessingScan = false;
                this.offLoadingPallet = '';
                this.ScanNewOffLoadingPallet();
              },
            });
          } else {
            const itemCode = itemDetails[0].ItemCode;
            scanControl.value = itemCode;
            const managedByBatch = itemDetails[0].ManBtchNum;
            const managedBySerial = itemDetails[0].ManSerNum;
            //this.addLineToTable();
            /*const itemCodeEle = this.lines[
              this.lines.length - 1
            ].Properties.find((p) => p.Name === 'ItemCode');*/

            this.layoutService
              .executeQuery(/*100086*/ 100011, {
                ItemCode: itemCode,
              })
              .subscribe((result: any) => {
                console.log('batch scanned result', result);
                this.offLoadingUOMOptions = result;
                this.offLoadingUOMScanFieldVisible = true;
                this.offLoadingManageByBatch = managedByBatch === 'Y';
                this.offLoadingManageBySerial = managedBySerial === 'Y';
                setTimeout(() => {
                  this.scanOffLoadingUOMControl.focus();
                }, 1000);
              });
          }
        },
      });
  }

  linkedObjectSubmitted($event, args) {
    console.log('linkedObjectSubmitted', $event, args);
    this.isNewItemScan = true;
    this.newItemReview = $event;
    this.layoutService
      .executeQuery(/*100115*/ 100018, {
        REV_ENTRY: $event,
      })
      .subscribe((result: any) => {
        console.log('batch scanned result', result);
        this.offLoadingManageByBatch = result[0].U_ManagedBy === 'B';
        this.offLoadingManageBySerial = result[0].U_ManagedBy === 'S';
        this.executeScanOffLoadingUOMChange(
          this.scanControl,
          this.offloadQuantityControl,
        );
      });
    /* this.executeScanOffLoadingUOMChange(
      this.scanControl,
      this.offloadQuantityControl,
    );*/
  }

  executeScanOffLoadingUOMChange(scanControl, offloadQuantityControl) {
    this.offLoadingQtyScanFieldVisible = true;
    setTimeout(() => {
      offloadQuantityControl.focus();
      if (this.offLoadingManageByBatch || this.offLoadingManageBySerial) {
        offloadQuantityControl.value = '1';
        this.offloadQuantityScanned(
          this.scanOffLoadingItemControl.nativeElement.value,
          scanControl,
          this.offloadQuantityControl,
          undefined,
          true,
        );
      }
    }, 1000);
  }

  executeScanOffLoadingUOM(
    scanControl,
    offloadQuantityControl,
    key = undefined,
  ) {
    if (key !== undefined && key.keyCode !== 13) {
      return;
    }

    this.offLoadingQtyScanFieldVisible = true;
    setTimeout(() => {
      offloadQuantityControl.focus();
      if (this.offLoadingManageByBatch || this.offLoadingManageBySerial) {
        offloadQuantityControl.value = '1';
        this.offloadQuantityScanned(
          this.scanOffLoadingItemControl.nativeElement.value,
          scanControl,
          this.offloadQuantityControl,
          undefined,
          true,
        );
      }
    }, 1000);
  }

  offloadQuantityScanned(
    itemCode,
    scanControl,
    quantityControl,
    key = undefined,
    fromAuto = false,
  ) {
    if (!fromAuto && key !== undefined && key.keyCode !== 13) {
      return;
    }

    this.addLineToTable();
    const itemCodeEle = this.lines[this.lines.length - 1].Properties.find(
      (p) => p.Name === 'U_ITEM_CODE',
    );
    const qtyEle = this.lines[this.lines.length - 1].Properties.find(
      (p) => p.Name === 'U_QTY',
    );
    qtyEle.ValueAsObject = quantityControl.value;
    qtyEle.Value = quantityControl.value;

    this.layoutService.triggerFieldValueChanged({
      recordProperty: qtyEle,
      formId: '',
      line: this.lines[this.lines.length - 1].Id,
      recordModel: this.recordModel,
      sectionTagName: 'ITM_OFF_LOAD_LINE',
      moduleStructure: this.moduleStructure,
    });

    const palletEle = this.lines[this.lines.length - 1].Properties.find(
      (p) => p.Name === 'U_PLT_NUMBER',
    );
    palletEle.ValueAsObject = this.offLoadingPallet;
    palletEle.Value = this.offLoadingPallet;

    const uomEle = this.lines[this.lines.length - 1].Properties.find(
      (p) => p.Name === 'U_UOM_ENTRY',
    );
    uomEle.ValueAsObject = this.offLoadingUOM;
    uomEle.Value = this.offLoadingUOM;

    if (this.isNewItemScan) {
      const itemCodeEle = this.lines[this.lines.length - 1].Properties.find(
        (p) => p.Name === 'U_ITEM_CODE',
      );
      itemCodeEle.ValueAsObject = itemCode;
      itemCodeEle.Value = itemCode;

      const barCodeEle = this.lines[this.lines.length - 1].Properties.find(
        (p) => p.Name === 'U_ITEM_BARCODE',
      );
      barCodeEle.ValueAsObject = itemCode;
      barCodeEle.Value = itemCode;

      const nItemReviewEle = this.lines[this.lines.length - 1].Properties.find(
        (p) => p.Name === 'U_ITEM_REVIEW_ENTRY',
      );
      nItemReviewEle.ValueAsObject = this.newItemReview;
      nItemReviewEle.Value = this.newItemReview;

      this.resetScanFields(quantityControl, scanControl);
      this.isProcessingScan = false;
      this.isNewItemScan = false;
      this.newItemReview = '';
      this.offLoadingPallet = '';
      this.ScanNewOffLoadingPallet();
    } else {
      this.layoutService
        .getModuleHeaderData(4, itemCode, '', false)
        .subscribe((d) => {
          this.moduleStructure.module.Sections.forEach((section) => {
            section.Fields.forEach((field) => {
              if (field.LinkedModule === '4') {
                const value = d[field.LinkedField];

                this.lines[this.lines.length - 1].Properties.forEach(
                  (property) => {
                    if (property.Name === field.PropertyName) {
                      property.ValueAsObject = value;
                      this.layoutService.triggerFieldValueChanged({
                        recordProperty: property,
                        formId: '',
                        line: this.lines[this.lines.length - 1].Id,
                        recordModel: this.recordModel,
                        sectionTagName: section.XmlTagName,
                        moduleStructure: this.moduleStructure,
                      });
                    }
                  },
                );
              }
            });
          });
          this.rowToWorkWith = this.lines[this.lines.length - 1];
          this.isNew = true;

          this.rowToWorkWith['isNew'] = true;

          this.resetScanFields(quantityControl, scanControl);
          this.isProcessingScan = false;
          this.isNewItemScan = false;
          this.newItemReview = '';
          this.offLoadingPallet = '';
          this.ScanNewOffLoadingPallet();
          return;
        });

      this.rowToWorkWith = this.lines[this.lines.length - 1];
      this.isNew = true;
      this.isProcessingScan = false;
      this.isNewItemScan = false;
      this.newItemReview = '';
    }

    if (this.offLoadingManageByBatch || this.offLoadingManageBySerial) {
      this.makeBatchDetailDrawerVisible(qtyEle);
      this.offLoadingManageByBatch = false;
      this.offLoadingManageBySerial = false;
    }
  }

  offloadQuantityScannedBlur(
    scanControl,
    scanOffLoadingItemControl,
    quantityControl,
  ) {
    if (
      quantityControl.value == null ||
      quantityControl.value === undefined ||
      quantityControl.value === ''
    )
      return;
    this.offloadQuantityScanned(
      scanOffLoadingItemControl.value,
      scanControl,
      quantityControl,
    );
  }

  executeScanOfQR(
    scanValue: string,
    scanControl: AbstractControl,
    quantityControl: AbstractControl,
  ): Observable<any> {
    const isCountingOrReturns =
      this.moduleStructure.module.ObjectType === 'InventoryCounting';

    const dataPart = scanValue.toString().split(';');
    const itemCodeQR = dataPart[0];
    const batchNumberQR = dataPart[1];
    const quantityQR = dataPart[2];

    return new Observable((observer) => {
      if (
        this.moduleStructure.module.ObjectType === 'InventoryCounting' ||
        this.moduleStructure.module.AdditionalInformationParsed
          .InventoryDirection === this.InventoryDirection.Outbound
      ) {
        this.inventoryService
          .getBatchNumberDetailsAfterScan(batchNumberQR, isCountingOrReturns)
          .subscribe({
            next: (d: any[]) => {
              this.rowToWorkWith = null;

              let itemCode = '';
              let batchNumber = '';
              this.batchNumberAvaQty = 0;
              let batchWarehouse = '';
              let found = false;
              for (let index = 0; index < d.length; index++) {
                if (d[index]['ItemCode'] !== itemCodeQR) {
                  continue;
                }
                itemCode = d[index]['ItemCode'];
                batchNumber = d[index].BatchNum ?? d[index].DistNumber;
                this.batchNumberAvaQty = d[index].AvaQuantity;
                batchWarehouse = d[index].WhsCode;

                for (let i = 0; i < this.lines.length; i++) {
                  const properties = this.lines[i].Properties;
                  const itemProp = properties.find(
                    (p) => p.Name === 'ItemCode',
                  );
                  const warehouse = properties.find(
                    (p) =>
                      p.Name === 'FromWarehouse' || p.Name === 'WarehouseCode',
                  );

                  if (
                    itemProp?.ValueAsObject === itemCode &&
                    warehouse?.ValueAsObject === batchWarehouse
                  ) {
                    if (
                      this.recordModel.ObjectKey !== 'InventoryCounting' &&
                      this.recordModel.ObjectKey !== 'oInventoryTransferRequest'
                    ) {
                      const quantityProp = properties.find(
                        (p) =>
                          p.Name === 'Quantity' || p.Name === 'PickedQuantity',
                      )?.ValueAsObject;
                      const openQtyProp = properties.find(
                        (p) =>
                          p.Name === 'OpenQty' || p.Name === 'ReleasedQuantity',
                      );
                      if (quantityProp === openQtyProp?.ValueAsObject) {
                        continue;
                      }
                    }
                    this.rowToWorkWith = this.lines[i];
                    found = true;
                    break;
                  }
                }

                if (found) break;
              }

              if (found && itemCode !== itemCodeQR) {
                this.message.error(
                  this.layoutService.translate(
                    "Can't find a product related to the scanned barcode.xx",
                  ),
                  { nzDuration: 5000 },
                );
                this.playErrorVoice();
                observer.error('No matching product found.');
                return;
              }
              // Secondary fallback if no match on warehouse
              if (!this.rowToWorkWith) {
                this.rowToWorkWith =
                  this.lines.find(
                    (line) =>
                      line.Properties.find((p) => p.Name === 'ItemCode')
                        ?.ValueAsObject === itemCode,
                  ) || null;
              }

              this.isNew = false;

              if (
                !this.rowToWorkWith &&
                this.recordModel.ObjectKey === 'ITM_WMS_SSCC'
              ) {
                this.message.error(
                  this.layoutService.translate(
                    "Can't find a product related to the scanned barcode.",
                  ),
                  { nzDuration: 5000 },
                );
                this.playErrorVoice();
                observer.error('No matching product found.');
                return;
              }

              if (!this.rowToWorkWith) {
                if (!itemCode) {
                  this.message.error(
                    this.layoutService.translate(
                      "We couldn't find any result for the scanned value.",
                    ),
                    { nzDuration: 5000 },
                  );
                  this.playErrorVoice();
                  observer.error('ItemCode not found.');
                  return;
                }

                this.doExecuteScanOfBatchNewForQR(
                  itemCode,
                  batchNumberQR,
                  quantityControl,
                  batchWarehouse,
                  Number(quantityQR),
                );
                observer.next({ itemCode, batchNumberQR, newRow: true });
                observer.complete();
              } else {
                const finalize = () => {
                  this.rowToWorkWith['ManBtchNum'] = 'Y';
                  this.rowToWorkWith['ManSerNum'] = 'N';
                  this.checkBinLocations();
                  this.scannedQty = null;
                  this.batchNumber = d[0].BatchNum;
                  setTimeout(
                    () =>
                      this.focusAfterScanQR(
                        quantityControl,
                        batchNumberQR,
                        Number(quantityQR),
                      ),
                    1000,
                  );
                };

                finalize();
                observer.next({ itemCode, batchNumber, newRow: false });
                observer.complete();
              }
            },
            error: (err) => {
              this.message.error('Error retrieving batch number details', {
                nzDuration: 5000,
              });
              this.playErrorVoice();
              observer.error(err);
            },
          });
      } else if (
        this.moduleStructure.module.AdditionalInformationParsed
          ?.InventoryDirection === this.InventoryDirection.Inbound
      ) {
        let found = false;
        for (let i = 0; i < this.lines.length; i++) {
          const properties = this.lines[i].Properties;
          const itemProp = properties.find((p) => p.Name === 'ItemCode');

          if (itemProp?.ValueAsObject === itemCodeQR) {
            this.rowToWorkWith = this.lines[i];
            found = true;
            break;
          }
        }
        if (!found) {
          this.message.error(
            this.layoutService.translate(
              "Can't find a product related to the scanned barcode.xx",
            ),
            { nzDuration: 5000 },
          );
          this.playErrorVoice();
          observer.error('No matching product found.');
          return;
        }

        let baseLine = this.rowToWorkWith.Properties.find(
          (prop) => prop.Name === 'BaseLine',
        )?.ValueAsObject;
        if (baseLine == null || baseLine === undefined || baseLine === '') {
          baseLine = '-1';
        }
        this.layoutService
          .executeQuery(
            this.moduleStructure.module.ObjectType === 'InventoryCounting' ||
              this.moduleStructure.module.ObjectType === 'oReturns'
              ? 2859
              : 2765,
            {
              Scan: batchNumberQR,
              BaseEntry: this.recordModel.SourceObjectId,
              ObjectType:
                this.moduleStructure.module.ObjectType === 'oReturns'
                  ? g.lookForBatchInBaseForReturn
                    ? this.moduleStructure.module.ObjectType
                    : 'oReturns1'
                  : this.moduleStructure.module.ObjectType,
              BaseLine: baseLine,
            },
          )
          .subscribe((result: any) => {
            console.log('batch scanned result', result);
            let dbBatch = '';
            let expDate = '';
            let mnfSerial = '';
            let inDate = '';

            let newBatch = false;
            if (result.length === 0) {
              newBatch = true;
            } else {
              dbBatch = result[0].DistNumber;
              expDate = result[0].ExpDate;
              mnfSerial = result[0].MnfSerial;
              inDate = result[0].InDate;
            }

            let numPerSale = 1;
            if (
              this.rowToWorkWith.Properties.find(
                (p) => p.Name === 'UnitsOfMeasurment' || p.Name === 'NumInCnt',
              ) === undefined
            ) {
              numPerSale = 1;
            } else {
              numPerSale = this.rowToWorkWith.Properties.find(
                (p) => p.Name === 'UnitsOfMeasurment' || p.Name === 'NumInCnt',
              ).ValueAsObject as number;
            }

            if (numPerSale == null) {
              numPerSale = 1;
            }

            let itmSerialNumber = this.rowToWorkWith.Properties.find(
              (prop) => prop.Name === 'ITMSerialNumber',
            )?.ValueAsObject as string;

            if (itmSerialNumber == null || itmSerialNumber === undefined) {
              itmSerialNumber = '';
            }

            itmSerialNumber =
              itmSerialNumber.charAt(0) === ','
                ? itmSerialNumber.substring(1)
                : itmSerialNumber;

            let itmSerialNumberObj = [];

            if (itmSerialNumber !== '') {
              itmSerialNumberObj = JSON.parse(`[${itmSerialNumber}]`) as any[];
            }

            itmSerialNumberObj.forEach((bn) => {
              bn.Quantity = bn.Quantity / numPerSale;
            });

            if (itmSerialNumberObj.length === 0) {
              itmSerialNumberObj.push({
                Quantity: Number(quantityQR) * numPerSale,
                BatchNumber: batchNumberQR,
                ExpDate: newBatch ? '' : expDate,
                AddmisionDate: newBatch
                  ? moment(new Date()).format(
                      g.companyConfiguration.MomentDateFormat,
                    )
                  : inDate,
                MnfSerial: newBatch ? '' : mnfSerial,
              });
            } else {
              let batchTemp = itmSerialNumberObj.find(
                (b) => b.BatchNumber === batchNumberQR,
              );

              if (batchTemp != null && batchTemp !== undefined) {
                batchTemp.Quantity = batchTemp.Quantity + Number(quantityQR);

                itmSerialNumberObj.forEach((bn) => {
                  bn.Quantity = bn.Quantity * numPerSale;
                });
              } else {
                itmSerialNumberObj.forEach((bn) => {
                  bn.Quantity = bn.Quantity * numPerSale;
                });

                itmSerialNumberObj.push({
                  Quantity: Number(quantityQR) * numPerSale,
                  BatchNumber: batchNumberQR,
                  ExpDate: newBatch ? '' : expDate,
                  AddmisionDate: newBatch
                    ? moment(new Date()).format(
                        g.companyConfiguration.MomentDateFormat,
                      )
                    : inDate,
                  MnfSerial: newBatch ? '' : mnfSerial,
                });
              }
            }

            let tempQty = 0;
            itmSerialNumberObj.forEach((bn) => {
              tempQty += Number(bn.Quantity / numPerSale);
            });

            const jsonToSave = JSON.stringify(itmSerialNumberObj);

            this.setITMSerialBatchNumberValue(
              jsonToSave.substring(1, jsonToSave.length - 1),
            );

            let qtyProp = this.rowToWorkWith.Properties.find(
              (p) => p.Name === this.quantityFieldPropertyName,
            );

            qtyProp.ValueAsObject = tempQty;
            this.resetScanFields(quantityControl, scanControl);
            observer.complete();
          });
      } else {
        this.message.error(
          this.layoutService.translate(
            "Can't find a product related to the scanned barcode.xx",
          ),
          { nzDuration: 5000 },
        );
        this.playErrorVoice();
        observer.error('No matching product found.');
        return;
      }
    });
  }

  executeScanOfNonProducedItem(value, scanControl, quantityControl) {
    const itemCode = value;
    //const itemCode = scanControl.value;
    for (let i = 0; i < this.lines.length; i++) {
      const properties = this.lines[i].Properties;
      const itemCodeProp = properties.find((p) => p.Name === 'U_ITEM_CODE');

      if (
        itemCodeProp != null &&
        itemCodeProp !== undefined &&
        itemCode.toLowerCase() === itemCodeProp.ValueAsObject.toLowerCase()
      ) {
        this.rowToWorkWith = this.lines[i];
        this.message.error(
          this.layoutService
            .translate(`You already scan the item with code _ITEM_CODE_`)
            .replace('_ITEM_CODE_', value),
          { nzDuration: 5000 },
          //.replace('_ITEM_CODE_', scanControl.value)
        );
        this.playErrorVoice();
        this.resetScanFields(undefined, scanControl);
        return;
      }
    }

    this.addLineToTable();

    const itemCodeEle = this.lines[this.lines.length - 1].Properties.find(
      (p) => p.Name === 'U_ITEM_CODE',
    );

    this.layoutService
      .getModuleHeaderData(4, itemCode, '', false)
      .subscribe((d) => {
        this.moduleStructure.module.Sections.forEach((section) => {
          if (section.XmlTagName === 'ITM_WMS_NON_PRDUCD_LINE') {
            section.Fields.forEach((field) => {
              if (field.LinkedModule === '4') {
                const value = d[field.LinkedField];

                this.lines[this.lines.length - 1].Properties.forEach(
                  (property) => {
                    if (property.Name === field.PropertyName) {
                      property.ValueAsObject = value;
                      this.layoutService.triggerFieldValueChanged({
                        recordProperty: property,
                        formId: '',
                        line: this.lines[this.lines.length - 1].Id,
                        recordModel: this.recordModel,
                        sectionTagName: section.XmlTagName,
                        moduleStructure: this.moduleStructure,
                      });
                    }
                  },
                );
              }
            });
          }
        });
        this.rowToWorkWith = this.lines[this.lines.length - 1];
        this.isNew = true;

        if (this.checkDONTDisplayNotificationForNewItemRule()) {
          this.notificationService.create(
            'warning',
            this.layoutService.translate(
              'You are going to add a new item #' + itemCode,
            ),
            '',
          );
        }

        this.rowToWorkWith['isNew'] = true;

        this.resetScanFields(quantityControl, scanControl);
        return;
      });

    this.rowToWorkWith = this.lines[this.lines.length - 1];
    this.isNew = true;

    this.rowToWorkWith['isNew'] = true;

    this.rowToWorkWith['ManBtchNum'] = 'N';
    this.rowToWorkWith['ManSerNum'] = 'N';

    if (this.rowToWorkWith['ScannedQty'] === undefined) {
      this.rowToWorkWith['ScannedQty'] = 0;
    }

    this.resetScanFields(quantityControl, scanControl);
  }

  /*executeScanOfBox(scanControl, quantityControl, newBox = false) {
    console.log('scan box');

    if (
      this.recordModel.ObjectKey === 'ITM_WMS_BOX_DCLR' ||
      this.recordModel.ObjectKey === 'ITM_WMS_BOX_DCLR_1'
    ) {
      this.executeScanBoxForDeclaration(scanControl, quantityControl, newBox);
    } else if (this.recordModel.ObjectKey === 'ITM_WMS_PLT_BOX') {
      this.executeScanBoxForLoadToPallet(scanControl, quantityControl, newBox);
    } else if (this.recordModel.ObjectKey === 'ITM_WMS_PICK_HDR') {
      this.executeScanBoxForPick(scanControl, quantityControl, newBox);
    } else if (this.recordModel.ObjectKey === 'ITM_WMS_BOX_RETURN') {
      this.executeScanBoxForReturn(scanControl, newBox);
    }
  }*/

  appendLineForBox(
    boxCode: string,
    headerLine: any,
    defQtyProp: any,
    quantityControl: FormControl,
    scanControl: FormControl,
    observer: Observer<{ boxCode: string }>,
  ): void {
    // 1. add row
    this.addLineToTable();

    // 2. grab the row we just added
    const newLine = this.lines[this.lines.length - 1];

    // 3. populate mandatory columns
    const boxCodeEle = newLine.Properties.find((p) => p.Name === 'U_BOX_CODE');
    boxCodeEle.ValueAsObject = boxCode;

    const headerItemCodeProp = headerLine.Properties.find(
      (p) => p.Name === 'U_ITEM_CODE',
    );
    const itemCodeLineEle = newLine.Properties.find(
      (p) => p.Name === 'U_ITEM_CODE',
    );
    itemCodeLineEle.ValueAsObject = headerItemCodeProp.ValueAsObject;

    // 4. notify the SAP/low-code runtime
    this.layoutService.triggerFieldValueChanged({
      recordProperty: boxCodeEle,
      formId: '',
      line: newLine.Id,
      recordModel: this.recordModel,
      sectionTagName: this.section.XmlTagName,
      moduleStructure: this.moduleStructure,
    });

    // 5. flag the row as “new” and configure batch/serial handling
    this.rowToWorkWith = newLine;
    this.isNew = true;
    this.rowToWorkWith['isNew'] = true;
    this.rowToWorkWith['ManBtchNum'] = 'N';
    this.rowToWorkWith['ManSerNum'] = 'N';

    // 6. default ScannedQty and, if DEF_QTY is set, increase qty
    if (this.rowToWorkWith['ScannedQty'] === undefined) {
      this.rowToWorkWith['ScannedQty'] = 0;
    }

    if (defQtyProp?.ValueAsObject && Number(defQtyProp.ValueAsObject) !== 0) {
      const qtyProp = this.rowToWorkWith.Properties.find(
        (p) => p.Name === this.quantityFieldPropertyName,
      );
      qtyProp.ValueAsObject =
        Number(qtyProp.ValueAsObject) + Number(defQtyProp.ValueAsObject);
      this.resetScanFields(quantityControl, scanControl);
    } else {
      setTimeout(
        () => this.focusAfterScan(scanControl, '', quantityControl),
        1000,
      );
    }

    // 7. finish the observable chain
    observer.next({ boxCode });
    observer.complete();
  }

  executeScanBoxForDeclaration(
    value,
    scanControl: FormControl,
    quantityControl: FormControl,
    newBox = false,
  ): Observable<any> {
    return new Observable((observer) => {
      try {
        if (newBox) {
          const boxCode = value;
          //const boxCode = scanControl.value;
          const headerLine = this.recordModel.Categories.find(
            (cat) => cat.Id === 'ITM_WMS_BOX_DCLR',
          ).Lines[0];

          const duplicate = this.lines.find(
            (line) =>
              line.Properties.find((p) => p.Name === 'U_BOX_CODE')
                ?.ValueAsObject === boxCode,
          );

          if (duplicate) {
            this.message.error(
              this.layoutService
                .translate(`You already scan the box with code _BOX_CODE_`)
                .replace('_BOX_CODE_', boxCode),
              { nzDuration: 5000 },
            );
            this.playErrorVoice();
            this.resetScanFields(undefined, scanControl);
            observer.error('Box already scanned');
            return;
          }

          const boxCurrentItemCode = headerLine.Properties.find(
            (p) => p.Name === 'U_ITEM_CODE',
          ).ValueAsObject;

          const qtyToLoad = headerLine.Properties.find(
            (p) => p.Name === 'BOX_COUNT',
          );

          const defQtyProp = headerLine.Properties.find(
            (p) => p.Name === 'DEF_QTY',
          );

          let loadedQty = 0;
          const remQtyToLoad = headerLine.Properties.find(
            (p) => p.Name === 'REM_BOX_COUNT',
          );

          this.isNew = false;
          if (this.recordModel.ObjectKey === 'ITM_WMS_BOX_DCLR_1') {
            const linesCat = this.recordModel.Categories.find(
              (cat) => cat.Id === 'ITM_WMS_BOX_LINE',
            );

            linesCat.Lines.forEach((line) => {
              const innerItemCode = line.Properties.find(
                (p) => p.Name === 'U_ITEM_CODE',
              ).ValueAsObject;
              if (boxCurrentItemCode === innerItemCode) {
                loadedQty += Number(
                  line.Properties.find((p) => p.Name === 'U_QTY').ValueAsObject,
                );
              }
            });

            loadedQty = Number(loadedQty.toFixed(2));

            //console.log('1', qtyToLoad.ValueAsObject);
            //console.log('1', Number(qtyToLoad.ValueAsObject));
            if (
              //qtyToLoad?.ValueAsObject &&
              Number(qtyToLoad.ValueAsObject) === 0
            ) {
              this.message.error(
                this.layoutService
                  .translate(
                    `The required quantity for item _ITEM_CODE_ is already fulfilled, you can't add more boxes to the pallet`,
                  )
                  .replace('_ITEM_CODE_', boxCurrentItemCode),
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Wrong box size');
              return;
            }

            //console.log('2', defQtyProp.ValueAsObject);
            //console.log('2', Number(defQtyProp.ValueAsObject));
            //console.log('2', loadedQty);
            //console.log('2', qtyToLoad.ValueAsObject);
            //console.log('2', Number(qtyToLoad.ValueAsObject));
            //console.log('2', loadedQty + Number(defQtyProp.ValueAsObject));
            /*console.log(
              '2',
              Number(qtyToLoad.ValueAsObject) *
                Number(defQtyProp.ValueAsObject),
            );*/

            if (
              //defQtyProp?.ValueAsObject &&
              Number(defQtyProp.ValueAsObject) !== 0 &&
              //qtyToLoad?.ValueAsObject &&
              loadedQty + Number(defQtyProp.ValueAsObject) >
                Number(qtyToLoad.ValueAsObject) *
                  Number(defQtyProp.ValueAsObject)
            ) {
              this.message.error(
                this.layoutService
                  .translate(
                    `The required quantity for item _ITEM_CODE_ is already fulfilled, you can't add more boxes to the pallet`,
                  )
                  .replace('_ITEM_CODE_', boxCurrentItemCode),
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Wrong box size');
              return;
            } else {
              this.addLineToTable();
            }
          } else {
            this.addLineToTable();
          }

          //this.addLineToTable();
          const newLine = this.lines[this.lines.length - 1];
          const boxCodeEle = newLine.Properties.find(
            (p) => p.Name === 'U_BOX_CODE',
          );
          boxCodeEle.ValueAsObject = boxCode;

          const headerItemCodeProp = headerLine.Properties.find(
            (p) => p.Name === 'U_ITEM_CODE',
          );

          const itemCodeLineEle = newLine.Properties.find(
            (p) => p.Name === 'U_ITEM_CODE',
          );
          itemCodeLineEle.ValueAsObject = headerItemCodeProp.ValueAsObject;

          this.layoutService.triggerFieldValueChanged({
            recordProperty: boxCodeEle,
            formId: '',
            line: newLine.Id,
            recordModel: this.recordModel,
            sectionTagName: this.section.XmlTagName,
            moduleStructure: this.moduleStructure,
          });

          this.rowToWorkWith = newLine;
          this.isNew = true;
          this.rowToWorkWith['isNew'] = true;
          this.rowToWorkWith['ManBtchNum'] = 'N';
          this.rowToWorkWith['ManSerNum'] = 'N';

          if (this.rowToWorkWith['ScannedQty'] === undefined) {
            this.rowToWorkWith['ScannedQty'] = 0;
          }

          if (
            defQtyProp?.ValueAsObject &&
            Number(defQtyProp.ValueAsObject) !== 0
          ) {
            const qtyProp = this.rowToWorkWith.Properties.find(
              (p) => p.Name === this.quantityFieldPropertyName,
            );
            qtyProp.ValueAsObject =
              Number(qtyProp.ValueAsObject) + Number(defQtyProp.ValueAsObject);

            this.voiceService.playSuccessVoice(this.lines.length.toString());
            this.resetScanFields(quantityControl, scanControl);
          } else {
            setTimeout(
              () => this.focusAfterScan(scanControl, '', quantityControl),
              1000,
            );
          }

          if (this.recordModel.ObjectKey === 'ITM_WMS_BOX_DCLR_1') {
            const boxCurrentItemCode1 = headerLine.Properties.find(
              (p) => p.Name === 'U_ITEM_CODE',
            ).ValueAsObject;

            remQtyToLoad.ValueAsObject =
              Number(qtyToLoad.ValueAsObject) -
              this.lines.filter(
                (line) =>
                  line.Properties.find((p) => p.Name === 'U_ITEM_CODE')
                    ?.ValueAsObject === boxCurrentItemCode1,
              ).length;
          }

          observer.next({ boxCode });
          observer.complete();
        } else {
          this.inventoryService
            .getBoxDetailsAfterScan(value)
            //.getBoxDetailsAfterScan(scanControl.value)
            .subscribe({
              next: (d: any[]) => {
                if (!d.length) {
                  this.message.error(
                    this.layoutService.translate(
                      `We couldn't find any result for the scanned value, or the box is not available`,
                    ),
                    { nzDuration: 5000 },
                  );
                  this.playErrorVoice();
                  this.resetScanFields(undefined, scanControl);
                  observer.error('Box not found');
                  return;
                }

                const boxCurrentStatus = d[0].BOX_STATUS;
                const boxAvailable = d[0].U_IS_AVAILABLE;
                const boxCurrentQuantity = d[0].U_QTY;
                const existedPLT = d[0].ExistedPLT;

                const boxCurrentItemCode = d[0].U_ITEM_CODE;
                if (
                  boxCurrentItemCode &&
                  this.recordModel.ObjectKey === 'ITM_WMS_BOX_DCLR'
                ) {
                  this.message.error(
                    this.layoutService
                      .translate(`Box _BOX_CODE_ is not available`)
                      .replace('_BOX_CODE_', value),
                    { nzDuration: 5000 },
                    //.replace('_BOX_CODE_', scanControl.value)
                  );
                  this.playErrorVoice();
                  this.resetScanFields(undefined, scanControl);
                  observer.error('Box not available');
                  return;
                }

                const boxCode = value;
                //const boxCode = scanControl.value;
                const duplicate = this.lines.find(
                  (line) =>
                    line.Properties.find((p) => p.Name === 'U_BOX_CODE')
                      ?.ValueAsObject === boxCode,
                );
                if (duplicate) {
                  this.message.error(
                    this.layoutService
                      .translate(
                        `You already scan the box with code _BOX_CODE_`,
                      )
                      .replace('_BOX_CODE_', boxCode),
                    { nzDuration: 5000 },
                  );
                  this.playErrorVoice();
                  this.resetScanFields(undefined, scanControl);
                  observer.error('Box already scanned');
                  return;
                }

                const headerLine = this.recordModel.Categories.find(
                  (cat) => cat.Id === 'ITM_WMS_BOX_DCLR',
                ).Lines[0];
                const headerBoxSize = headerLine.Properties.find(
                  (p) => p.Name === 'U_BOX_TYPE',
                );
                const boxSize = d[0].U_BOX_SIZE;

                if (headerBoxSize.ValueAsObject !== boxSize) {
                  this.message.error(
                    this.layoutService
                      .translate(
                        `Please select a box with only the following size: _SIZE_, the box size you scanned is: _WRONG_SIZE_`,
                      )
                      .replace('_SIZE_', headerBoxSize.ValueAsObject)
                      .replace('_WRONG_SIZE_', boxSize),
                    { nzDuration: 5000 },
                  );
                  this.playErrorVoice();
                  this.resetScanFields(undefined, scanControl);
                  observer.error('Wrong box size');
                  return;
                }

                const qtyToLoad = headerLine.Properties.find(
                  (p) => p.Name === 'BOX_COUNT',
                );

                const defQtyProp = headerLine.Properties.find(
                  (p) => p.Name === 'DEF_QTY',
                );

                let loadedQty = 0;
                const remQtyToLoad = headerLine.Properties.find(
                  (p) => p.Name === 'REM_BOX_COUNT',
                );

                if (this.recordModel.ObjectKey === 'ITM_WMS_BOX_DCLR_1') {
                  if (boxCurrentStatus === 'D' && boxAvailable === 'N') {
                    this.message.error(
                      this.layoutService.translate(`The box is not available`),
                      { nzDuration: 5000 },
                    );
                    this.playErrorVoice();
                    this.resetScanFields(undefined, scanControl);
                    observer.error('Box status D');
                    return;
                  }

                  const linesCat = this.recordModel.Categories.find(
                    (cat) => cat.Id === 'ITM_WMS_BOX_LINE',
                  );

                  linesCat.Lines.forEach((line) => {
                    const innerItemCode = line.Properties.find(
                      (p) => p.Name === 'U_ITEM_CODE',
                    ).ValueAsObject;
                    if (boxCurrentItemCode === innerItemCode) {
                      loadedQty += Number(
                        line.Properties.find((p) => p.Name === 'U_QTY')
                          .ValueAsObject,
                      );
                    }
                  });

                  loadedQty = Number(loadedQty.toFixed(2));

                  //console.log('3', defQtyProp.ValueAsObject);
                  //console.log('3', Number(defQtyProp.ValueAsObject));
                  //console.log('3', qtyToLoad?.ValueAsObject);
                  //console.log('3', loadedQty);
                  //console.log('3', Number(qtyToLoad.ValueAsObject));

                  if (
                    defQtyProp?.ValueAsObject &&
                    Number(defQtyProp.ValueAsObject) !== 0 &&
                    qtyToLoad?.ValueAsObject &&
                    loadedQty + Number(defQtyProp.ValueAsObject) >
                      Number(qtyToLoad.ValueAsObject) *
                        Number(defQtyProp.ValueAsObject)
                  ) {
                    this.message.error(
                      this.layoutService
                        .translate(
                          `The required quantity for item _ITEM_CODE_ is already fulfilled, you can't add more boxes to the pallet`,
                        )
                        .replace('_ITEM_CODE_', boxCurrentItemCode),
                      { nzDuration: 5000 },
                    );
                    this.playErrorVoice();
                    this.resetScanFields(undefined, scanControl);
                    observer.error('Wrong box size');
                    return;
                  } else {
                    //this.addLineToTable();

                    if (existedPLT && boxCurrentStatus !== 'D') {
                      this.playErrorVoice();
                      this.modal.confirm({
                        nzTitle: this.layoutService
                          .translate(
                            'Box: _BOX_CODE_ is already loaded into: _PALLET_, do you want to transfer it to the current pallet?',
                          )
                          .replace('_PALLET_', existedPLT)
                          .replace('_BOX_CODE_', boxCode),
                        nzContent: '',
                        nzOnOk: () =>
                          this.appendLineForBox(
                            value, // ← boxCode
                            headerLine,
                            defQtyProp,
                            quantityControl,
                            scanControl,
                            observer,
                          ),
                        nzOnCancel: () => {
                          this.resetScanFields(undefined, scanControl);
                          observer.error('Transfer cancelled');
                        },
                      });
                    } else {
                      this.appendLineForBox(
                        value, // ← boxCode
                        headerLine,
                        defQtyProp,
                        quantityControl,
                        scanControl,
                        observer,
                      );
                    }
                  }
                } else {
                  this.appendLineForBox(
                    value, // ← boxCode
                    headerLine,
                    defQtyProp,
                    quantityControl,
                    scanControl,
                    observer,
                  );
                }

                if (this.recordModel.ObjectKey === 'ITM_WMS_BOX_DCLR_1') {
                  const boxCurrentItemCode1 = headerLine.Properties.find(
                    (p) => p.Name === 'U_ITEM_CODE',
                  ).ValueAsObject;
                  remQtyToLoad.ValueAsObject =
                    Number(qtyToLoad.ValueAsObject) -
                    this.lines.filter(
                      (line) =>
                        line.Properties.find((p) => p.Name === 'U_ITEM_CODE')
                          ?.ValueAsObject === boxCurrentItemCode1,
                    ).length;
                }
                /*const newLine = this.lines[this.lines.length - 1];
                const boxCodeEle = newLine.Properties.find(
                  (p) => p.Name === 'U_BOX_CODE'
                );
                boxCodeEle.ValueAsObject = boxCode;

                const headerItemCodeProp = headerLine.Properties.find(
                  (p) => p.Name === 'U_ITEM_CODE'
                );

                const itemCodeLineEle = newLine.Properties.find(
                  (p) => p.Name === 'U_ITEM_CODE'
                );
                itemCodeLineEle.ValueAsObject =
                  headerItemCodeProp.ValueAsObject;

                this.layoutService.triggerFieldValueChanged({
                  recordProperty: boxCodeEle,
                  formId: '',
                  line: newLine.Id,
                  recordModel: this.recordModel,
                  sectionTagName: this.section.XmlTagName,
                  moduleStructure: this.moduleStructure,
                });

                this.rowToWorkWith = newLine;
                this.isNew = true;
                this.rowToWorkWith['isNew'] = true;
                this.rowToWorkWith['ManBtchNum'] = 'N';
                this.rowToWorkWith['ManSerNum'] = 'N';

                if (this.rowToWorkWith['ScannedQty'] === undefined) {
                  this.rowToWorkWith['ScannedQty'] = 0;
                }

                if (
                  defQtyProp?.ValueAsObject &&
                  Number(defQtyProp.ValueAsObject) !== 0
                ) {
                  const qtyProp = this.rowToWorkWith.Properties.find(
                    (p) => p.Name === this.quantityFieldPropertyName
                  );
                  qtyProp.ValueAsObject =
                    Number(qtyProp.ValueAsObject) +
                    Number(defQtyProp.ValueAsObject);
                  this.resetScanFields(quantityControl, scanControl);
                } else {
                  setTimeout(() => this.focusAfterScan(quantityControl), 1000);
                }*/

                observer.next({ boxCode });
                observer.complete();
              },
              error: (err) => observer.error(err),
            });
        }
      } catch (err) {
        observer.error(err);
      }
    });
  }

  executeScanBoxForPick(
    value,
    scanControl: FormControl,
    quantityControl: FormControl,
    newBox = false,
  ): Observable<any> {
    return new Observable((observer) => {
      if (newBox) {
        this.message.error(
          this.layoutService.translate(
            `We couldn't find any result for the scanned value, or the box is not available`,
          ),
          { nzDuration: 5000 },
        );
        this.playErrorVoice();
        this.resetScanFields(undefined, scanControl);
        observer.error('Box scan failed: new box with no data');
        return;
      }

      this.inventoryService
        .getBoxDetailsAfterScan(value)
        //.getBoxDetailsAfterScan(scanControl.value)
        .subscribe({
          next: (d: any[]) => {
            if (!d.length) {
              this.message.error(
                this.layoutService.translate(
                  `We couldn't find any result for the scanned value, or the box is not available`,
                ),
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('No box data returned');
              return;
            }

            const boxCurrentItemCode = d[0].U_ITEM_CODE;
            const boxCurrentQuantity = d[0].U_QTY;

            if (!boxCurrentItemCode) {
              this.message.error(
                this.layoutService
                  .translate(`Box _BOX_CODE_ is empty`)
                  .replace('_BOX_CODE_', value),
                { nzDuration: 5000 },
                //.replace('_BOX_CODE_', scanControl.value)
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Empty box');
              return;
            }

            const headerLine = this.recordModel.Categories.find(
              (cat) => cat.Id === 'ITM_WMS_PICK_HDR',
            ).Lines[0];
            const headerItemCode = headerLine.Properties.find(
              (p) => p.Name === 'U_ITEM_CODE',
            ).ValueAsObject;
            const headerOpenQtyProp = headerLine.Properties.find(
              (p) => p.Name === 'U_OPEN_QTY',
            );
            const headerPickedQtyProp = headerLine.Properties.find(
              (p) => p.Name === 'U_PICKED_QTY',
            );

            if (boxCurrentItemCode !== headerItemCode) {
              this.message.error(
                this.layoutService.translate(
                  `The scanned box already contains different products.`,
                ),
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Mismatched item code');
              return;
            }

            //console.log('4', headerOpenQtyProp.ValueAsObject);
            //console.log('4', Number(headerOpenQtyProp.ValueAsObject));
            //console.log('4', boxCurrentQuantity);
            //console.log('4', Number(boxCurrentQuantity));

            if (
              Number(headerOpenQtyProp.ValueAsObject) -
                Number(boxCurrentQuantity) <
              0
            ) {
              this.message.error(
                this.layoutService.translate(
                  `The required quantity is already fulfilled, you can't add more boxes to the pallet`,
                ),
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Over pick quantity');
              return;
            }

            const boxCode = value;
            //const boxCode = scanControl.value;
            const duplicate = this.lines.find(
              (line) =>
                line.Properties.find((p) => p.Name === 'U_BOX_CODE')
                  ?.ValueAsObject === boxCode,
            );

            if (duplicate) {
              this.message.error(
                this.layoutService
                  .translate(`You already scan the box with code _BOX_CODE_`)
                  .replace('_BOX_CODE_', value),
                { nzDuration: 5000 },
                //.replace('_BOX_CODE_', scanControl.value)
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Box already scanned');
              return;
            }

            this.isNew = false;
            this.addLineToTable();

            const newLine = this.lines[this.lines.length - 1];
            const boxCodeEle = newLine.Properties.find(
              (p) => p.Name === 'U_BOX_CODE',
            );
            boxCodeEle.ValueAsObject = boxCode;

            this.layoutService.triggerFieldValueChanged({
              recordProperty: boxCodeEle,
              formId: '',
              line: newLine.Id,
              recordModel: this.recordModel,
              sectionTagName: this.section.XmlTagName,
              moduleStructure: this.moduleStructure,
            });

            this.rowToWorkWith = newLine;
            this.isNew = true;
            newLine['isNew'] = true;
            newLine['ManBtchNum'] = 'N';
            newLine['ManSerNum'] = 'N';

            if (newLine['ScannedQty'] === undefined) {
              newLine['ScannedQty'] = 0;
            }

            const qtyProp = newLine.Properties.find(
              (p) => p.Name === this.quantityFieldPropertyName,
            );
            qtyProp.ValueAsObject =
              Number(qtyProp.ValueAsObject) + Number(boxCurrentQuantity);

            headerOpenQtyProp.ValueAsObject =
              Number(headerOpenQtyProp.ValueAsObject) -
              Number(boxCurrentQuantity);
            headerPickedQtyProp.ValueAsObject =
              Number(headerPickedQtyProp.ValueAsObject) +
              Number(boxCurrentQuantity);

            this.resetScanFields(quantityControl, scanControl);
            observer.next({ boxCode });
            observer.complete();
          },
          error: (err) => {
            this.message.error('Failed to scan box', { nzDuration: 5000 });
            this.playErrorVoice();
            observer.error(err);
          },
        });
    });
  }

  executeScanBoxForReturn(
    value,
    scanControl: FormControl,
    newBox = false,
  ): Observable<any> {
    return new Observable((observer) => {
      if (newBox) {
        this.message.error(
          this.layoutService.translate(
            `We couldn't find any result for the scanned value, or the box is not available`,
          ),
          { nzDuration: 5000 },
        );
        this.playErrorVoice();
        this.resetScanFields(undefined, scanControl);
        observer.error('Box not found (newBox = true)');
        return;
      }

      this.inventoryService
        .getBoxDetailsAfterScan(value)
        //.getBoxDetailsAfterScan(scanControl.value)
        .subscribe({
          next: (d: any[]) => {
            if (!d.length) {
              this.message.error(
                this.layoutService.translate(
                  `We couldn't find any result for the scanned value, or the box is not available`,
                ),
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Box not found');
              return;
            }

            const boxCurrentItemCode = d[0].U_ITEM_CODE;
            const boxStatus = d[0].BOX_STATUS;

            if (!boxCurrentItemCode) {
              this.message.error(
                this.layoutService
                  .translate(
                    `The box _BOX_CODE_ you scanned is already in warehouse.`,
                  )
                  .replace('_BOX_CODE_', value),
                { nzDuration: 5000 },
                //.replace('_BOX_CODE_', scanControl.value)
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Box already in warehouse');
              return;
            }

            if (boxStatus === 'O') {
              this.message.error(
                this.layoutService
                  .translate(`Box _BOX_CODE_ is currently loaded into a pallet`)
                  .replace('_BOX_CODE_', value),
                { nzDuration: 5000 },
                //.replace('_BOX_CODE_', scanControl.value)
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Box in pallet');
              return;
            }

            const boxCode = value;
            //const boxCode = scanControl.value;
            const duplicate = this.lines.find(
              (line) =>
                line.Properties.find((p) => p.Name === 'U_BOX_CODE')
                  ?.ValueAsObject === boxCode,
            );

            if (duplicate) {
              this.message.error(
                this.layoutService
                  .translate(`You already scan the box with code _BOX_CODE_`)
                  .replace('_BOX_CODE_', value),
                { nzDuration: 5000 },
                //.replace('_BOX_CODE_', scanControl.value)
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Box already scanned');
              return;
            }

            this.isNew = false;
            this.addLineToTable();

            const newLine = this.lines[this.lines.length - 1];
            const boxCodeEle = newLine.Properties.find(
              (p) => p.Name === 'U_BOX_CODE',
            );
            boxCodeEle.ValueAsObject = boxCode;

            this.layoutService.triggerFieldValueChanged({
              recordProperty: boxCodeEle,
              formId: '',
              line: newLine.Id,
              recordModel: this.recordModel,
              sectionTagName: this.section.XmlTagName,
              moduleStructure: this.moduleStructure,
            });

            this.rowToWorkWith = newLine;
            this.isNew = true;
            newLine['isNew'] = true;
            newLine['ManBtchNum'] = 'N';
            newLine['ManSerNum'] = 'N';

            if (newLine['ScannedQty'] === undefined) {
              newLine['ScannedQty'] = 0;
            }

            this.resetScanFields(undefined, scanControl);
            observer.next({ boxCode });
            observer.complete();
          },
          error: (err) => {
            this.message.error('Error fetching box data', { nzDuration: 5000 });
            this.playErrorVoice();
            observer.error(err);
          },
        });
    });
  }

  executeScanOfBox(
    value,
    scanControl: FormControl,
    quantityControl: FormControl,
    newBox = false,
  ): Observable<any> {
    return new Observable((observer) => {
      try {
        let scan$: Observable<any>;

        if (
          this.recordModel.ObjectKey === 'ITM_WMS_BOX_DCLR' ||
          this.recordModel.ObjectKey === 'ITM_WMS_BOX_DCLR_1'
        ) {
          scan$ = this.executeScanBoxForDeclaration(
            value,
            scanControl,
            quantityControl,
            newBox,
          );
        } else if (this.recordModel.ObjectKey === 'ITM_WMS_PLT_BOX') {
          scan$ = this.executeScanBoxForLoadToPallet(
            value,
            scanControl,
            quantityControl,
            newBox,
          );
        } else if (this.recordModel.ObjectKey === 'ITM_WMS_PICK_HDR') {
          scan$ = this.executeScanBoxForPick(
            value,
            scanControl,
            quantityControl,
            newBox,
          );
        } else if (this.recordModel.ObjectKey === 'ITM_WMS_BOX_RETURN') {
          scan$ = this.executeScanBoxForReturn(value, scanControl, newBox);
        } else {
          observer.error('Unsupported ObjectKey for box scan');
          return;
        }

        scan$.subscribe({
          next: (res) => observer.next(res),
          error: (err) => observer.error(err),
          complete: () => observer.complete(),
        });
      } catch (err) {
        observer.error(err);
      }
    });
  }

  executeScanBoxForLoadToPallet(
    value,
    scanControl: FormControl,
    quantityControl: FormControl,
    newBox = false,
  ): Observable<any> {
    return new Observable((observer) => {
      if (newBox) {
        this.message.error(
          this.layoutService.translate(
            `We couldn't find any result for the scanned value, or the box is not available`,
          ),
          { nzDuration: 5000 },
        );
        this.playErrorVoice();
        this.resetScanFields(undefined, scanControl);
        observer.error('New box flag set without data');
        return;
      }

      this.inventoryService
        .getBoxDetailsAfterScan(value)
        //.getBoxDetailsAfterScan(scanControl.value)
        .subscribe({
          next: (d: any[]) => {
            if (!d.length) {
              this.message.error(
                this.layoutService.translate(
                  `We couldn't find any result for the scanned value, or the box is not available`,
                ),
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Box not found');
              return;
            }

            const boxCurrentItemCode = d[0].U_ITEM_CODE;
            const boxCurrentStatus = d[0].BOX_STATUS;
            const boxAvailable = d[0].U_IS_AVAILABLE;
            const boxCurrentQuantity = d[0].U_QTY;
            const existedPLT = d[0].ExistedPLT;

            if (!boxCurrentItemCode) {
              this.message.error(
                this.layoutService
                  .translate(`Box _BOX_CODE_ is empty`)
                  .replace('_BOX_CODE_', value),
                { nzDuration: 5000 },
                //.replace('_BOX_CODE_', scanControl.value)
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Box is empty');
              return;
            }

            const boxCode = value;
            //const boxCode = scanControl.value;
            const duplicate = this.lines.find(
              (line) =>
                line.Properties.find((p) => p.Name === 'U_BOX_CODE')
                  ?.ValueAsObject === boxCode,
            );

            if (duplicate) {
              this.message.error(
                this.layoutService
                  .translate(`You already scan the box with code _BOX_CODE_`)
                  .replace('_BOX_CODE_', boxCode),
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Box already scanned');
              return;
            }

            if (boxCurrentStatus === 'D' && boxAvailable === 'N') {
              this.message.error(
                this.layoutService.translate(`The box is not available`),
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Box status D');
              return;
            }

            const alreadyFulfilled = this.lines.some((line) => {
              const itemCodeProp = line.Properties.find(
                (p) => p.Name === 'U_ITEM_CODE',
              );
              if (
                !itemCodeProp ||
                itemCodeProp.ValueAsObject !== boxCurrentItemCode
              )
                return false;
              const remainQty = line.Properties.find(
                (p) => p.Name === 'ITM_REMAIN_BOXES_TO_LOAD',
              )?.ValueAsObject;
              return remainQty === 0;
            });

            if (alreadyFulfilled) {
              this.message.error(
                this.layoutService
                  .translate(
                    `The required quantity for item _ITEM_CODE_ is already fulfilled, you can't add more boxes to the pallet`,
                  )
                  .replace('_ITEM_CODE_', boxCurrentItemCode),
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              this.resetScanFields(undefined, scanControl);
              observer.error('Item fulfilled');
              return;
            }

            const finalizeAddBox = () => {
              this.addBoxToPallet(
                boxCode,
                boxCurrentQuantity,
                quantityControl,
                scanControl,
              );
              observer.next({ boxCode });
              observer.complete();
            };

            if (existedPLT && boxCurrentStatus !== 'D') {
              this.playErrorVoice();
              this.modal.confirm({
                nzTitle: this.layoutService
                  .translate(
                    'Box: _BOX_CODE_ is already loaded into: _PALLET_, do you want to transfer it to the current pallet?',
                  )
                  .replace('_PALLET_', existedPLT)
                  .replace('_BOX_CODE_', boxCode),
                nzContent: '',
                nzOnOk: () => finalizeAddBox(),
                nzOnCancel: () => {
                  this.resetScanFields(undefined, scanControl);
                  observer.error('Transfer cancelled');
                },
              });
            } else {
              finalizeAddBox();
            }
          },
          error: (err) => {
            this.message.error('Error retrieving box details', {
              nzDuration: 5000,
            });
            this.playErrorVoice();
            observer.error(err);
          },
        });
    });
  }

  // executeScanBoxForReturn(scanControl, newBox = false) {
  //   if (newBox) {
  //     this.message.error(
  //       this.layoutService.translate(
  //         `We couldn't find any result for the scanned value, or the box is not available`
  //       )
  //     );
  //     this.playErrorVoice();
  //     this.resetScanFields(undefined, scanControl);
  //     return;
  //   } else {
  //     this.inventoryService
  //       .getBoxDetailsAfterScan(scanControl.value)
  //       .subscribe((d: any[]) => {
  //         this.rowToWorkWith = null;

  //         if (d.length == 0) {
  //           this.message.error(
  //             this.layoutService.translate(
  //               `We couldn't find any result for the scanned value, or the box is not available`
  //             )
  //           );
  //           this.playErrorVoice();
  //           this.resetScanFields(undefined, scanControl);
  //           return;
  //         }

  //         const boxCurrentItemCode = d[0].U_ITEM_CODE;

  //         if (
  //           boxCurrentItemCode == null ||
  //           boxCurrentItemCode === undefined ||
  //           boxCurrentItemCode === ''
  //         ) {
  //           this.message.error(
  //             this.layoutService
  //               .translate(
  //                 `The box _BOX_CODE_ you scanned is already in warehouse.`
  //               )
  //               .replace('_BOX_CODE_', scanControl.value)
  //           );
  //           this.playErrorVoice();
  //           this.resetScanFields(undefined, scanControl);
  //           return;
  //         }

  //         const boxStatus = d[0].BOX_STATUS;

  //         if (boxStatus == 'O') {
  //           this.message.error(
  //             this.layoutService
  //               .translate(`Box _BOX_CODE_ is currently loaded into a pallet`)
  //               .replace('_BOX_CODE_', scanControl.value)
  //           );
  //           this.playErrorVoice();
  //           this.resetScanFields(undefined, scanControl);
  //           return;
  //         }

  //         const boxCode = scanControl.value;

  //         this.rowToWorkWith = null;

  //         for (let i = 0; i < this.lines.length; i++) {
  //           const properties = this.lines[i].Properties;
  //           const boxProp = properties.find((p) => p.Name === 'U_BOX_CODE');

  //           if (
  //             boxProp != null &&
  //             boxProp !== undefined &&
  //             boxCode === boxProp.ValueAsObject
  //           ) {
  //             this.rowToWorkWith = this.lines[i];
  //             this.message.error(
  //               this.layoutService
  //                 .translate(`You already scan the box with code _BOX_CODE_`)
  //                 .replace('_BOX_CODE_', scanControl.value)
  //             );
  //             this.playErrorVoice();
  //             this.resetScanFields(undefined, scanControl);
  //             return;
  //           }
  //         }

  //         this.isNew = false;
  //         this.addLineToTable();

  //         const boxCodeEle = this.lines[this.lines.length - 1].Properties.find(
  //           (p) => p.Name === 'U_BOX_CODE'
  //         );

  //         boxCodeEle.ValueAsObject = boxCode;
  //         this.layoutService.triggerFieldValueChanged({
  //           recordProperty: boxCodeEle,
  //           formId: '',
  //           line: this.lines[this.lines.length - 1].Id,
  //           recordModel: this.recordModel,
  //           sectionTagName: this.section.XmlTagName,
  //           moduleStructure: this.moduleStructure,
  //         });

  //         this.rowToWorkWith = this.lines[this.lines.length - 1];
  //         this.isNew = true;

  //         this.rowToWorkWith['isNew'] = true;

  //         this.rowToWorkWith['ManBtchNum'] = 'N';
  //         this.rowToWorkWith['ManSerNum'] = 'N';

  //         if (this.rowToWorkWith['ScannedQty'] === undefined) {
  //           this.rowToWorkWith['ScannedQty'] = 0;
  //         }

  //         this.resetScanFields(undefined, scanControl);
  //       });
  //   }
  // }

  // executeScanBoxForPick(scanControl, quantityControl, newBox = false) {
  //   if (newBox) {
  //     this.message.error(
  //       this.layoutService.translate(
  //         `We couldn't find any result for the scanned value, or the box is not available`
  //       )
  //     );
  //     this.playErrorVoice();
  //     this.resetScanFields(undefined, scanControl);
  //     return;
  //   } else {
  //     this.inventoryService
  //       .getBoxDetailsAfterScan(scanControl.value)
  //       .subscribe((d: any[]) => {
  //         this.rowToWorkWith = null;

  //         if (d.length == 0) {
  //           this.message.error(
  //             this.layoutService.translate(
  //               `We couldn't find any result for the scanned value, or the box is not available`
  //             )
  //           );
  //           this.playErrorVoice();
  //           this.resetScanFields(undefined, scanControl);
  //           return;
  //         }

  //         const boxCurrentItemCode = d[0].U_ITEM_CODE;
  //         const boxCurrentQuantity = d[0].U_QTY;
  //         //const existedPLT = d[0].ExistedPLT;

  //         if (
  //           boxCurrentItemCode == null ||
  //           boxCurrentItemCode === undefined ||
  //           boxCurrentItemCode === ''
  //         ) {
  //           this.message.error(
  //             this.layoutService
  //               .translate(`Box _BOX_CODE_ is empty`)
  //               .replace('_BOX_CODE_', scanControl.value)
  //           );
  //           this.playErrorVoice();
  //           this.resetScanFields(undefined, scanControl);
  //           return;
  //         }

  //         const headerLine = this.recordModel.Categories.find(
  //           (cat) => cat.Id === 'ITM_WMS_PICK_HDR'
  //         ).Lines[0];

  //         const headerItemCode = headerLine.Properties.find(
  //           (p) => p.Name === 'U_ITEM_CODE'
  //         ).ValueAsObject;
  //         const headerOpenQtyProp = headerLine.Properties.find(
  //           (p) => p.Name === 'U_OPEN_QTY'
  //         );
  //         const headerPickedQtyProp = headerLine.Properties.find(
  //           (p) => p.Name === 'U_PICKED_QTY'
  //         );

  //         if (boxCurrentItemCode != headerItemCode) {
  //           this.message.error(
  //             this.layoutService.translate(
  //               `The scanned box already contains different products.`
  //             )
  //           );
  //           this.playErrorVoice();
  //           this.resetScanFields(undefined, scanControl);
  //           return;
  //         }

  //         if (
  //           Number(headerOpenQtyProp.ValueAsObject) -
  //             Number(boxCurrentQuantity) <
  //           0
  //         ) {
  //           this.message.error(
  //             this.layoutService.translate(
  //               `The required quantity is already fulfilled, you can't add more boxes to the pallet`
  //             )
  //           );
  //           this.playErrorVoice();
  //           this.resetScanFields(undefined, scanControl);
  //           return;
  //         }

  //         const boxCode = scanControl.value;

  //         this.rowToWorkWith = null;

  //         for (let i = 0; i < this.lines.length; i++) {
  //           const properties = this.lines[i].Properties;
  //           const boxProp = properties.find((p) => p.Name === 'U_BOX_CODE');

  //           if (
  //             boxProp != null &&
  //             boxProp !== undefined &&
  //             boxCode === boxProp.ValueAsObject
  //           ) {
  //             this.rowToWorkWith = this.lines[i];
  //             this.message.error(
  //               this.layoutService
  //                 .translate(`You already scan the box with code _BOX_CODE_`)
  //                 .replace('_BOX_CODE_', scanControl.value)
  //             );
  //             this.playErrorVoice();
  //             this.resetScanFields(undefined, scanControl);
  //             return;
  //           }
  //         }

  //         /*if (
  //           existedPLT != null &&
  //           existedPLT !== undefined &&
  //           existedPLT !== 0
  //         ) {
  //           this.message.error(
  //             this.layoutService.translate(`The box is used in another pallet`)
  //           );
  //           this.playErrorVoice();
  //           return;
  //         }*/

  //         this.isNew = false;
  //         this.addLineToTable();

  //         const boxCodeEle = this.lines[this.lines.length - 1].Properties.find(
  //           (p) => p.Name === 'U_BOX_CODE'
  //         );

  //         boxCodeEle.ValueAsObject = boxCode;
  //         this.layoutService.triggerFieldValueChanged({
  //           recordProperty: boxCodeEle,
  //           formId: '',
  //           line: this.lines[this.lines.length - 1].Id,
  //           recordModel: this.recordModel,
  //           sectionTagName: this.section.XmlTagName,
  //           moduleStructure: this.moduleStructure,
  //         });

  //         this.rowToWorkWith = this.lines[this.lines.length - 1];
  //         this.isNew = true;

  //         this.rowToWorkWith['isNew'] = true;

  //         this.rowToWorkWith['ManBtchNum'] = 'N';
  //         this.rowToWorkWith['ManSerNum'] = 'N';

  //         if (this.rowToWorkWith['ScannedQty'] === undefined) {
  //           this.rowToWorkWith['ScannedQty'] = 0;
  //         }

  //         const qtyProp = this.rowToWorkWith.Properties.find(
  //           (p) => p.Name === this.quantityFieldPropertyName
  //         );

  //         qtyProp.ValueAsObject =
  //           Number(qtyProp.ValueAsObject) + Number(boxCurrentQuantity);

  //         headerOpenQtyProp.ValueAsObject =
  //           Number(headerOpenQtyProp.ValueAsObject) -
  //           Number(boxCurrentQuantity);

  //         headerPickedQtyProp.ValueAsObject =
  //           Number(headerPickedQtyProp.ValueAsObject) +
  //           Number(boxCurrentQuantity);

  //         this.resetScanFields(quantityControl, scanControl);
  //       });
  //   }
  // }

  // executeScanBoxForDeclaration(scanControl, quantityControl, newBox = false) {
  //   if (newBox) {
  //     const boxCode = scanControl.value;

  //     const headerLine = this.recordModel.Categories.find(
  //       (cat) => cat.Id === 'ITM_WMS_BOX_DCLR'
  //     ).Lines[0];

  //     this.rowToWorkWith = null;

  //     for (let i = 0; i < this.lines.length; i++) {
  //       const properties = this.lines[i].Properties;
  //       const boxProp = properties.find((p) => p.Name === 'U_BOX_CODE');

  //       if (
  //         boxProp != null &&
  //         boxProp !== undefined &&
  //         boxCode === boxProp.ValueAsObject
  //       ) {
  //         this.rowToWorkWith = this.lines[i];
  //         this.message.error(
  //           this.layoutService
  //             .translate(`You already scan the box with code _BOX_CODE_`)
  //             .replace('_BOX_CODE_', scanControl.value)
  //         );
  //         this.playErrorVoice();
  //         this.resetScanFields(undefined, scanControl);
  //         return;
  //       }
  //     }

  //     /*this.notificationService.create(
  //       'warning',
  //       this.layoutService
  //         .translate('You are going to add a new box _BOX_CODE_')
  //         .replace('_BOX_CODE_', boxCode),
  //       ''
  //     );*/

  //     this.isNew = false;
  //     this.addLineToTable();

  //     const boxCodeEle = this.lines[this.lines.length - 1].Properties.find(
  //       (p) => p.Name === 'U_BOX_CODE'
  //     );

  //     boxCodeEle.ValueAsObject = boxCode;
  //     this.layoutService.triggerFieldValueChanged({
  //       recordProperty: boxCodeEle,
  //       formId: '',
  //       line: this.lines[this.lines.length - 1].Id,
  //       recordModel: this.recordModel,
  //       sectionTagName: this.section.XmlTagName,
  //       moduleStructure: this.moduleStructure,
  //     });

  //     this.rowToWorkWith = this.lines[this.lines.length - 1];
  //     this.isNew = true;

  //     this.rowToWorkWith['isNew'] = true;

  //     this.rowToWorkWith['ManBtchNum'] = 'N';
  //     this.rowToWorkWith['ManSerNum'] = 'N';

  //     if (this.rowToWorkWith['ScannedQty'] === undefined) {
  //       this.rowToWorkWith['ScannedQty'] = 0;
  //     }

  //     const defQtyProp = headerLine.Properties.find(
  //       (p) => p.Name === 'DEF_QTY'
  //     );

  //     if (
  //       defQtyProp !== undefined &&
  //       defQtyProp.ValueAsObject != null &&
  //       defQtyProp.ValueAsObject !== undefined &&
  //       Number(defQtyProp.ValueAsObject) !== 0
  //     ) {
  //       const qtyProp = this.rowToWorkWith.Properties.find(
  //         (p) => p.Name === this.quantityFieldPropertyName
  //       );

  //       qtyProp.ValueAsObject =
  //         Number(qtyProp.ValueAsObject) + Number(defQtyProp.ValueAsObject);

  //       this.resetScanFields(quantityControl, scanControl);
  //     } else {
  //       const comp = this;
  //       setTimeout(function () {
  //         comp.focusAfterScan(quantityControl);
  //       }, 1000);
  //     }
  //   } else {
  //     this.inventoryService
  //       .getBoxDetailsAfterScan(scanControl.value)
  //       .subscribe((d: any[]) => {
  //         this.rowToWorkWith = null;

  //         if (d.length == 0) {
  //           this.message.error(
  //             this.layoutService.translate(
  //               `We couldn't find any result for the scanned value, or the box is not available`
  //             )
  //           );
  //           this.playErrorVoice();
  //           this.resetScanFields(undefined, scanControl);
  //           return;
  //         }

  //         const boxCurrentItemCode = d[0].U_ITEM_CODE;
  //         if (
  //           boxCurrentItemCode != null &&
  //           boxCurrentItemCode !== undefined &&
  //           boxCurrentItemCode !== ''
  //         ) {
  //           this.message.error(
  //             this.layoutService
  //               .translate(`Box _BOX_CODE_ is not available`)
  //               .replace('_BOX_CODE_', scanControl.value)
  //           );
  //           this.playErrorVoice();
  //           this.resetScanFields(undefined, scanControl);
  //           return;
  //         }

  //         const boxCode = scanControl.value;

  //         for (let i = 0; i < this.lines.length; i++) {
  //           const properties = this.lines[i].Properties;
  //           const boxProp = properties.find((p) => p.Name === 'U_BOX_CODE');

  //           if (
  //             boxProp != null &&
  //             boxProp !== undefined &&
  //             boxCode === boxProp.ValueAsObject
  //           ) {
  //             this.rowToWorkWith = this.lines[i];
  //             this.message.error(
  //               this.layoutService
  //                 .translate(`You already scan the box with code _BOX_CODE_`)
  //                 .replace('_BOX_CODE_', scanControl.value)
  //             );
  //             this.playErrorVoice();
  //             this.resetScanFields(undefined, scanControl);
  //             return;
  //           }
  //         }

  //         const headerLine = this.recordModel.Categories.find(
  //           (cat) => cat.Id === 'ITM_WMS_BOX_DCLR'
  //         ).Lines[0];

  //         const headerBoxSize = headerLine.Properties.find(
  //           (p) => p.Name === 'U_BOX_TYPE'
  //         );

  //         const boxSize = d[0].U_BOX_SIZE;

  //         if (headerBoxSize.ValueAsObject !== boxSize) {
  //           this.message.error(
  //             this.layoutService
  //               .translate(
  //                 `Please select a box with only the following size: _SIZE_, the box size you scanned is: _WRONG_SIZE_`
  //               )
  //               .replace('_SIZE_', headerBoxSize.ValueAsObject)
  //               .replace('_WRONG_SIZE_', boxSize)
  //           );
  //           this.playErrorVoice();
  //           this.resetScanFields(undefined, scanControl);
  //           return;
  //         }

  //         this.rowToWorkWith = null;

  //         for (let i = 0; i < this.lines.length; i++) {
  //           const properties = this.lines[i].Properties;
  //           const boxProp = properties.find((p) => p.Name === 'U_BOX_CODE');

  //           if (
  //             boxProp != null &&
  //             boxProp !== undefined &&
  //             boxCode === boxProp.ValueAsObject
  //           ) {
  //             this.rowToWorkWith = this.lines[i];
  //             this.message.error(
  //               this.layoutService
  //                 .translate(`You already scan the box with code _BOX_CODE_`)
  //                 .replace('_BOX_CODE_', scanControl.value)
  //             );
  //             this.playErrorVoice();
  //             this.resetScanFields(undefined, scanControl);
  //             return;
  //           }
  //         }

  //         this.isNew = false;
  //         this.addLineToTable();

  //         const boxCodeEle = this.lines[this.lines.length - 1].Properties.find(
  //           (p) => p.Name === 'U_BOX_CODE'
  //         );

  //         boxCodeEle.ValueAsObject = boxCode;
  //         this.layoutService.triggerFieldValueChanged({
  //           recordProperty: boxCodeEle,
  //           formId: '',
  //           line: this.lines[this.lines.length - 1].Id,
  //           recordModel: this.recordModel,
  //           sectionTagName: this.section.XmlTagName,
  //           moduleStructure: this.moduleStructure,
  //         });

  //         this.rowToWorkWith = this.lines[this.lines.length - 1];
  //         this.isNew = true;

  //         this.rowToWorkWith['isNew'] = true;

  //         this.rowToWorkWith['ManBtchNum'] = 'N';
  //         this.rowToWorkWith['ManSerNum'] = 'N';

  //         if (this.rowToWorkWith['ScannedQty'] === undefined) {
  //           this.rowToWorkWith['ScannedQty'] = 0;
  //         }

  //         const defQtyProp = headerLine.Properties.find(
  //           (p) => p.Name === 'DEF_QTY'
  //         );

  //         if (
  //           defQtyProp !== undefined &&
  //           defQtyProp.ValueAsObject != null &&
  //           defQtyProp.ValueAsObject !== undefined &&
  //           Number(defQtyProp.ValueAsObject) !== 0
  //         ) {
  //           const qtyProp = this.rowToWorkWith.Properties.find(
  //             (p) => p.Name === this.quantityFieldPropertyName
  //           );

  //           qtyProp.ValueAsObject =
  //             Number(qtyProp.ValueAsObject) + Number(defQtyProp.ValueAsObject);

  //           this.resetScanFields(quantityControl, scanControl);
  //         } else {
  //           const comp = this;
  //           setTimeout(function () {
  //             comp.focusAfterScan(quantityControl);
  //           }, 1000);
  //         }
  //       });
  //   }
  // }

  // executeScanBoxForLoadToPallet(scanControl, quantityControl, newBox = false) {
  //   if (newBox) {
  //     this.message.error(
  //       this.layoutService.translate(
  //         `We couldn't find any result for the scanned value, or the box is not available`
  //       )
  //     );
  //     this.playErrorVoice();
  //     this.resetScanFields(undefined, scanControl);
  //     return;
  //   } else {
  //     this.inventoryService
  //       .getBoxDetailsAfterScan(scanControl.value)
  //       .subscribe((d: any[]) => {
  //         this.rowToWorkWith = null;

  //         if (d.length == 0) {
  //           this.message.error(
  //             this.layoutService.translate(
  //               `We couldn't find any result for the scanned value, or the box is not available`
  //             )
  //           );
  //           this.playErrorVoice();
  //           this.resetScanFields(undefined, scanControl);
  //           return;
  //         }

  //         const boxCurrentItemCode = d[0].U_ITEM_CODE;
  //         const boxCurrentStatus = d[0].BOX_STATUS;
  //         const boxCurrentQuantity = d[0].U_QTY;
  //         const existedPLT = d[0].ExistedPLT;

  //         if (
  //           boxCurrentItemCode == null ||
  //           boxCurrentItemCode === undefined ||
  //           boxCurrentItemCode === ''
  //         ) {
  //           this.message.error(
  //             this.layoutService
  //               .translate(`Box _BOX_CODE_ is empty`)
  //               .replace('_BOX_CODE_', scanControl.value)
  //           );
  //           this.playErrorVoice();
  //           this.resetScanFields(undefined, scanControl);
  //           return;
  //         }

  //         const boxCode = scanControl.value;

  //         this.rowToWorkWith = null;

  //         for (let i = 0; i < this.lines.length; i++) {
  //           const properties = this.lines[i].Properties;
  //           const boxProp = properties.find((p) => p.Name === 'U_BOX_CODE');

  //           if (
  //             boxProp != null &&
  //             boxProp !== undefined &&
  //             boxCode === boxProp.ValueAsObject
  //           ) {
  //             this.rowToWorkWith = this.lines[i];
  //             this.message.error(
  //               this.layoutService
  //                 .translate(`You already scan the box with code _BOX_CODE_`)
  //                 .replace('_BOX_CODE_', scanControl.value)
  //             );
  //             this.playErrorVoice();
  //             this.resetScanFields(undefined, scanControl);
  //             return;
  //           }
  //         }

  //         if (boxCurrentStatus == 'D') {
  //           this.message.error(
  //             this.layoutService.translate(`The box is not available`)
  //           );
  //           this.playErrorVoice();
  //           this.resetScanFields(undefined, scanControl);
  //           return;
  //         }

  //         // check if need more before proceed

  //         for (let i = 0; i < this.lines.length; i++) {
  //           const properties = this.lines[i].Properties;
  //           const itemCodeProp = properties.find(
  //             (p) => p.Name === 'U_ITEM_CODE'
  //           );

  //           if (
  //             itemCodeProp != null &&
  //             itemCodeProp !== undefined &&
  //             itemCodeProp.ValueAsObject === boxCurrentItemCode
  //           ) {
  //             const remainQty = properties.find(
  //               (p) => p.Name === 'ITM_REMAIN_BOXES_TO_LOAD'
  //             ).ValueAsObject;

  //             if (remainQty === 0) {
  //               this.message.error(
  //                 this.layoutService
  //                   .translate(
  //                     `The required quantity for item _ITEM_CODE_ is already fulfilled, you can't add more boxes to the pallet`
  //                   )
  //                   .replace('_ITEM_CODE_', boxCurrentItemCode)
  //               );
  //               this.playErrorVoice();
  //               this.resetScanFields(undefined, scanControl);
  //               return;
  //             }
  //           }
  //         }

  //         if (
  //           existedPLT != null &&
  //           existedPLT !== undefined &&
  //           existedPLT !== ''
  //         ) {
  //           this.playErrorVoice();
  //           this.modal.confirm({
  //             nzTitle: this.layoutService
  //               .translate(
  //                 'Box: _BOX_CODE_ is already loaded into: _PALLET_, do you want to transfer it to the current pallet?'
  //               )
  //               .replace('_PALLET_', existedPLT)
  //               .replace('_BOX_CODE_', boxCode),
  //             nzContent: '',
  //             nzOnOk: () => {
  //               this.addBoxToPallet(
  //                 boxCode,
  //                 boxCurrentQuantity,
  //                 quantityControl,
  //                 scanControl
  //               );
  //             },
  //           });
  //         } else {
  //           this.addBoxToPallet(
  //             boxCode,
  //             boxCurrentQuantity,
  //             quantityControl,
  //             scanControl
  //           );
  //         }
  //       });
  //   }
  // }

  addBoxToPallet(boxCode, boxCurrentQuantity, quantityControl, scanControl) {
    this.isNew = false;
    this.addLineToTable();

    const boxCodeEle = this.lines[this.lines.length - 1].Properties.find(
      (p) => p.Name === 'U_BOX_CODE',
    );

    boxCodeEle.ValueAsObject = boxCode;
    this.layoutService.triggerFieldValueChanged({
      recordProperty: boxCodeEle,
      formId: '',
      line: this.lines[this.lines.length - 1].Id,
      recordModel: this.recordModel,
      sectionTagName: this.section.XmlTagName,
      moduleStructure: this.moduleStructure,
    });

    this.rowToWorkWith = this.lines[this.lines.length - 1];
    this.isNew = true;

    this.rowToWorkWith['isNew'] = true;

    this.rowToWorkWith['ManBtchNum'] = 'N';
    this.rowToWorkWith['ManSerNum'] = 'N';

    if (this.rowToWorkWith['ScannedQty'] === undefined) {
      this.rowToWorkWith['ScannedQty'] = 0;
    }

    const qtyProp = this.rowToWorkWith.Properties.find(
      (p) => p.Name === this.quantityFieldPropertyName,
    );

    qtyProp.ValueAsObject =
      Number(qtyProp.ValueAsObject) + Number(boxCurrentQuantity);

    this.layoutService.triggerFieldValueChanged({
      recordProperty: qtyProp,
      formId: '',
      line: this.lines[this.lines.length - 1].Id,
      recordModel: this.recordModel,
      sectionTagName: this.section.XmlTagName,
      moduleStructure: this.moduleStructure,
    });

    this.voiceService.playSuccessVoice(this.lines.length.toString());
    this.resetScanFields(quantityControl, scanControl);
  }

  executeScanOfSerial(value, scanControl: FormControl): Observable<any> {
    return new Observable((observer) => {
      this.inventoryService
        .getSerialNumberDetailsAfterScan(value)
        //.getSerialNumberDetailsAfterScan(scanControl.value)
        .subscribe({
          next: (d: any[]) => {
            this.rowToWorkWith = null;

            if (d.length === 0) {
              this.message.error(
                this.layoutService.translate(
                  `We couldn't find any result for the scanned value, or the serial is not available`,
                ),
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              observer.error('Serial not found or unavailable');
              return;
            }

            const itemCode = d[0]['ItemCode'];

            for (let i = 0; i < this.lines.length; i++) {
              const properties = this.lines[i].Properties;
              const itemProp = properties.find((p) => p.Name === 'ItemCode');

              if (itemProp != null && itemCode === itemProp.ValueAsObject) {
                this.rowToWorkWith = this.lines[i];
                break;
              }
            }

            this.isNew = false;

            if (this.rowToWorkWith === null) {
              if (this.recordModel.ObjectKey === 'oPickLists') {
                this.message.error(
                  this.layoutService.translate(
                    `We couldn't find any result for the scanned value ${value}. `,
                  ),
                  { nzDuration: 5000 },
                );

                this.playErrorVoice();
                observer.error('No matching row found and object is PickList');
                return;
              }

              this.addLineToTable();

              this.layoutService
                .getModuleHeaderData(4, itemCode, '', false)
                .subscribe({
                  next: (headerData) => {
                    this.moduleStructure.module.Sections.forEach((section) => {
                      if (
                        [
                          'Document_Lines',
                          'StockTransfer_Lines',
                          'InventoryCountingLines|InventoryCountingLine',
                        ].includes(section.XmlTagName)
                      ) {
                        section.Fields.forEach((field) => {
                          if (field.LinkedModule === '4') {
                            const value = headerData[field.LinkedField];

                            this.lines[
                              this.lines.length - 1
                            ].Properties.forEach((property) => {
                              if (property.Name === field.PropertyName) {
                                property.ValueAsObject = value;
                                this.layoutService.triggerFieldValueChanged({
                                  recordProperty: property,
                                  formId: '',
                                  line: this.lines[this.lines.length - 1].Id,
                                  recordModel: this.recordModel,
                                  sectionTagName: section.XmlTagName,
                                  moduleStructure: this.moduleStructure,
                                });
                              }
                            });
                          }
                        });
                      }
                    });

                    this.rowToWorkWith = this.lines[this.lines.length - 1];
                    this.isNew = true;

                    if (this.checkDONTDisplayNotificationForNewItemRule()) {
                      this.notificationService.create(
                        'warning',
                        this.layoutService.translate(
                          'You are going to add a new item #' + itemCode,
                        ),
                        '',
                      );
                    }
                    this.rowToWorkWith['ManSerNum'] = 'Y';
                    this.rowToWorkWith['ManBtchNum'] = 'N';

                    this.scannedQty = 1;
                    this.serialNumber = value;
                    //this.serialNumber = scanControl.value;
                    this.checkBinLocations();
                    this.setSerialNumber(value, scanControl);

                    observer.next({ itemCode, newRow: true });
                    observer.complete();
                  },
                  error: (err) => {
                    this.message.error('Failed to get module header data', {
                      nzDuration: 5000,
                    });
                    observer.error(err);
                  },
                });
            } else {
              this.rowToWorkWith['ManSerNum'] = 'Y';
              this.rowToWorkWith['ManBtchNum'] = 'N';

              this.scannedQty = 1;
              this.serialNumber = value;
              //this.serialNumber = scanControl.value;
              this.checkBinLocations();
              this.setSerialNumber(value, scanControl);

              observer.next({ itemCode, newRow: false });
              observer.complete();
            }
          },
          error: (err) => {
            this.message.error('Error during serial scan', {
              nzDuration: 5000,
            });
            observer.error(err);
          },
        });
    });
  }

  executeScanOfBatchAfterItem(scanControl, quantityControl) {
    if (this.rowToWorkWith == null || this.rowToWorkWith === undefined) {
      return;
    }

    const properties = this.rowToWorkWith.Properties;
    const itemToWorkWithProp = properties.find((p) => p.Name === 'ItemCode');
    /*const batchToWorkWithProp = properties.find(
      (p) => p.Name === 'BatchNumber'
    );*/

    let tempRowToWork: RecordLine = null;

    for (let i = 0; i < this.lines.length; i++) {
      const properties = this.lines[i].Properties;
      const itemProp = properties.find((p) => p.Name === 'ItemCode');
      //const binAbs = properties.find((p) => p.Name === 'BinAbs');
      const batchNumber = properties.find((p) => p.Name === 'BatchNumber');

      if (
        itemProp != null &&
        itemProp !== undefined &&
        itemToWorkWithProp.ValueAsObject === itemProp.ValueAsObject &&
        /*binAbs != null &&
        binAbs !== undefined &&
        this.binCode.toString() === binAbs.ValueAsObject.toString() &&*/
        batchNumber != null &&
        batchNumber !== undefined &&
        scanControl.value.toLowerCase() ===
          batchNumber.ValueAsObject.toLowerCase()
      ) {
        tempRowToWork = this.lines[i];
        break;
      }
    }
    this.rowToWorkWith = tempRowToWork;

    this.rowToWorkWith['ManBtchNum'] = 'Y';
    this.rowToWorkWith['ManSerNum'] = 'N';
    this.checkBinLocations();

    console.log(tempRowToWork);
    if (this.rowToWorkWith == null) {
      this.message.error(
        this.layoutService.translate(
          "Can't find a line related to the scanned param.",
        ),
        { nzDuration: 5000 },
      );
      this.playErrorVoice();
      return;
    }

    if (this.rowToWorkWith['BinActivate'] === 'Y') {
      this.binScanFieldVisible = true;
      setTimeout(() => {
        this.scanBinControl.nativeElement.focus();
      }, 1000);
    } else {
      setTimeout(() => {
        quantityControl.focus();
        this.rowToWorkWith['ScannedQty'] = 0;
        this.scanMode = 'Batch';
        this.rowToWorkWith['ManBtchNum'] = 'Y';
        this.rowToWorkWith['ManSerNum'] = 'N';
        this.rowToWorkWith['BinActivate'] = 'N';
      }, 1000);
    }
  }

  executeScanOfBinAfterBatch(scanControl, scanBinControl, quantityControl) {
    if (this.rowToWorkWith == null || this.rowToWorkWith === undefined) {
      return;
    }

    const properties = this.rowToWorkWith.Properties;
    const itemToWorkWithProp = properties.find((p) => p.Name === 'ItemCode');

    let tempRowToWork: RecordLine = null;

    for (let i = 0; i < this.lines.length; i++) {
      const properties = this.lines[i].Properties;
      const itemProp = properties.find((p) => p.Name === 'ItemCode');
      const binCode = properties.find((p) => p.Name === 'BinCode');
      const batchNumber = properties.find((p) => p.Name === 'BatchNumber');

      if (
        itemProp != null &&
        itemProp !== undefined &&
        itemToWorkWithProp.ValueAsObject === itemProp.ValueAsObject &&
        binCode != null &&
        binCode !== undefined &&
        scanBinControl.value.toLowerCase() ===
          binCode.ValueAsObject.toLowerCase() &&
        batchNumber != null &&
        batchNumber !== undefined &&
        scanControl.value.toLowerCase() ===
          batchNumber.ValueAsObject.toLowerCase()
      ) {
        tempRowToWork = this.lines[i];
        break;
      }
    }
    this.rowToWorkWith = tempRowToWork;

    if (this.rowToWorkWith == null) {
      this.message.error(
        this.layoutService.translate(
          "Can't find a line related to the scanned param.",
        ),
        { nzDuration: 5000 },
      );
      this.playErrorVoice();
      return;
    }

    setTimeout(() => {
      quantityControl.focus();
      this.rowToWorkWith['ScannedQty'] = 0;
      this.scanMode = 'Batch';
      this.rowToWorkWith['ManBtchNum'] = 'Y';
      this.rowToWorkWith['ManSerNum'] = 'N';
      this.rowToWorkWith['BinActivate'] = 'Y';
    }, 1000);
  }

  executeScanOfBatch(
    value,
    scanControl: AbstractControl,
    quantityControl: AbstractControl,
  ): Observable<any> {
    const isCountingOrReturns =
      this.moduleStructure.module.ObjectType === 'InventoryCounting' ||
      this.moduleStructure.module.ObjectType === 'oReturns';

    return new Observable((observer) => {
      this.inventoryService
        .getBatchNumberDetailsAfterScan(scanControl.value, isCountingOrReturns)
        .subscribe({
          next: (d: any[]) => {
            this.rowToWorkWith = null;

            let itemCode = '';
            let batchNumber = '';
            this.batchNumberAvaQty = 0;
            let batchWarehouse = '';

            for (let index = 0; index < d.length; index++) {
              let found = false;
              itemCode = d[index]['ItemCode'];
              batchNumber = d[index].BatchNum ?? d[index].DistNumber;
              this.batchNumberAvaQty = d[index].AvaQuantity;
              batchWarehouse = d[index].WhsCode;

              for (let i = 0; i < this.lines.length; i++) {
                const properties = this.lines[i].Properties;
                const itemProp = properties.find((p) => p.Name === 'ItemCode');
                const allocatedBatchsProp = properties.find(
                  (p) => p.Name === 'AllocatedBatchs',
                );
                const warehouse = properties.find(
                  (p) =>
                    p.Name === 'FromWarehouse' || p.Name === 'WarehouseCode',
                );

                if (
                  itemProp?.ValueAsObject === itemCode &&
                  warehouse?.ValueAsObject === batchWarehouse &&
                  (allocatedBatchsProp == null ||
                    allocatedBatchsProp === undefined ||
                    allocatedBatchsProp?.ValueAsObject == null ||
                    allocatedBatchsProp?.ValueAsObject === undefined ||
                    allocatedBatchsProp.ValueAsObject === '' ||
                    (this.enableBatchAllocation &&
                      allocatedBatchsProp != null &&
                      allocatedBatchsProp !== undefined &&
                      allocatedBatchsProp.ValueAsObject.toString().indexOf(
                        scanControl.value,
                      ) !== -1))
                ) {
                  if (
                    this.recordModel.ObjectKey !== 'InventoryCounting' &&
                    this.recordModel.ObjectKey !== 'oInventoryTransferRequest'
                  ) {
                    const quantityProp = properties.find(
                      (p) =>
                        p.Name === 'Quantity' || p.Name === 'PickedQuantity',
                    )?.ValueAsObject;
                    const openQtyProp = properties.find(
                      (p) =>
                        p.Name === 'OpenQty' || p.Name === 'ReleasedQuantity',
                    );
                    if (quantityProp === openQtyProp?.ValueAsObject) {
                      continue;
                    }
                  }
                  this.rowToWorkWith = this.lines[i];
                  found = true;
                  break;
                }
              }

              if (found) break;
            }

            let foundByBatch = false;
            //if (!this.rowToWorkWith) {
            for (let i = 0; i < this.lines.length; i++) {
              const batchToWorkWithProp = this.lines[i].Properties.find(
                (p) => p.Name === 'BatchNumber' || p.Name === 'BatchNum',
              );
              if (
                batchToWorkWithProp == null ||
                batchToWorkWithProp === undefined
              ) {
                break;
              }

              if (
                batchToWorkWithProp.Value.toLowerCase() === value.toLowerCase()
              ) {
                this.rowToWorkWith = this.lines[i];
                foundByBatch = true;
                break;
              }
            }
            //}

            // Secondary fallback if no match on warehouse
            if (!this.rowToWorkWith && !this.enableBatchAllocation) {
              this.rowToWorkWith =
                this.lines.find(
                  (line) =>
                    line.Properties.find((p) => p.Name === 'ItemCode')
                      ?.ValueAsObject === itemCode,
                ) || null;
            }

            this.isNew = false;

            if (
              !this.rowToWorkWith &&
              this.recordModel.ObjectKey === 'ITM_WMS_SSCC'
            ) {
              this.message.error(
                this.layoutService.translate(
                  "Can't find a product related to the scanned barcode.",
                ),
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              observer.error('No matching product found.');
              return;
            }

            if (!this.rowToWorkWith) {
              if (!itemCode || this.disableAddingNewLines) {
                this.message.error(
                  this.layoutService.translate(
                    "We couldn't find any result for the scanned value.",
                  ),
                  { nzDuration: 5000 },
                );
                this.playErrorVoice();
                observer.error('ItemCode not found.');
                return;
              }

              const confirmText = this.layoutService
                .translate(
                  `you scanned batch:_BATCH_CODE_ ,for item:_ITEM_CODE_ ,qty:_QTY_ do you want to continue?`,
                )
                .replace('_BATCH_CODE_', batchNumber)
                .replace('_QTY_', '' + this.batchNumberAvaQty)
                .replace('_ITEM_CODE_', itemCode);

              if (this.showConfirmationForNewBatch()) {
                this.modal.confirm({
                  nzTitle: confirmText,
                  nzContent: '',
                  nzOnOk: () => {
                    this.doExecuteScanOfBatchNew(
                      value,
                      itemCode,
                      batchNumber,
                      quantityControl,
                      batchWarehouse,
                    );
                    observer.next({ itemCode, batchNumber, newRow: true });
                    observer.complete();
                  },
                  nzOnCancel: () => {
                    this.resetScanFields(quantityControl, scanControl);
                    observer.error('Batch scan cancelled');
                  },
                });
              } else {
                this.doExecuteScanOfBatchNew(
                  value,
                  itemCode,
                  batchNumber,
                  quantityControl,
                  batchWarehouse,
                );
                observer.next({ itemCode, batchNumber, newRow: true });
                observer.complete();
              }
            } else {
              const confirmText = this.layoutService
                .translate(
                  `you scanned batch:_BATCH_CODE_ ,for item:_ITEM_CODE_ ,qty:_QTY_ do you want to continue?`,
                )
                .replace('_BATCH_CODE_', batchNumber)
                .replace('_QTY_', '' + this.batchNumberAvaQty)
                .replace('_ITEM_CODE_', itemCode);

              const validateWarehouse = () => {
                const warehouse = this.rowToWorkWith.Properties.find(
                  (p) => p.Name === 'WarehouseCode',
                )?.ValueAsObject;
                const fromwarehouse = this.rowToWorkWith.Properties.find(
                  (p) => p.Name === 'FromWarehouse',
                )?.ValueAsObject;

                if (
                  !foundByBatch &&
                  (((this.recordModel.ObjectKey === 'oStockTransfer' ||
                    this.recordModel.ObjectKey ===
                      'oInventoryTransferRequest') &&
                    batchWarehouse !== fromwarehouse) ||
                    (this.recordModel.ObjectKey !== 'oStockTransfer' &&
                      batchWarehouse !== warehouse)) &&
                  !this.isNew
                ) {
                  this.message.error(
                    this.layoutService.translate(
                      `The scanned value not belong to warehouse:`,
                    ) +
                      `${
                        this.recordModel.ObjectKey === 'oStockTransfer'
                          ? fromwarehouse
                          : warehouse
                      }`,
                    { nzDuration: 5000 },
                  );
                  this.playErrorVoice();
                  return false;
                }
                return true;
              };

              const finalize = () => {
                this.rowToWorkWith['ManBtchNum'] = 'Y';
                this.rowToWorkWith['ManSerNum'] = 'N';
                this.checkBinLocations();
                const comp = this;
                setTimeout(() => {
                  comp.checkBinLocations();
                }, 1000);

                const batchToWorkWithProp = this.rowToWorkWith.Properties.find(
                  (p) => p.Name === 'BatchNumber',
                );
                if (
                  this.recordModel.ObjectKey ===
                    'oPickLists' /* && another condition*/ &&
                  batchToWorkWithProp != null &&
                  batchToWorkWithProp !== undefined &&
                  batchToWorkWithProp.Value !== ''
                ) {
                  this.batchScanFieldVisible = true;
                  setTimeout(() => {
                    this.scanBatchControl.nativeElement.value = value;
                    this.executeScanOfBatchAfterItem(
                      this.scanBatchControl.nativeElement,
                      quantityControl,
                    );
                    //this.scanBinControl.nativeElement.focus();
                  }, 1000);
                } else {
                  this.scannedQty = null;
                  this.batchNumber = d[0].BatchNum;
                  setTimeout(
                    () =>
                      this.focusAfterScan(scanControl, value, quantityControl),
                    1000,
                  );
                }
              };

              if (this.showConfirmationForNewBatch()) {
                this.modal.confirm({
                  nzTitle: confirmText,
                  nzContent: '',
                  nzOnOk: () => {
                    if (validateWarehouse()) {
                      finalize();
                      observer.next({ itemCode, batchNumber, newRow: false });
                      observer.complete();
                    } else {
                      observer.error('Invalid warehouse');
                    }
                  },
                  nzOnCancel: () => {
                    this.resetScanFields(quantityControl, scanControl);
                    observer.error('Batch scan cancelled');
                  },
                });
              } else {
                if (validateWarehouse()) {
                  finalize();
                  observer.next({ itemCode, batchNumber, newRow: false });
                  observer.complete();
                } else {
                  observer.error('Invalid warehouse');
                }
              }
            }
          },
          error: (err) => {
            this.message.error('Error retrieving batch number details', {
              nzDuration: 5000,
            });
            this.playErrorVoice();
            observer.error(err);
          },
        });
    });
  }

  /*executeScanOfBatch(scanControl, quantityControl) {
    this.inventoryService
      .getBatchNumberDetailsAfterScan(
        scanControl.value,
        this.moduleStructure.module.ObjectType === 'InventoryCounting' ||
          this.moduleStructure.module.ObjectType === 'oReturns'
      )
      .subscribe((d: any[]) => {
        this.rowToWorkWith = null;

        let itemCode = '';
        let batchNumber = '';
        this.batchNumberAvaQty = 0;
        let batchWarehouse = '';

        for (let index = 0; index < d.length; index++) {
          let found = false;
          itemCode = d[index]['ItemCode'];
          batchNumber =
            d[index].BatchNum === undefined
              ? d[index].DistNumber
              : d[index].BatchNum;
          this.batchNumberAvaQty = d[index].AvaQuantity;
          batchWarehouse = d[index].WhsCode;

          for (let i = 0; i < this.lines.length; i++) {
            const properties = this.lines[i].Properties;
            const itemProp = properties.find((p) => p.Name === 'ItemCode');
            const warehouse = properties.find(
              (p) => p.Name === 'FromWarehouse' || p.Name === 'WarehouseCode'
            );

            if (
              itemProp != null &&
              itemProp !== undefined &&
              itemCode === itemProp.ValueAsObject &&
              warehouse != null &&
              warehouse !== undefined &&
              batchWarehouse === warehouse.ValueAsObject
            ) {
              if (
                this.recordModel.ObjectKey !== 'InventoryCounting' &&
                this.recordModel.ObjectKey !== 'oInventoryTransferRequest'
              ) {
                const quantityProp = properties.find(
                  (p) => p.Name === 'Quantity' || p.Name === 'PickedQuantity'
                ).ValueAsObject;
                const openQtyProp = properties.find(
                  (p) => p.Name === 'OpenQty' || p.Name === 'ReleasedQuantity'
                );
                if (
                  openQtyProp != null &&
                  openQtyProp !== undefined &&
                  quantityProp === openQtyProp.ValueAsObject
                ) {
                  continue;
                }
              }
              this.rowToWorkWith = this.lines[i];
              found = true;
              break;
            }
          }

          if (found) {
            break;
          }
        }

        if (this.rowToWorkWith === null) {
          for (let i = 0; i < this.lines.length; i++) {
            const properties = this.lines[i].Properties;
            const itemProp = properties.find((p) => p.Name === 'ItemCode');

            if (
              itemProp != null &&
              itemProp !== undefined &&
              itemCode === itemProp.ValueAsObject
            ) {
              this.rowToWorkWith = this.lines[i];
              break;
            }
          }
        }

        this.isNew = false;
        if (
          this.rowToWorkWith === null &&
          this.recordModel.ObjectKey === 'ITM_WMS_SSCC'
        ) {
          this.message.error(
            this.layoutService.translate(
              "Can't find a product related to the scanned barcode."
            )
          );
          this.playErrorVoice();
          return;
        }
        if (this.rowToWorkWith === null) {
          if (itemCode == null || itemCode === undefined || itemCode === '') {
            this.message.error(
              this.layoutService.translate(
                "We couldn't find any result for the scanned value."
              )
            );
            this.playErrorVoice();
            return;
          }
          if (this.showConfirmationForNewBatch()) {
            this.modal.confirm({
              nzTitle: this.layoutService
                .translate(
                  `you scanned batch:_BATCH_CODE_ ,for item:_ITEM_CODE_ ,qty:_QTY_ do you want to continue?`
                )
                .replace('_BATCH_CODE_', batchNumber)
                .replace('_QTY_', '' + this.batchNumberAvaQty)
                .replace('_ITEM_CODE_', itemCode),
              nzContent: '',
              nzOnOk: () => {
                this.doExecuteScanOfBatchNew(
                  itemCode,
                  batchNumber,
                  quantityControl,
                  batchWarehouse
                );
              },
              nzOnCancel: () => {
                this.resetScanFields(quantityControl, scanControl);
              },
            });
          } else {
            this.doExecuteScanOfBatchNew(
              itemCode,
              batchNumber,
              quantityControl,
              batchWarehouse
            );
          }
        } else {
          if (this.showConfirmationForNewBatch()) {
            this.modal.confirm({
              nzTitle: this.layoutService
                .translate(
                  `you scanned batch:_BATCH_CODE_ ,for item:_ITEM_CODE_ ,qty:_QTY_ do you want to continue?`
                )
                .replace('_BATCH_CODE_', batchNumber)
                .replace('_QTY_', '' + this.batchNumberAvaQty)
                .replace('_ITEM_CODE_', itemCode),
              nzContent: '',
              nzOnOk: () => {
                const warehouse = this.rowToWorkWith.Properties.find(
                  (p) => p.Name === 'WarehouseCode'
                ).ValueAsObject;

                const fromwarehouse = this.rowToWorkWith.Properties.find(
                  (p) => p.Name === 'FromWarehouse'
                )?.ValueAsObject;

                if (
                  (((this.recordModel.ObjectKey === 'oStockTransfer' ||
                    this.recordModel.ObjectKey ===
                      'oInventoryTransferRequest') &&
                    batchWarehouse != fromwarehouse) ||
                    (this.recordModel.ObjectKey !== 'oStockTransfer' &&
                      batchWarehouse != warehouse)) &&
                  !this.isNew
                ) {
                  this.message.error(
                    this.layoutService.translate(
                      `The scanned value not belong to warehouse:`
                    ) +
                      `${
                        this.recordModel.ObjectKey === 'oStockTransfer'
                          ? fromwarehouse
                          : warehouse
                      }`
                  );
                  this.playErrorVoice();
                  return;
                }

                this.rowToWorkWith['ManBtchNum'] = 'Y';
                this.rowToWorkWith['ManSerNum'] = 'N';

                this.checkBinLocations();

                this.scannedQty = null;
                this.batchNumber = d[0].BatchNum;
                const comp = this;
                setTimeout(function () {
                  comp.focusAfterScan(quantityControl);
                }, 1000);
              },
              nzOnCancel: () => {
                this.resetScanFields(quantityControl, scanControl);
              },
            });
          } else {
            const warehouse = this.rowToWorkWith.Properties.find(
              (p) => p.Name === 'WarehouseCode'
            ).ValueAsObject;

            const fromwarehouse = this.rowToWorkWith.Properties.find(
              (p) => p.Name === 'FromWarehouse'
            )?.ValueAsObject;

            if (
              (((this.recordModel.ObjectKey === 'oStockTransfer' ||
                this.recordModel.ObjectKey === 'oInventoryTransferRequest') &&
                batchWarehouse != fromwarehouse) ||
                (this.recordModel.ObjectKey !== 'oStockTransfer' &&
                  batchWarehouse != warehouse)) &&
              !this.isNew
            ) {
              this.message.error(
                this.layoutService.translate(
                  `The scanned value not belong to warehouse:`
                ) +
                  `${
                    this.recordModel.ObjectKey === 'oStockTransfer'
                      ? fromwarehouse
                      : warehouse
                  }`
              );
              this.playErrorVoice();
              return;
            }

            this.rowToWorkWith['ManBtchNum'] = 'Y';
            this.rowToWorkWith['ManSerNum'] = 'N';

            this.checkBinLocations();

            this.scannedQty = null;
            this.batchNumber = d[0].BatchNum;
            const comp = this;
            setTimeout(function () {
              comp.focusAfterScan(quantityControl);
            }, 1000);
          }
        }
      });
  }*/

  // executeScanOfSSCC(scanControl, quantityControl, serialNumberControl) {
  //   let qtyProp = 'Quantity';
  //   let openQty = 'OpenQty';
  //   if (this.recordModel.ObjectKey === 'oPickLists') {
  //     qtyProp = 'PickedQuantity';
  //     openQty = 'ReleasedQuantity';
  //   }

  //   this.inventoryService
  //     .getSSCCDetailsAfterScan(scanControl.value)
  //     .subscribe((rows: any[]) => {
  //       if (rows.length == 0) {
  //         this.message.error(
  //           this.layoutService.translate(`The scanned SSCC is not available`)
  //         );
  //         this.playErrorVoice();
  //         return;
  //       }
  //       if (rows.length === 1) {
  //         if (rows[0].ManBtchNum === 'Y') {
  //           scanControl.value = rows[0].DistNumber;
  //           this.executeScan(scanControl, quantityControl, serialNumberControl);
  //           return;
  //         } else if (rows[0].ManSerNum === 'Y') {
  //           scanControl.value = rows[0].DistNumber;
  //           this.executeScan(scanControl, quantityControl, serialNumberControl);
  //           return;
  //         }
  //       }

  //       for (
  //         let i = 0;
  //         i < rows.length;
  //         i++ //rows.forEach((row) =>
  //       ) {
  //         let row = rows[i];
  //         this.rowToWorkWith = undefined;
  //         const itemCode = row.ItemCode;
  //         for (const sourceLine of this.lines) {
  //           if (
  //             itemCode ===
  //             sourceLine.Properties.find((p) => p.Name === 'ItemCode')
  //               .ValueAsObject
  //           ) {
  //             if (
  //               sourceLine.Properties.find((p) => p.Name === qtyProp)
  //                 .ValueAsObject ===
  //                 sourceLine.Properties.find((p) => p.Name === openQty)
  //                   .ValueAsObject ||
  //               sourceLine.Properties.find((p) => p.Name === openQty)
  //                 .ValueAsObject === 0
  //             ) {
  //               continue;
  //             } else {
  //               this.rowToWorkWith = sourceLine;
  //             }
  //           }
  //         }

  //         if (this.rowToWorkWith === null || this.rowToWorkWith === undefined) {
  //           this.message.create(
  //             this.layoutService.translate('warning'),
  //             this.layoutService.translate(
  //               `Unable to find lines to use with the scanned barcode, or you scanned enough quantity already.`
  //             )
  //           );
  //           return;
  //         }

  //         if (row.ManBtchNum === 'Y') {
  //           let serials = this.rowToWorkWith.Properties.find(
  //             (p) => p.Name === 'ITMSerialNumber'
  //           ).ValueAsObject;
  //           let numPerSale = 0;
  //           if (
  //             this.rowToWorkWith.Properties.find(
  //               (p) => p.Name === 'UnitsOfMeasurment'
  //             ) === undefined
  //           ) {
  //             numPerSale = 1;
  //           } else {
  //             numPerSale = this.rowToWorkWith.Properties.find(
  //               (p) => p.Name === 'UnitsOfMeasurment'
  //             ).ValueAsObject;
  //           }

  //           if (serials === '' || serials === undefined) {
  //             serials = JSON.stringify({
  //               BatchNumber: row.DistNumber,
  //               Quantity: Number(row.Quantity) /* * Number(numPerSale) */,
  //               BaseQuantity: 1,
  //               BasePerc: Number(numPerSale),
  //               U_ITM_WMS_SSCC: scanControl.value,
  //             });
  //           } else {
  //             serials +=
  //               ',' +
  //               JSON.stringify({
  //                 BatchNumber: row.DistNumber,
  //                 Quantity: Number(row.Quantity) /* * Number(numPerSale) */,
  //                 BaseQuantity: 1,
  //                 BasePerc: Number(numPerSale),
  //                 U_ITM_WMS_SSCC: scanControl.value,
  //               });
  //           }

  //           this.rowToWorkWith.Properties.find(
  //             (p) => p.Name === 'ITMSerialNumber'
  //           ).ValueAsObject = serials;
  //           this.rowToWorkWith.Properties.find(
  //             (p) => p.Name === qtyProp
  //           ).ValueAsObject =
  //             Number(
  //               this.rowToWorkWith.Properties.find((p) => p.Name === qtyProp)
  //                 .ValueAsObject
  //             ) + Number(row.Quantity / numPerSale);
  //         } else if (row.ManSerNum === 'Y') {
  //           let serials = this.rowToWorkWith.Properties.find(
  //             (p) => p.Name === 'ITMSerialNumber'
  //           ).ValueAsObject;
  //           if (serials === '' || serials === undefined) {
  //             scanControl.value = row.DistNumber;
  //             this.executeScan(
  //               scanControl,
  //               quantityControl,
  //               serialNumberControl
  //             );
  //             return;
  //           } else {
  //             const selectedSerialNumbers = [];
  //             if (!serials.toString().includes(',')) {
  //               if (!serials.toString().includes('|')) {
  //                 selectedSerialNumbers.push({
  //                   AbsEntry: Number(serials),
  //                 });
  //               } else {
  //                 selectedSerialNumbers.push({
  //                   AbsEntry: Number(serials.toString().split('|')[0]),
  //                   BinLocation: Number(serials.toString().split('|')[1]),
  //                 });
  //               }
  //             } else {
  //               serials
  //                 .toString()
  //                 .split(',')
  //                 .forEach((f) => {
  //                   if (f.includes('|')) {
  //                     selectedSerialNumbers.push({
  //                       AbsEntry: Number(f.split('|')[0]),
  //                       BinLocation: Number(f.split('|')[1]),
  //                     });
  //                   } else {
  //                     selectedSerialNumbers.push({
  //                       AbsEntry: Number(f),
  //                     });
  //                   }
  //                 });
  //             }

  //             const existingSerial = selectedSerialNumbers.find((sn) => {
  //               if (sn.AbsEntry === row.AbsEntry) {
  //                 return sn;
  //               }
  //             });
  //             if (existingSerial !== undefined && i < rows.length - 1) {
  //               continue;
  //             } else if (existingSerial !== undefined && i == rows.length - 1) {
  //               this.message.error(
  //                 this.layoutService.translate(
  //                   `All available serials in the SSCC are scanned`
  //                 )
  //               );
  //               this.playErrorVoice();
  //               return;
  //             } else {
  //               scanControl.value = row.DistNumber;
  //               this.executeScan(
  //                 scanControl,
  //                 quantityControl,
  //                 serialNumberControl
  //               );
  //               return;
  //             }
  //           }
  //           /*if (serials === '' || serials === undefined) {
  //             serials = row.AbsEntry;
  //           } else {
  //             serials += ',' + row.AbsEntry;
  //           }

  //           this.rowToWorkWith.Properties.find(
  //             (p) => p.Name === 'ITMSerialNumber'
  //           ).ValueAsObject = serials;
  //           this.rowToWorkWith.Properties.find(
  //             (p) => p.Name === qtyProp
  //           ).ValueAsObject += 1;*/
  //         } else {
  //           this.rowToWorkWith.Properties.find(
  //             (p) => p.Name === qtyProp
  //           ).ValueAsObject += 1;
  //         }
  //       }
  //       //);

  //       const s = this.rowToWorkWith.Properties.find(
  //         (p) => p.Name === 'ITMSerialNumber'
  //       ).ValueAsObject;

  //       this.rowToWorkWith = undefined;
  //       this.serialNumber = undefined;
  //       this.scannedQty = undefined;
  //       setTimeout(() => {
  //         scanControl.value = '';
  //         scanControl.disabled = false;
  //         scanControl.focus();
  //         this.shouldFocusOnScanControl = true;
  //       }, 100);
  //     });
  // }
  executeScanOfSSCC(
    value,
    scanControl: FormControl,
    quantityControl: FormControl,
    serialNumberControl: FormControl,
  ): Observable<any> {
    return new Observable((observer) => {
      let qtyProp = 'Quantity';
      let openQty = 'OpenQty';
      if (this.recordModel.ObjectKey === 'oPickLists') {
        qtyProp = 'PickedQuantity';
        openQty = 'ReleasedQuantity';
      }

      this.inventoryService
        .getSSCCDetailsAfterScan(value)
        //.getSSCCDetailsAfterScan(scanControl.value)
        .subscribe({
          next: (rows: any[]) => {
            if (rows.length === 0) {
              this.message.error(
                this.layoutService.translate(
                  `The scanned SSCC is not available`,
                ),
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              observer.error('SSCC not available');
              return;
            }

            if (
              rows.length === 1 &&
              (rows[0].ManBtchNum === 'Y' || rows[0].ManSerNum === 'Y')
            ) {
              //scanControl.value = rows[0].DistNumber;
              scanControl.setValue(rows[0].DistNumber);
              this.executeScan(
                scanControl,
                quantityControl,
                serialNumberControl,
              );
              observer.next('Redirected to item/serial scan');
              observer.complete();
              return;
            }

            for (let i = 0; i < rows.length; i++) {
              const row = rows[i];
              this.rowToWorkWith = undefined;
              const itemCode = row.ItemCode;

              for (const sourceLine of this.lines) {
                const itemMatch =
                  itemCode ===
                  sourceLine.Properties.find((p) => p.Name === 'ItemCode')
                    ?.ValueAsObject;
                if (!itemMatch) continue;

                const qtyVal = sourceLine.Properties.find(
                  (p) => p.Name === qtyProp,
                )?.ValueAsObject;
                const openQtyVal = sourceLine.Properties.find(
                  (p) => p.Name === openQty,
                )?.ValueAsObject;

                if (qtyVal === openQtyVal || openQtyVal === 0) continue;

                this.rowToWorkWith = sourceLine;
                break;
              }

              if (!this.rowToWorkWith) {
                this.message.create(
                  this.layoutService.translate('warning'),
                  this.layoutService.translate(
                    `Unable to find lines to use with the scanned barcode, or you scanned enough quantity already.`,
                  ),
                  { nzDuration: 5000 },
                );
                observer.error('No usable line for SSCC row');
                return;
              }

              if (row.ManBtchNum === 'Y') {
                const numPerSale =
                  this.rowToWorkWith.Properties.find(
                    (p) => p.Name === 'UnitsOfMeasurment',
                  )?.ValueAsObject || 1;
                let serials =
                  this.rowToWorkWith.Properties.find(
                    (p) => p.Name === 'ITMSerialNumber',
                  )?.ValueAsObject || '';
                const entry = JSON.stringify({
                  BatchNumber: row.DistNumber,
                  Quantity: Number(row.Quantity),
                  BaseQuantity: 1,
                  BasePerc: Number(numPerSale),
                  U_ITM_WMS_SSCC: scanControl.value,
                });
                serials = serials ? `${serials},${entry}` : entry;
                this.rowToWorkWith.Properties.find(
                  (p) => p.Name === 'ITMSerialNumber',
                ).ValueAsObject = serials;
                this.rowToWorkWith.Properties.find(
                  (p) => p.Name === qtyProp,
                ).ValueAsObject += Number(row.Quantity / numPerSale);
              } else if (row.ManSerNum === 'Y') {
                let serials = this.rowToWorkWith.Properties.find(
                  (p) => p.Name === 'ITMSerialNumber',
                )?.ValueAsObject;

                if (!serials) {
                  //scanControl.value = row.DistNumber;
                  scanControl.setValue(row.DistNumber);
                  this.executeScan(
                    scanControl,
                    quantityControl,
                    serialNumberControl,
                  );
                  observer.next('Redirected to serial scan');
                  observer.complete();
                  return;
                }

                const selectedSerialNumbers = serials
                  .toString()
                  .split(',')
                  .map((f) => {
                    if (f.includes('|')) {
                      const [abs, bin] = f.split('|');
                      return {
                        AbsEntry: Number(abs),
                        BinLocation: Number(bin),
                      };
                    } else {
                      return { AbsEntry: Number(f) };
                    }
                  });

                const exists = selectedSerialNumbers.some(
                  (sn) => sn.AbsEntry === row.AbsEntry,
                );

                if (exists && i < rows.length - 1) continue;

                if (exists && i === rows.length - 1) {
                  this.message.error(
                    this.layoutService.translate(
                      `All available serials in the SSCC are scanned`,
                    ),
                    { nzDuration: 5000 },
                  );
                  this.playErrorVoice();
                  observer.error('Serials already scanned');
                  return;
                }

                //scanControl.value = row.DistNumber;
                scanControl.setValue(row.DistNumber);
                this.executeScan(
                  scanControl,
                  quantityControl,
                  serialNumberControl,
                );
                observer.next('Redirected to new serial scan');
                observer.complete();
                return;
              } else {
                this.rowToWorkWith.Properties.find(
                  (p) => p.Name === qtyProp,
                ).ValueAsObject += 1;
              }
            }

            this.rowToWorkWith = undefined;
            this.serialNumber = undefined;
            this.scannedQty = undefined;
            setTimeout(() => {
              this.resetScanFields(undefined, scanControl);
            }, 100);

            observer.next('SSCC scan processed');
            observer.complete();
          },
          error: (err) => {
            this.message.error(
              this.layoutService.translate('Error during SSCC scan'),
              { nzDuration: 5000 },
            );
            this.playErrorVoice();
            observer.error(err);
          },
        });
    });
  }

  executeScanOfBarCode(
    value,
    scanControl: FormControl,
    quantityControl: FormControl,
    serialNumberControl: FormControl,
  ): Observable<any> {
    this.allowAddNewItemsInPackage = g.allowAddNewItemsInPackage;
    return new Observable((observer) => {
      this.layoutService.executeQuery(2755, { Barcode: value }).subscribe({
        next: (d) => {
          const itemCode = d[0].ItemCode;

          if (this.recordModel.ObjectKey === 'ITM_WMS_NON_PRDUCD') {
            const scannedBarcode = value;
            //scanControl.value = itemCode;
            this.executeScanOfItem(
              itemCode,
              scanControl,
              quantityControl,
              serialNumberControl,
              scannedBarcode,
            ).subscribe({
              next: (res) => {
                observer.next(res);
                observer.complete();
              },
              error: (err) => observer.error(err),
            });
            return;
          }

          const uomEntry = d[0].UomEntry;
          let lineToWorkOn =
            this.lines.find(
              (line) =>
                line.Properties.find((p) => p.Name === 'ItemCode')
                  ?.ValueAsObject === itemCode &&
                line.Properties.find((p) => p.Name === 'UoMEntry')
                  ?.ValueAsObject === uomEntry,
            ) ||
            this.lines.find(
              (line) =>
                line.Properties.find((p) => p.Name === 'ItemCode')
                  ?.ValueAsObject === itemCode,
            );

          if (lineToWorkOn !== undefined) {
            this.rowToWorkWith = lineToWorkOn;
            this.inventoryService
              .getItemNumberDetailsAfterScan(itemCode)
              .subscribe({
                next: (itemDetails) => {
                  const managedByBatch = itemDetails[0].ManBtchNum;
                  const managedBySerial = itemDetails[0].ManSerNum;

                  // Re-assign matching row
                  this.rowToWorkWith =
                    this.lines.find((line) => {
                      const itemProp = line.Properties.find(
                        (p) => p.Name === 'ItemCode',
                      );
                      if (!itemProp || itemProp.ValueAsObject !== itemCode)
                        return false;
                      if (this.recordModel.ObjectKey !== 'InventoryCounting') {
                        const qty = line.Properties.find(
                          (p) =>
                            p.Name === 'Quantity' ||
                            p.Name === 'PickedQuantity',
                        )?.ValueAsObject;
                        const openQty = line.Properties.find(
                          (p) =>
                            p.Name === 'OpenQty' ||
                            p.Name === 'ReleasedQuantity',
                        )?.ValueAsObject;
                        return qty !== openQty;
                      }
                      return true;
                    }) ||
                    this.lines.find(
                      (line) =>
                        line.Properties.find((p) => p.Name === 'ItemCode')
                          ?.ValueAsObject === itemCode,
                    );

                  this.isNew = false;
                  if (!this.rowToWorkWith) {
                    if (this.recordModel.ObjectKey === 'oPickLists') {
                      this.message.error(
                        this.layoutService.translate(
                          "We couldn't find any result for the scanned value.",
                        ),
                        { nzDuration: 5000 },
                      );
                      this.playErrorVoice();
                      this.resetScanFields(quantityControl, scanControl);
                      observer.error('Row not found for scanned barcode');
                      return;
                    }
                    this.addLineToTable();
                    const itemCodeEle = this.lines[
                      this.lines.length - 1
                    ].Properties.find((p) => p.Name === 'ItemCode');

                    this.layoutService
                      .getModuleHeaderData(4, itemCode, '', false)
                      .subscribe({
                        next: (headerData) => {
                          this.moduleStructure.module.Sections.forEach(
                            (section) => {
                              if (
                                [
                                  'Document_Lines',
                                  'StockTransfer_Lines',
                                  'InventoryCountingLines|InventoryCountingLine',
                                ].includes(section.XmlTagName)
                              ) {
                                section.Fields.forEach((field) => {
                                  if (field.LinkedModule === '4') {
                                    const value = headerData[field.LinkedField];
                                    this.lines[
                                      this.lines.length - 1
                                    ].Properties.forEach((property) => {
                                      if (
                                        property.Name === field.PropertyName
                                      ) {
                                        property.ValueAsObject = value;
                                        this.layoutService.triggerFieldValueChanged(
                                          {
                                            recordProperty: property,
                                            formId: '',
                                            line: this.lines[
                                              this.lines.length - 1
                                            ].Id,
                                            recordModel: this.recordModel,
                                            sectionTagName: section.XmlTagName,
                                            moduleStructure:
                                              this.moduleStructure,
                                          },
                                        );
                                      }
                                    });
                                  }
                                });
                              }
                            },
                          );

                          this.rowToWorkWith =
                            this.lines[this.lines.length - 1];
                          this.isNew = true;
                          this.rowToWorkWith['isNew'] = true;
                          if (
                            this.checkDONTDisplayNotificationForNewItemRule()
                          ) {
                            this.notificationService.create(
                              'warning',
                              this.layoutService.translate(
                                'You are going to add a new item #' + itemCode,
                              ),
                              '',
                            );
                          }

                          this.handleBarcodeItemMode(
                            value,
                            managedByBatch,
                            managedBySerial,
                            quantityControl,
                            scanControl,
                          );
                          observer.next({ itemCode, newRow: true });
                          observer.complete();
                        },
                        error: (err) => observer.error(err),
                      });
                  } else {
                    this.handleBarcodeItemMode(
                      value,
                      managedByBatch,
                      managedBySerial,
                      quantityControl,
                      scanControl,
                    );
                    observer.next({ itemCode, newRow: false });
                    observer.complete();
                  }
                },
                error: (err) => observer.error(err),
              });
          } else if (
            itemCode &&
            (this.moduleStructure.module.AdditionalInformationParsed
              ?.InventoryDirection === this.InventoryDirection.Inbound ||
              this.parentComponent.moduleActionType === undefined ||
              this.parentComponent.moduleActionType?.toString() === '-1' ||
              (this.recordModel.ObjectKey === 'ITM_WMS_SSCC' &&
                this.allowAddNewItemsInPackage))
          ) {
            const scannedBarcode = value;
            //scanControl.value = itemCode;
            this.executeScanOfItem(
              itemCode,
              scanControl,
              quantityControl,
              serialNumberControl,
              scannedBarcode,
            ).subscribe({
              next: (res) => {
                observer.next(res);
                observer.complete();
              },
              error: (err) => observer.error(err),
            });
          } else {
            this.message.error(
              this.layoutService.translate(
                "Can't find a product related to the scanned barcode.",
              ),
              { nzDuration: 5000 },
            );
            this.playErrorVoice();
            this.resetScanFields(quantityControl, scanControl);
            observer.error('Unrecognized barcode');
          }
        },
        error: (err) => observer.error(err),
      });
    });
  }

  handleBarcodeItemMode(
    scannedValue,
    managedByBatch: string,
    managedBySerial: string,
    quantityControl: AbstractControl,
    scanControl: AbstractControl,
  ) {
    this.checkBinLocations();
    const comp = this;
    setTimeout(
      () => comp.focusAfterScan(scanControl, scannedValue, quantityControl),
      1000,
    );

    if (managedBySerial === 'Y') {
      this.rowToWorkWith['ManBtchNum'] = 'N';
      this.rowToWorkWith['ManSerNum'] = 'Y';
      this.scannedQty = undefined;
    } else if (managedByBatch === 'Y') {
      this.rowToWorkWith['ManBtchNum'] = 'Y';
      this.rowToWorkWith['ManSerNum'] = 'N';
      this.scannedQty = undefined;
    } else {
      this.rowToWorkWith['ManBtchNum'] = 'N';
      this.rowToWorkWith['ManSerNum'] = 'N';

      if (this.rowToWorkWith['ScannedQty'] === undefined) {
        this.rowToWorkWith['ScannedQty'] = 0;
      }

      if (this.autoIncrease) {
        let qtyProp = this.rowToWorkWith.Properties.find(
          (p) => p.Name === 'Quantity',
        );

        if (
          this.recordModel.ObjectKey === 'InventoryCounting' ||
          this.recordModel.ObjectKey === 'InventoryPosting'
        ) {
          qtyProp = this.rowToWorkWith.Properties.find(
            (p) => p.Name === 'UoMCountedQuantity',
          );
        }

        if (!this.isNew) {
          qtyProp.ValueAsObject = Number(qtyProp.ValueAsObject) + 1;
        }
        // to be checked later
        //this.resetScanFields(quantityControl, scanControl);
        this.resetQuantityFields(quantityControl);
      }
    }
  }

  //   executeScanOfBarCode(scanControl, quantityControl, serialNumberControl) {
  //     this.layoutService
  //       .executeQuery(2755, { Barcode: scanControl.value })
  //       .subscribe((d) => {
  //         const itemCode = d[0].ItemCode;

  //         if (this.recordModel.ObjectKey === 'ITM_WMS_NON_PRDUCD') {
  //           const scannedBarcode = scanControl.value;
  //           scanControl.value = itemCode;
  //           this.executeScanOfItem(
  //             scanControl,
  //             quantityControl,
  //             serialNumberControl,
  //             scannedBarcode
  //           );
  //           return;
  //         }

  //         const uomEntry = d[0].UomEntry;
  //         let lineToWorkOn: RecordLine;

  //         for (const line of this.lines) {
  //           const itemCodeProp = line.Properties.find(
  //             (p) => p.Name === 'ItemCode'
  //           );
  //           const uomEntryProp = line.Properties.find(
  //             (p) => p.Name === 'UoMEntry'
  //           );

  //           if (
  //             itemCodeProp.ValueAsObject === itemCode &&
  //             uomEntryProp.ValueAsObject === d[0].UomEntry
  //           ) {
  //             lineToWorkOn = line;
  //           }
  //         }

  //         if (lineToWorkOn === undefined) {
  //           for (const line of this.lines) {
  //             const itemCodeProp = line.Properties.find(
  //               (p) => p.Name === 'ItemCode'
  //             );

  //             if (itemCodeProp.ValueAsObject === itemCode) {
  //               lineToWorkOn = line;
  //             }
  //           }
  //         }

  //         if (lineToWorkOn !== undefined) {
  //           this.rowToWorkWith = lineToWorkOn;
  //           this.inventoryService
  //             .getItemNumberDetailsAfterScan(itemCode)
  //             .subscribe((itemDetails) => {
  //               const managedByBatch = itemDetails[0].ManBtchNum;
  //               const managedBySerial = itemDetails[0].ManSerNum;
  //               this.rowToWorkWith = null;

  //               const itemCode = d[0]['ItemCode'];
  //               for (let i = 0; i < this.lines.length; i++) {
  //                 const properties = this.lines[i].Properties;
  //                 const itemProp = properties.find((p) => p.Name === 'ItemCode');

  //                 if (
  //                   itemProp != null &&
  //                   itemProp !== undefined &&
  //                   itemCode === itemProp.ValueAsObject
  //                 ) {
  //                   if (this.recordModel.ObjectKey !== 'InventoryCounting') {
  //                     const quantityProp = properties.find(
  //                       (p) => p.Name === 'Quantity' || p.Name == 'PickedQuantity'
  //                     ).ValueAsObject;
  //                     const openQtyProp = properties.find(
  //                       (p) =>
  //                         p.Name === 'OpenQty' || p.Name == 'ReleasedQuantity'
  //                     ).ValueAsObject;
  //                     if (quantityProp === openQtyProp) {
  //                       continue;
  //                     }
  //                   }
  //                   this.rowToWorkWith = this.lines[i];
  //                   break;
  //                 }
  //               }

  //               if (this.rowToWorkWith === null) {
  //                 for (let i = 0; i < this.lines.length; i++) {
  //                   const properties = this.lines[i].Properties;
  //                   const itemProp = properties.find(
  //                     (p) => p.Name === 'ItemCode'
  //                   );

  //                   if (
  //                     itemProp != null &&
  //                     itemProp !== undefined &&
  //                     itemCode === itemProp.ValueAsObject
  //                   ) {
  //                     this.rowToWorkWith = this.lines[i];
  //                     break;
  //                   }
  //                 }
  //               }

  //               this.isNew = false;
  //               if (this.rowToWorkWith === null) {
  //                 if (this.recordModel.ObjectKey === 'oPickLists') {
  //                   this.message.error(
  //                     this.layoutService.translate(
  //                       `We couldn't find any result for the scanned value ${value}. `
  //                     )
  //                   );
  //                   this.playErrorVoice();
  //                   this.resetScanFields(quantityControl, scanControl);
  //                   return;
  //                 }
  //                 this.addLineToTable();
  //                 const itemCodeEle = this.lines[
  //                   this.lines.length - 1
  //                 ].Properties.find((p) => p.Name === 'ItemCode');

  //                 this.layoutService
  //                   .getModuleHeaderData(4, itemCode, '', false)
  //                   .subscribe((d) => {
  //                     this.moduleStructure.module.Sections.forEach((section) => {
  //                       if (
  //                         section.XmlTagName === 'Document_Lines' ||
  //                         section.XmlTagName === 'StockTransfer_Lines' ||
  //                         section.XmlTagName ===
  //                           'InventoryCountingLines|InventoryCountingLine'
  //                       ) {
  //                         section.Fields.forEach((field) => {
  //                           if (field.LinkedModule === '4') {
  //                             const value = d[field.LinkedField];

  //                             this.lines[
  //                               this.lines.length - 1
  //                             ].Properties.forEach((property) => {
  //                               if (property.Name === field.PropertyName) {
  //                                 property.ValueAsObject = value;
  //                                 this.layoutService.triggerFieldValueChanged({
  //                                   recordProperty: property,
  //                                   formId: '',
  //                                   line: this.lines[this.lines.length - 1].Id,
  //                                   recordModel: this.recordModel,
  //                                   sectionTagName: section.XmlTagName,
  //                                   moduleStructure: this.moduleStructure,
  //                                 });
  //                               }
  //                             });
  //                           }
  //                         });
  //                       }
  //                     });
  //                     this.rowToWorkWith = this.lines[this.lines.length - 1];
  //                     this.isNew = true;

  //                     this.notificationService.create(
  //                       'warning',
  //                       this.layoutService.translate(
  //                         'You are going to add a new item #' + itemCode
  //                       ),
  //                       ''
  //                     );

  //                     this.rowToWorkWith['isNew'] = true;

  //                     if (managedBySerial === 'Y') {
  //                       this.rowToWorkWith['ManBtchNum'] = 'N';
  //                       this.rowToWorkWith['ManSerNum'] = 'Y';
  //                       //this.scannedQty = 1;

  //                       this.checkBinLocations();

  //                       /*setTimeout(function () {
  //                   serialNumberControl.focus();
  //                 }, 200);*/

  //                       this.scannedQty = undefined;
  //                       const comp = this;

  //                       setTimeout(function () {
  //                         comp.focusAfterScan(quantityControl);
  //                       }, 1000);
  //                     } else if (managedByBatch === 'Y') {
  //                       this.rowToWorkWith['ManBtchNum'] = 'Y';
  //                       this.rowToWorkWith['ManSerNum'] = 'N';

  //                       this.checkBinLocations();

  //                       this.scannedQty = undefined;
  //                       const comp = this;
  //                       setTimeout(function () {
  //                         comp.focusAfterScan(quantityControl);
  //                       }, 1000);
  //                     } else {
  //                       this.rowToWorkWith['ManBtchNum'] = 'N';
  //                       this.rowToWorkWith['ManSerNum'] = 'N';

  //                       if (this.rowToWorkWith['ScannedQty'] === undefined) {
  //                         this.rowToWorkWith['ScannedQty'] = 0;
  //                       }

  //                       if (this.autoIncrease) {
  //                         const qtyProp = this.rowToWorkWith.Properties.find(
  //                           (p) => p.Name === 'Quantity'
  //                         );

  //                         if (!this.isNew) {
  //                           qtyProp.ValueAsObject =
  //                             Number(qtyProp.ValueAsObject) + 1;
  //                         }

  //                         this.resetScanFields(quantityControl, scanControl);
  //                       } else {
  //                         this.checkBinLocations();
  //                         const comp = this;
  //                         setTimeout(function () {
  //                           comp.focusAfterScan(quantityControl);
  //                         }, 1000);
  //                       }
  //                     }
  //                   });
  //               } else {
  //                 if (managedBySerial === 'Y') {
  //                   this.rowToWorkWith['ManBtchNum'] = 'N';
  //                   this.rowToWorkWith['ManSerNum'] = 'Y';
  //                   //this.scannedQty = 1;

  //                   this.checkBinLocations();

  //                   /*setTimeout(function () {
  //   serialNumberControl.focus();
  // }, 200);*/

  //                   this.scannedQty = undefined;
  //                   const comp = this;

  //                   setTimeout(function () {
  //                     comp.focusAfterScan(quantityControl);
  //                   }, 1000);
  //                 } else if (managedByBatch === 'Y') {
  //                   this.rowToWorkWith['ManBtchNum'] = 'Y';
  //                   this.rowToWorkWith['ManSerNum'] = 'N';

  //                   this.checkBinLocations();

  //                   this.scannedQty = undefined;
  //                   const comp = this;
  //                   setTimeout(function () {
  //                     comp.focusAfterScan(quantityControl);
  //                   }, 1000);
  //                 } else {
  //                   this.rowToWorkWith['ManBtchNum'] = 'N';
  //                   this.rowToWorkWith['ManSerNum'] = 'N';

  //                   if (this.rowToWorkWith['ScannedQty'] === undefined) {
  //                     this.rowToWorkWith['ScannedQty'] = 0;
  //                   }

  //                   if (this.autoIncrease) {
  //                     const qtyProp = this.rowToWorkWith.Properties.find(
  //                       (p) => p.Name === 'Quantity'
  //                     );

  //                     if (!this.isNew) {
  //                       qtyProp.ValueAsObject = Number(qtyProp.ValueAsObject) + 1;
  //                     }

  //                     this.resetScanFields(quantityControl, scanControl);
  //                   } else {
  //                     this.checkBinLocations();
  //                     const comp = this;
  //                     setTimeout(function () {
  //                       comp.focusAfterScan(quantityControl);
  //                     }, 1000);
  //                   }
  //                 }
  //               }
  //             });

  //           return;
  //         } else if (
  //           itemCode != null &&
  //           itemCode !== undefined &&
  //           itemCode !== '' &&
  //           this.moduleStructure.module.AdditionalInformationParsed
  //             .InventoryDirection === this.InventoryDirection.Inbound
  //         ) {
  //           const scannedBarcode = scanControl.value;
  //           scanControl.value = itemCode;
  //           this.executeScanOfItem(
  //             scanControl,
  //             quantityControl,
  //             serialNumberControl,
  //             scannedBarcode
  //           );
  //         } else {
  //           this.message.error(
  //             this.layoutService.translate(
  //               "Can't find a product related to the scanned barcode."
  //             )
  //           );
  //           this.playErrorVoice();
  //           this.resetScanFields(quantityControl, scanControl);
  //         }
  //       });
  //   }

  // executeScanOfBin(scanControl, quantityControl) {
  //   this.layoutService
  //     .executeQuery(80034, { Bin: scanControl.value })
  //     .subscribe((d: any[]) => {
  //       if (d.length === 0) {
  //         this.message.error(
  //           this.layoutService.translate(
  //             "Can't find a product related to the scanned barcode."
  //           )
  //         );
  //         this.playErrorVoice();
  //         this.resetScanFields(quantityControl, scanControl);
  //         return;
  //       }

  //       this.rowToWorkWith = null;
  //       let itemCode = '';
  //       let batch = '';
  //       for (let j = 0; j < d.length; j++) {
  //         itemCode = d[j].ItemCode;
  //         batch = d[j].DistNumber;

  //         for (let i = 0; i < this.lines.length; i++) {
  //           const properties = this.lines[i].Properties;
  //           const itemProp = properties.find((p) => p.Name === 'ItemCode');
  //           const binProp = properties.find((p) => p.Name === 'BinCode');

  //           if (
  //             itemProp != null &&
  //             itemProp !== undefined &&
  //             itemCode === itemProp.ValueAsObject &&
  //             binProp != null &&
  //             binProp !== undefined &&
  //             binProp.ValueAsObject === scanControl.value
  //           ) {
  //             if (this.recordModel.ObjectKey !== 'InventoryCounting') {
  //               const quantityProp = properties.find(
  //                 (p) => p.Name === 'Quantity' || p.Name === 'PickedQuantity'
  //               ).ValueAsObject;
  //               const openQtyProp = properties.find(
  //                 (p) => p.Name === 'OpenQty' || p.Name === 'ReleasedQuantity'
  //               ).ValueAsObject;
  //               if (quantityProp === openQtyProp) {
  //                 continue;
  //               }
  //             }
  //             this.rowToWorkWith = this.lines[i];
  //             break;
  //           }
  //         }
  //       }

  //       if (batch != null && batch !== undefined && batch !== '') {
  //         scanControl.value = batch;
  //         this.scanMode = 'Batch';
  //         this.executeScanOfBatch(scanControl, quantityControl);
  //       } else {
  //         this.inventoryService
  //           .getItemNumberDetailsAfterScan(itemCode)
  //           .subscribe((d) => {
  //             const itemCode = d[0]['ItemCode'];
  //             const managedBySerial = d[0]['ManSerNum'];
  //             const managedByBatch = d[0]['ManBtchNum'];

  //             if (this.rowToWorkWith === null) {
  //               for (let i = 0; i < this.lines.length; i++) {
  //                 const properties = this.lines[i].Properties;
  //                 const itemProp = properties.find(
  //                   (p) => p.Name === 'ItemCode'
  //                 );

  //                 if (
  //                   itemProp != null &&
  //                   itemProp !== undefined &&
  //                   itemCode === itemProp.ValueAsObject
  //                 ) {
  //                   this.rowToWorkWith = this.lines[i];
  //                   break;
  //                 }
  //               }
  //             }
  //             this.isNew = false;
  //             if (
  //               this.rowToWorkWith === null &&
  //               this.recordModel.ObjectKey === 'ITM_WMS_SSCC'
  //             ) {
  //               this.message.error(
  //                 this.layoutService.translate(
  //                   "Can't find a product related to the scanned barcode."
  //                 )
  //               );
  //               this.playErrorVoice();
  //               this.resetScanFields(quantityControl, scanControl);
  //               return;
  //             }
  //             if (this.rowToWorkWith === null) {
  //               if (
  //                 this.recordModel.ObjectKey === 'oPickLists' /*||
  //               this.recordModel.ObjectKey === 'oInventoryGenEntry'*/
  //               ) {
  //                 this.message.error(
  //                   this.layoutService.translate(
  //                     `We couldn't find any result for the scanned value ${value}. `
  //                   )
  //                 );
  //                 this.playErrorVoice();
  //                 this.resetScanFields(quantityControl, scanControl);
  //                 return;
  //               }
  //               this.addLineToTable();

  //               const itemCodeEle = this.lines[
  //                 this.lines.length - 1
  //               ].Properties.find((p) => p.Name === 'ItemCode');

  //               this.layoutService
  //                 .getModuleHeaderData(4, itemCode, '', false)
  //                 .subscribe((d) => {
  //                   this.moduleStructure.module.Sections.forEach((section) => {
  //                     if (
  //                       section.XmlTagName === 'Document_Lines' ||
  //                       section.XmlTagName === 'StockTransfer_Lines' ||
  //                       section.XmlTagName ===
  //                         'InventoryCountingLines|InventoryCountingLine'
  //                     ) {
  //                       section.Fields.forEach((field) => {
  //                         if (field.LinkedModule === '4') {
  //                           const value = d[field.LinkedField];

  //                           this.lines[
  //                             this.lines.length - 1
  //                           ].Properties.forEach((property) => {
  //                             if (property.Name === field.PropertyName) {
  //                               property.ValueAsObject = value;
  //                               this.layoutService.triggerFieldValueChanged({
  //                                 recordProperty: property,
  //                                 formId: '',
  //                                 line: this.lines[this.lines.length - 1].Id,
  //                                 recordModel: this.recordModel,
  //                                 sectionTagName: section.XmlTagName,
  //                                 moduleStructure: this.moduleStructure,
  //                               });
  //                             }
  //                           });
  //                         }
  //                       });
  //                     }
  //                   });
  //                   this.rowToWorkWith = this.lines[this.lines.length - 1];
  //                   this.isNew = true;

  //                   this.notificationService.create(
  //                     'warning',
  //                     this.layoutService.translate(
  //                       'You are going to add a new item #' + itemCode
  //                     ),
  //                     ''
  //                   );

  //                   this.rowToWorkWith['isNew'] = true;

  //                   if (managedBySerial === 'Y') {
  //                     this.rowToWorkWith['ManBtchNum'] = 'N';
  //                     this.rowToWorkWith['ManSerNum'] = 'Y';

  //                     this.checkBinLocations();

  //                     this.scannedQty = undefined;
  //                     const comp = this;

  //                     setTimeout(function () {
  //                       comp.focusAfterScan(quantityControl);
  //                     }, 1000);
  //                   } else if (managedByBatch === 'Y') {
  //                     this.rowToWorkWith['ManBtchNum'] = 'Y';
  //                     this.rowToWorkWith['ManSerNum'] = 'N';

  //                     this.checkBinLocations();

  //                     this.scannedQty = undefined;
  //                     const comp = this;
  //                     setTimeout(function () {
  //                       comp.focusAfterScan(quantityControl);
  //                     }, 1000);
  //                   } else {
  //                     this.rowToWorkWith['ManBtchNum'] = 'N';
  //                     this.rowToWorkWith['ManSerNum'] = 'N';

  //                     if (this.rowToWorkWith['ScannedQty'] === undefined) {
  //                       this.rowToWorkWith['ScannedQty'] = 0;
  //                     }

  //                     if (this.autoIncrease) {
  //                       const qtyProp = this.rowToWorkWith.Properties.find(
  //                         (p) => p.Name === 'Quantity'
  //                       );

  //                       if (!this.isNew) {
  //                         qtyProp.ValueAsObject =
  //                           Number(qtyProp.ValueAsObject) + 1;
  //                       }

  //                       this.resetScanFields(quantityControl, scanControl);
  //                     } else {
  //                       this.checkBinLocations();

  //                       const comp = this;
  //                       setTimeout(function () {
  //                         comp.focusAfterScan(quantityControl);
  //                       }, 1000);
  //                     }
  //                   }
  //                 });
  //             } else {
  //               if (managedBySerial === 'Y') {
  //                 this.rowToWorkWith['ManBtchNum'] = 'N';
  //                 this.rowToWorkWith['ManSerNum'] = 'Y';

  //                 this.checkBinLocations();

  //                 this.scannedQty = undefined;
  //                 const comp = this;

  //                 setTimeout(function () {
  //                   comp.focusAfterScan(quantityControl);
  //                 }, 1000);
  //               } else if (managedByBatch === 'Y') {
  //                 this.rowToWorkWith['ManBtchNum'] = 'Y';
  //                 this.rowToWorkWith['ManSerNum'] = 'N';

  //                 this.checkBinLocations();

  //                 this.scannedQty = undefined;
  //                 const comp = this;
  //                 setTimeout(function () {
  //                   comp.focusAfterScan(quantityControl);
  //                 }, 1000);
  //               } else {
  //                 this.rowToWorkWith['ManBtchNum'] = 'N';
  //                 this.rowToWorkWith['ManSerNum'] = 'N';

  //                 if (this.rowToWorkWith['ScannedQty'] === undefined) {
  //                   this.rowToWorkWith['ScannedQty'] = 0;
  //                 }

  //                 if (this.autoIncrease) {
  //                   const qtyProp = this.rowToWorkWith.Properties.find(
  //                     (p) => p.Name === 'Quantity'
  //                   );

  //                   if (!this.isNew) {
  //                     qtyProp.ValueAsObject = Number(qtyProp.ValueAsObject) + 1;
  //                   }

  //                   this.resetScanFields(quantityControl, scanControl);
  //                 } else {
  //                   this.checkBinLocations();
  //                   const comp = this;
  //                   setTimeout(function () {
  //                     //comp.focusAfterScan(quantityControl);

  //                     comp.modal.confirm({
  //                       nzTitle: comp.layoutService
  //                         .translate(
  //                           'you are scanned the item : _ITEM_CODE_ do you want to pick all quantity?'
  //                         )
  //                         .replace('_ITEM_CODE_', itemCode),
  //                       nzContent: '',
  //                       nzOnOk: () => {
  //                         const openQtyProp =
  //                           comp.rowToWorkWith.Properties.find(
  //                             (p) =>
  //                               p.Name === 'OpenQty' ||
  //                               p.Name === 'ReleasedQuantity'
  //                           ).ValueAsObject;

  //                         quantityControl.focus();
  //                         quantityControl.value = openQtyProp;
  //                         comp.scannedQty = openQtyProp;
  //                         comp.quantityScanned(
  //                           comp.scanControl.nativeElement,
  //                           quantityControl,
  //                           undefined
  //                         );
  //                       },
  //                     });
  //                   }, 1000);
  //                 }
  //               }
  //             }
  //           });
  //       }
  //     });
  // }

  executeScanOfBin(
    value,
    scanControl: FormControl,
    quantityControl: FormControl,
  ): Observable<any> {
    return new Observable((observer) => {
      this.layoutService
        .executeQuery(80034, { Bin: value })
        //.executeQuery(80034, { Bin: scanControl.value })
        .subscribe({
          next: (d: any[]) => {
            if (d.length === 0) {
              this.message.error(
                this.layoutService.translate(
                  "Can't find a product related to the scanned barcode.",
                ),
                { nzDuration: 5000 },
              );
              this.playErrorVoice();
              this.resetScanFields(quantityControl, scanControl);
              observer.error('Bin scan returned no results');
              return;
            }

            this.rowToWorkWith = null;
            let itemCode = '';
            let batch = '';

            for (let j = 0; j < d.length; j++) {
              itemCode = d[j].ItemCode;
              batch = d[j].DistNumber;

              for (let i = 0; i < this.lines.length; i++) {
                const properties = this.lines[i].Properties;
                const itemProp = properties.find((p) => p.Name === 'ItemCode');
                const binProp = properties.find((p) => p.Name === 'BinCode');

                if (
                  itemProp?.ValueAsObject === itemCode &&
                  binProp?.ValueAsObject === value
                  //binProp?.ValueAsObject === scanControl.value
                ) {
                  if (this.recordModel.ObjectKey !== 'InventoryCounting') {
                    const quantityProp = properties.find(
                      (p) =>
                        p.Name === 'Quantity' || p.Name === 'PickedQuantity',
                    )?.ValueAsObject;
                    const openQtyProp = properties.find(
                      (p) =>
                        p.Name === 'OpenQty' || p.Name === 'ReleasedQuantity',
                    )?.ValueAsObject;
                    if (quantityProp === openQtyProp) {
                      continue;
                    }
                  }
                  this.rowToWorkWith = this.lines[i];
                  break;
                }
              }
            }

            if (batch) {
              //scanControl.value = batch;
              scanControl.setValue(batch);
              this.scanMode = 'Batch';
              this.executeScanOfBatch(
                scanControl.value,
                scanControl,
                quantityControl,
              ).subscribe({
                next: (res) => {
                  observer.next(res);
                  observer.complete();
                },
                error: (err) => observer.error(err),
              });
              return;
            }

            this.inventoryService
              .getItemNumberDetailsAfterScan(itemCode)
              .subscribe({
                next: (d) => {
                  const itemCode = d[0]['ItemCode'];
                  const managedBySerial = d[0]['ManSerNum'];
                  const managedByBatch = d[0]['ManBtchNum'];

                  if (!this.rowToWorkWith) {
                    this.rowToWorkWith =
                      this.lines.find(
                        (line) =>
                          line.Properties.find((p) => p.Name === 'ItemCode')
                            ?.ValueAsObject === itemCode,
                      ) || null;
                  }

                  this.isNew = false;
                  if (
                    !this.rowToWorkWith &&
                    this.recordModel.ObjectKey === 'ITM_WMS_SSCC'
                  ) {
                    this.message.error(
                      this.layoutService.translate(
                        "Can't find a product related to the scanned barcode.",
                      ),
                      { nzDuration: 5000 },
                    );
                    this.playErrorVoice();
                    this.resetScanFields(quantityControl, scanControl);
                    observer.error('Item not found for SSCC');
                    return;
                  }

                  if (!this.rowToWorkWith) {
                    if (this.recordModel.ObjectKey === 'oPickLists') {
                      this.message.error(
                        this.layoutService.translate(
                          "We couldn't find any result for the scanned value.",
                        ),
                        { nzDuration: 5000 },
                      );
                      this.playErrorVoice();
                      this.resetScanFields(quantityControl, scanControl);
                      observer.error('PickList item not found');
                      return;
                    }

                    this.addLineToTable();
                    const itemCodeEle = this.lines[
                      this.lines.length - 1
                    ].Properties.find((p) => p.Name === 'ItemCode');

                    this.layoutService
                      .getModuleHeaderData(4, itemCode, '', false)
                      .subscribe({
                        next: (d) => {
                          this.moduleStructure.module.Sections.forEach(
                            (section) => {
                              if (
                                [
                                  'Document_Lines',
                                  'StockTransfer_Lines',
                                  'InventoryCountingLines|InventoryCountingLine',
                                ].includes(section.XmlTagName)
                              ) {
                                section.Fields.forEach((field) => {
                                  if (field.LinkedModule === '4') {
                                    const value = d[field.LinkedField];
                                    this.lines[
                                      this.lines.length - 1
                                    ].Properties.forEach((property) => {
                                      if (
                                        property.Name === field.PropertyName
                                      ) {
                                        property.ValueAsObject = value;
                                        this.layoutService.triggerFieldValueChanged(
                                          {
                                            recordProperty: property,
                                            formId: '',
                                            line: this.lines[
                                              this.lines.length - 1
                                            ].Id,
                                            recordModel: this.recordModel,
                                            sectionTagName: section.XmlTagName,
                                            moduleStructure:
                                              this.moduleStructure,
                                          },
                                        );
                                      }
                                    });
                                  }
                                });
                              }
                            },
                          );

                          this.rowToWorkWith =
                            this.lines[this.lines.length - 1];
                          this.isNew = true;
                          this.rowToWorkWith['isNew'] = true;

                          if (
                            this.checkDONTDisplayNotificationForNewItemRule()
                          ) {
                            this.notificationService.create(
                              'warning',
                              this.layoutService.translate(
                                'You are going to add a new item #' + itemCode,
                              ),
                              '',
                            );
                          }

                          this.applyScanItemLogic(
                            value,
                            managedBySerial,
                            managedByBatch,
                            scanControl,
                            quantityControl,
                          );
                          observer.next({ itemCode, newRow: true });
                          observer.complete();
                        },
                        error: (err) => observer.error(err),
                      });
                  } else {
                    this.applyScanItemLogic(
                      value,
                      managedBySerial,
                      managedByBatch,
                      scanControl,
                      quantityControl,
                    );
                    observer.next({ itemCode, newRow: false });
                    observer.complete();
                  }
                },
                error: (err) => observer.error(err),
              });
          },
          error: (err) => {
            this.message.error(
              this.layoutService.translate('Error during bin scan'),
              { nzDuration: 5000 },
            );
            this.playErrorVoice();
            observer.error(err);
          },
        });
    });
  }

  applyScanItemLogic(
    scannedValue,
    managedBySerial: string,
    managedByBatch: string,
    scanControl: FormControl,
    quantityControl,
  ) {
    const comp = this;

    if (managedBySerial === 'Y') {
      this.rowToWorkWith['ManBtchNum'] = 'N';
      this.rowToWorkWith['ManSerNum'] = 'Y';
      this.checkBinLocations();
      this.scannedQty = undefined;
      setTimeout(
        () => comp.focusAfterScan(scanControl, scannedValue, quantityControl),
        1000,
      );
    } else if (managedByBatch === 'Y') {
      this.rowToWorkWith['ManBtchNum'] = 'Y';
      this.rowToWorkWith['ManSerNum'] = 'N';
      this.checkBinLocations();
      this.scannedQty = undefined;
      setTimeout(
        () => comp.focusAfterScan(scanControl, scannedValue, quantityControl),
        1000,
      );
    } else {
      this.rowToWorkWith['ManBtchNum'] = 'N';
      this.rowToWorkWith['ManSerNum'] = 'N';

      if (this.rowToWorkWith['ScannedQty'] === undefined) {
        this.rowToWorkWith['ScannedQty'] = 0;
      }

      if (this.autoIncrease) {
        let qtyProp = this.rowToWorkWith.Properties.find(
          (p) => p.Name === 'Quantity',
        );

        if (
          this.recordModel.ObjectKey === 'InventoryCounting' ||
          this.recordModel.ObjectKey === 'InventoryPosting'
        ) {
          qtyProp = this.rowToWorkWith.Properties.find(
            (p) => p.Name === 'UoMCountedQuantity',
          );
        }

        if (!this.isNew) {
          qtyProp.ValueAsObject = Number(qtyProp.ValueAsObject) + 1;
        }
        this.resetScanFields(quantityControl, scanControl);
      } else {
        this.checkBinLocations();
        setTimeout(() => {
          comp.modal.confirm({
            nzTitle: comp.layoutService
              .translate(
                'you are scanned the item : _ITEM_CODE_ do you want to pick all quantity?',
              )
              .replace(
                '_ITEM_CODE_',
                this.rowToWorkWith?.Properties.find(
                  (p) => p.Name === 'ItemCode',
                )?.ValueAsObject || '',
              ),
            nzContent: '',
            nzOnOk: () => {
              const openQtyProp = comp.rowToWorkWith.Properties.find(
                (p) => p.Name === 'OpenQty' || p.Name === 'ReleasedQuantity',
              ).ValueAsObject;
              quantityControl.focus();
              //quantityControl.value = openQtyProp;
              quantityControl.setValue(openQtyProp);
              comp.scannedQty = openQtyProp;
              comp.quantityScanned(
                comp.scanControl.nativeElement,
                quantityControl,
                undefined,
              );
            },
          });
        }, 1000);
      }
    }
  }

  makeBatchDetailDrawerVisible(quantityToWorkWith: RecordProperties) {
    quantityToWorkWith.DialogVisibleDrawerInitialized = true;
    setTimeout(() => {
      quantityToWorkWith.DialogVisible = true;
    }, 200);
  }

  focusAfterScan(scanControl, scannedValue, quantityControl) {
    if (
      (this.rowToWorkWith['ManBtchNum'] === 'Y' ||
        this.rowToWorkWith['ManSerNum'] === 'Y') &&
      this.moduleStructure.module.ObjectType !== 'oInventoryTransferRequest' &&
      !(
        this.scanMode === 'Batch' &&
        (this.moduleStructure.module.AdditionalInformationParsed
          .InventoryDirection === this.InventoryDirection.Outbound ||
          this.moduleStructure.module.ObjectType === 'InventoryCounting' ||
          this.moduleStructure.module.ObjectType === 'oReturns')
      )
    ) {
      const property = this.quantityToWorkWith;
      property.DialogVisibleDrawerInitialized = true;
      setTimeout(() => {
        property.DialogVisible = true;
      }, 200);

      const quantityToWorkWith = this.quantityToWorkWith;
      setTimeout(() => {
        quantityToWorkWith.DialogVisible = true;
      }, 500);

      this.quantityToWorkWith.IsNew = this.rowToWorkWith['isNew'];
      this.scanControl.nativeElement.value = '';
      this.rowToWorkWith = undefined;
      quantityControl.value = '';
    } else {
      if (this.autoIncrease) {
        setTimeout(() => {
          this.scannedQty = quantityControl.value = 1;
          this.quantityScanned(
            scannedValue,
            this.scanControl.nativeElement,
            quantityControl,
            undefined,
            true,
          );

          if (
            this.moduleStructure.module.ObjectType !== 'InventoryCounting' &&
            this.openQuantityToWorkWith.ValueAsObject !== '' &&
            this.openQuantityToWorkWith.ValueAsObject !== 0 &&
            this.quantityToWorkWith.ValueAsObject >
              this.openQuantityToWorkWith.ValueAsObject
          ) {
            this.notificationService.create(
              'warning',
              this.layoutService.translate(
                'The selected quantity ' +
                  this.quantityToWorkWith.ValueAsObject +
                  ' exceeds the open quantity' +
                  this.openQuantityToWorkWith.ValueAsObject,
              ),
              '',
            );

            let audio = new Audio('assets/audio_file.mp3');
            audio.load();
            audio.play();
          }

          if (this.moduleStructure.module.ObjectType !== 'InventoryCounting') {
            let showFullMessage = true;
            for (let i = 0; i < this.lines.length; i++) {
              const properties = this.lines[i].Properties;
              const quantity = properties.find(
                (p) => p.Name === 'Quantity',
              ).ValueAsObject;
              const openQty = properties.find(
                (p) => p.Name === 'OpenQty',
              ).ValueAsObject;
              if (quantity < openQty) {
                showFullMessage = false;
                break;
              }
            }
            if (showFullMessage) {
              this.notificationService.create(
                'success',
                this.layoutService.translate(
                  'You have scanned all open quantities',
                ),
                '',
              );
            }
          }
        }, 200);
      } else {
        if (
          this.rowToWorkWith['ManBtchNum'] === 'Y' &&
          this.scanMode === 'Batch' &&
          !(
            this.recordModel.ObjectKey === 'oStockTransfer' ||
            this.recordModel.ObjectKey === 'oInventoryTransferRequest'
          ) &&
          this.moduleStructure.module.AdditionalInformationParsed
            .InventoryDirection === this.InventoryDirection.Outbound &&
          this.fullBatchQtyMode
        ) {
          quantityControl.focus();
          quantityControl.value = this.batchNumberAvaQty;
          this.scannedQty = this.batchNumberAvaQty;
          this.quantityScanned(
            scannedValue,
            this.scanControl.nativeElement,
            quantityControl,
            undefined,
          );
        } else {
          //oStockTransfer only
          if (
            this.recordModel.ObjectKey === 'oStockTransfer' ||
            this.recordModel.ObjectKey === 'oInventoryTransferRequest' ||
            this.recordModel.ObjectKey === 'oDeliveryNotes'
          ) {
            setTimeout(() => {
              if (this.rowToWorkWith['FromBinActivate'] === 'Y') {
                this.binLocationFrom.focus();
              } else if (this.rowToWorkWith['BinActivate'] === 'Y') {
                if (
                  this.recordModel.ObjectKey === 'oStockTransfer' ||
                  this.recordModel.ObjectKey === 'oInventoryTransferRequest'
                ) {
                  this.binLocationToS.focus();
                } else {
                  this.binLocationTo.focus();
                }
              } else {
                if (g.autoScanQtyForSTQueryId !== 0) {
                  this.layoutService
                    .executeQuery(g.autoScanQtyForSTQueryId, {
                      ItemCode: this.lastScannedRow.ItemCodeProp.ValueAsObject,
                    })
                    .subscribe((result: any[]) => {
                      if (result.length > 0) {
                        if (
                          result[0].Value != null &&
                          result[0].Value !== undefined &&
                          result[0].Value !== ''
                        ) {
                          quantityControl.value = result[0].Value;
                          this.scannedQty = result[0].Value;
                          this.quantityScanned(
                            result[0].Value,
                            scanControl,
                            quantityControl,
                            undefined,
                          );
                        }
                      } else {
                        quantityControl.focus();
                      }
                    });
                } else {
                  quantityControl.focus();
                }
              }
            }, 1000);
          } else if (
            this.recordModel.ObjectKey === 'InventoryCounting' &&
            this.rowToWorkWith['ManBtchNum'] === 'Y' &&
            this.scanMode === 'Batch' &&
            this.fullBatchQtyMode
          ) {
            quantityControl.focus();
            quantityControl.value = this.batchNumberAvaQty;
            this.scannedQty = this.batchNumberAvaQty;
            this.quantityScanned(
              scannedValue,
              this.scanControl.nativeElement,
              quantityControl,
              undefined,
            );

            if (this.setCountedAsChecked) {
              this.rowToWorkWith.Properties.find(
                (p) => p.Name === 'Counted',
              ).Value = 'Y';
              this.rowToWorkWith.Properties.find(
                (p) => p.Name === 'Counted',
              ).ValueAsObject = 'Y';
            }
          } else {
            if (g.autoScanQtyForSTQueryId !== 0) {
              this.layoutService
                .executeQuery(g.autoScanQtyForSTQueryId, {
                  ItemCode: this.lastScannedRow.ItemCodeProp.ValueAsObject,
                })
                .subscribe((result: any[]) => {
                  if (result.length > 0) {
                    if (
                      result[0].Value != null &&
                      result[0].Value !== undefined &&
                      result[0].Value !== ''
                    ) {
                      quantityControl.value = result[0].Value;
                      this.scannedQty = result[0].Value;
                      this.quantityScanned(
                        result[0].Value,
                        scanControl,
                        quantityControl,
                        undefined,
                      );
                    }
                  } else {
                    quantityControl.focus();
                  }
                });
            } else {
              quantityControl.focus();
            }
          }
        }
      }
    }
  }

  focusAfterScanQR(quantityControl, batch: string, quantityQR: number) {
    if (
      this.rowToWorkWith['ManBtchNum'] === 'Y' &&
      this.scanMode === 'QR' &&
      (this.moduleStructure.module.AdditionalInformationParsed
        .InventoryDirection === this.InventoryDirection.Outbound ||
        this.moduleStructure.module.ObjectType === 'InventoryCounting' ||
        this.recordModel.ObjectKey === 'oStockTransfer' ||
        this.recordModel.ObjectKey === 'oInventoryTransferRequest')
    ) {
      //quantityControl.focus();

      if (
        (this.recordModel.ObjectKey === 'oStockTransfer' ||
          this.recordModel.ObjectKey === 'oInventoryTransferRequest' ||
          this.recordModel.ObjectKey === 'oDeliveryNotes') &&
        (this.rowToWorkWith['FromBinActivate'] === 'Y' ||
          this.rowToWorkWith['BinActivate'] === 'Y')
      ) {
        quantityControl.value = quantityQR;
        this.scannedQty = quantityQR;
        setTimeout(() => {
          if (this.rowToWorkWith['FromBinActivate'] === 'Y') {
            this.binLocationFrom.focus();
          } else if (this.rowToWorkWith['BinActivate'] === 'Y') {
            if (
              this.recordModel.ObjectKey === 'oStockTransfer' ||
              this.recordModel.ObjectKey === 'oInventoryTransferRequest'
            ) {
              this.binLocationToS.focus();
            } else {
              this.binLocationTo.focus();
            }
          } else {
            quantityControl.focus();
          }
        }, 2000);
      } else {
        quantityControl.value = quantityQR;
        this.scannedQty = quantityQR;
        this.quantityScannedQR(
          this.scanControl.nativeElement,
          quantityControl,
          batch,
          undefined,
        );
      }
    } else {
    }
  }

  focusAfterScanReverse(quantityControl) {
    if (
      this.rowToWorkWith['ManBtchNum'] === 'Y' ||
      this.rowToWorkWith['ManSerNum'] === 'Y'
    ) {
      return;
    } else {
      quantityControl.focus();
    }
  }

  fromBinSelected(scanControl, quantityControl, key = undefined) {
    if (key !== undefined && key.keyCode !== 13) {
      return;
    }

    if (this.recordModel.ObjectKey === 'oStockTransfer') {
      /*if (this.rowToWorkWith['BinActivate'] === 'Y') {
        setTimeout(() => {
          this.binLocationTo.focus();
        }, 1000);
      } else {
        quantityControl.focus();
      }*/
      if (this.scanMode === 'QR') {
        if (this.rowToWorkWith['BinActivate'] === 'Y') {
          setTimeout(() => {
            this.binLocationToS.focus();
          }, 1000);
          return;
        } else {
          this.quantityScanned(
            this.batchNumber,
            scanControl,
            quantityControl,
            undefined,
            false,
            true,
          );
        }
      } else {
        quantityControl.focus();
      }
    }
  }

  toBinSelected(scanControl, quantityControl, key = undefined) {
    if (key !== undefined && key.keyCode !== 13) {
      return;
    }

    if (
      this.recordModel.ObjectKey === 'oStockTransfer' &&
      this.rowToWorkWith['FromBinActivate'] === 'Y'
    ) {
      //quantityControl.focus();

      this.quantityScanned(
        this.scanMode === 'QR' ? this.batchNumber : scanControl.value,
        scanControl,
        quantityControl,
        undefined,
        false,
        true,
      );
    } else if (g.autoScanQtyForSTQueryId !== 0) {
      this.layoutService
        .executeQuery(g.autoScanQtyForSTQueryId, {
          ItemCode: this.lastScannedRow.ItemCodeProp.ValueAsObject,
        })
        .subscribe((result: any[]) => {
          if (result.length > 0) {
            if (
              result[0].Value != null &&
              result[0].Value !== undefined &&
              result[0].Value !== ''
            ) {
              quantityControl.value = result[0].Value;
              this.scannedQty = result[0].Value;
              this.quantityScanned(
                result[0].Value,
                scanControl,
                quantityControl,
                undefined,
              );
            }
          } else {
            quantityControl.focus();
          }
        });
    } else {
      quantityControl.focus();
    }
  }

  setSerialNumber(value, scanControl) {
    const properties = this.rowToWorkWith.Properties;
    const itemProp = properties.find((p) => p.Name === 'ItemCode');
    const whsProp = properties.find((p) => p.Name === 'WarehouseCode');
    const serialProp = properties.find((p) => p.Name === 'ITMSerialNumber');
    const fromWharehouse = properties.find((p) => p.Name === 'FromWarehouse');
    let qtyProp = properties.find((p) => p.Name === 'Quantity');
    if (
      this.recordModel.ObjectKey === 'InventoryCounting' ||
      this.recordModel.ObjectKey === 'InventoryPosting'
    ) {
      qtyProp = properties.find((p) => p.Name === 'UoMCountedQuantity');
      const binEntryProp = properties.find((p) => p.Name === 'BinEntry');
    } else if (this.recordModel.ObjectKey === 'oPickLists') {
      qtyProp = properties.find((p) => p.Name === 'PickedQuantity');
    }
    const serialValue = serialProp.ValueAsObject;

    this.inventoryService
      .getSerialNumberDetails(
        itemProp.ValueAsObject,
        fromWharehouse == null || fromWharehouse === undefined
          ? whsProp.ValueAsObject
          : fromWharehouse.ValueAsObject,
        this.serialNumber,
      )
      .subscribe((result: any[]) => {
        if (result.length === 0) {
          this.message.error(
            `The serial number ${this.serialNumber} is not valid. Or this serial not belong to this warehouse`,
            { nzDuration: 5000 },
          );
          this.playErrorVoice();
          this.resetScanFields(undefined, scanControl);
        } else if (result[0].Status === 1) {
          this.message.error(
            this.layoutService.translate(
              `You have selected a serial number which is not available anymore.`,
            ),
            { nzDuration: 5000 },
          );
          this.playErrorVoice();
          this.resetScanFields(undefined, scanControl);
        } else {
          if (
            serialValue == null ||
            serialValue === undefined ||
            serialValue === ''
          ) {
            if (
              this.recordModel.ObjectKey === 'InventoryCounting' ||
              this.recordModel.ObjectKey === 'InventoryPosting'
            ) {
              serialProp.ValueAsObject = this.serialNumber.toString();

              const serialToAdd = {
                //BinLocation: this.selectedBinLocation,
                U_ITM_WMS_SSCC: '',
                ManufacturerSerialNumber: this.serialNumber,
                InternalSerialNumber: this.serialNumber,
                Quantity: 1,
              };

              const jsonToSave = JSON.stringify(serialToAdd);
              serialProp.ValueAsObject = jsonToSave;
            } else {
              serialProp.ValueAsObject = result[0].AbsEntry;
              if (this.binCode != '') {
                serialProp.ValueAsObject += '|' + this.binCode;
              }
            }
          } else {
            if (
              this.recordModel.ObjectKey === 'InventoryCounting' ||
              this.recordModel.ObjectKey === 'InventoryPosting'
            ) {
              let serialArr = JSON.parse(`[${serialValue}]`);

              const existingSerial = serialArr.find((sn) => {
                if (sn.ManufacturerSerialNumber === this.serialNumber) {
                  return sn;
                }
              });
              if (existingSerial !== undefined) {
                this.message.error(
                  this.layoutService.translate(
                    'The scanned Serial is already scanned',
                  ),
                  { nzDuration: 5000 },
                );
                this.playErrorVoice();
                return;
              }

              const serialToAdd = {
                //BinLocation: this.selectedBinLocation,
                U_ITM_WMS_SSCC: '',
                ManufacturerSerialNumber: this.serialNumber,
                InternalSerialNumber: this.serialNumber,
                Quantity: 1,
              };

              serialArr = [...serialArr, serialToAdd];

              const jsonToSave = JSON.stringify(serialArr);
              serialProp.ValueAsObject = jsonToSave.substring(
                1,
                jsonToSave.length - 1,
              );
              //serialProp.ValueAsObject = serialValue + ',' + this.serialNumber;
            } else {
              const selectedSerialNumbers = [];
              if (!serialProp.ValueAsObject.toString().includes(',')) {
                if (!serialProp.ValueAsObject.toString().includes('|')) {
                  selectedSerialNumbers.push({
                    AbsEntry: Number(serialProp.ValueAsObject),
                  });
                } else {
                  selectedSerialNumbers.push({
                    AbsEntry: Number(
                      serialProp.ValueAsObject.toString().split('|')[0],
                    ),
                    BinLocation: Number(
                      serialProp.ValueAsObject.toString().split('|')[1],
                    ),
                  });
                }
              } else {
                serialProp.ValueAsObject.toString()
                  .split(',')
                  .forEach((f) => {
                    if (f.includes('|')) {
                      selectedSerialNumbers.push({
                        AbsEntry: Number(f.split('|')[0]),
                        BinLocation: Number(f.split('|')[1]),
                      });
                    } else {
                      selectedSerialNumbers.push({
                        AbsEntry: Number(f),
                      });
                    }
                  });
              }

              const existingSerial = selectedSerialNumbers.find((sn) => {
                if (sn.AbsEntry === result[0].AbsEntry) {
                  return sn;
                }
              });
              if (existingSerial !== undefined) {
                this.message.error(
                  this.layoutService.translate(
                    'The scanned Serial is already scanned',
                  ),
                  { nzDuration: 5000 },
                );
                this.playErrorVoice();
                return;
              } else {
                serialProp.ValueAsObject =
                  serialValue + ',' + result[0].AbsEntry;
                if (this.binCode != '') {
                  serialProp.ValueAsObject += '|' + this.binCode;
                }
              }
            }
          }

          if (!this.isNew) {
            const lineSerialsLen =
              serialProp.ValueAsObject.toString().split(',').length;

            if (
              lineSerialsLen >
              Number(
                qtyProp.ValueAsObject *
                  this.unitsPerMeasureToWorkWith.ValueAsObject,
              )
            ) {
              if (
                this.recordModel.ObjectKey === 'InventoryCounting' ||
                this.recordModel.ObjectKey === 'InventoryPosting'
              ) {
                qtyProp = properties.find(
                  (p) => p.Name === 'UoMCountedQuantity',
                );
              }
              qtyProp.ValueAsObject =
                Number(qtyProp.ValueAsObject) +
                1 / this.unitsPerMeasureToWorkWith.ValueAsObject;
            }
          } else {
            if (
              this.recordModel.ObjectKey === 'InventoryCounting' ||
              this.recordModel.ObjectKey === 'InventoryPosting'
            ) {
              qtyProp = properties.find((p) => p.Name === 'UoMCountedQuantity');
              const binEntryProp = properties.find(
                (p) => p.Name === 'BinEntry',
              );
              binEntryProp.ValueAsObject = this.binCode;
            }
            qtyProp.ValueAsObject = 1;
          }
          this.isNew = false;
          if (
            this.rowToWorkWith['SerialData'] == null ||
            this.rowToWorkWith['SerialData'] === undefined
          ) {
            this.rowToWorkWith['SerialData'] = [];
            this.rowToWorkWith['SerialData'].push({
              SerialName: this.serialNumber,
              SerialEntry: result[0].AbsEntry,
            });
          } else {
            this.rowToWorkWith['SerialData'].push({
              SerialName: this.serialNumber,
              SerialEntry: result[0].AbsEntry,
            });
          }

          this.rowToWorkWith = undefined;
          this.serialNumber = undefined;
          this.scannedQty = undefined;
          setTimeout(function () {
            scanControl.value = '';
            scanControl.disabled = false;
            scanControl.focus();
            //this.shouldFocusOnScanControl = true;
          }, 200);
        }
      });
  }

  removeSerialNumber(row, serialNumber) {
    row['SerialData'].forEach((element, index) => {
      if (element.SerialEntry === serialNumber) {
        row['SerialData'].splice(index, 1);
      }
    });
    const properties = row.Properties;
    const qtyProp = properties.find((p) => p.Name === 'Quantity');
    const serialProp = properties.find((p) => p.Name === 'ITMSerialNumber');
    const serialValue = serialProp.ValueAsObject;
    if (
      serialValue != null &&
      serialValue !== undefined &&
      serialValue !== ''
    ) {
      const lineSerialsLen = serialProp.ValueAsObject.toString().split(',');

      lineSerialsLen.forEach((element, index) => {
        if (Number(element) === serialNumber) {
          lineSerialsLen.splice(index, 1);
        }
      });

      serialProp.ValueAsObject = lineSerialsLen.join(',');
      qtyProp.ValueAsObject -= 1;
      if (qtyProp.ValueAsObject <= 0) {
        this.deleteRow(row.Id);
      }
    }
  }

  getPropertyValue(recordLine: RecordLine, propertyName: string) {
    return recordLine.Properties.find((p) => p.Name === propertyName)
      .ValueAsObject;
  }

  setRowToWorkWith() {
    console.log(this.rowToWorkWith);
    console.log(this.binCode);

    const baseItemProp = this.rowToWorkWith.Properties.find(
      (p) => p.Name === 'ItemCode',
    );

    this.rowToWorkWith = undefined;

    for (let i = 0; i < this.lines.length; i++) {
      const properties = this.lines[i].Properties;
      const itemProp = properties.find((p) => p.Name === 'ItemCode');
      const binAbs = properties.find((p) => p.Name === 'BinAbs');
      const batchNumber = properties.find((p) => p.Name === 'BatchNumber');

      if (
        itemProp != null &&
        itemProp !== undefined &&
        baseItemProp.ValueAsObject === itemProp.ValueAsObject &&
        binAbs != null &&
        binAbs !== undefined &&
        this.binCode.toString() === binAbs.ValueAsObject.toString() &&
        batchNumber != null &&
        batchNumber !== undefined &&
        this.batchNumber === batchNumber.ValueAsObject
      ) {
        this.rowToWorkWith = this.lines[i];
        break;
      }
    }

    if (this.rowToWorkWith === undefined) {
      for (let i = 0; i < this.lines.length; i++) {
        const properties = this.lines[i].Properties;
        const itemProp = properties.find((p) => p.Name === 'ItemCode');
        const binActivate = properties.find((p) => p.Name === 'BinActivate');

        if (
          itemProp != null &&
          itemProp !== undefined &&
          baseItemProp.ValueAsObject === itemProp.ValueAsObject &&
          binActivate != null &&
          binActivate !== undefined &&
          'N' === binActivate.ValueAsObject.toString()
        ) {
          this.rowToWorkWith = this.lines[i];
          break;
        }
      }
    }

    if (this.rowToWorkWith === undefined) {
      this.message.error(
        this.layoutService.translate(
          `We couldn't find any result for the scanned value. `,
        ),
        { nzDuration: 5000 },
      );
      this.playErrorVoice();
    }
  }
  quantityScannedBlur(scanControl, quantityControl) {
    if (
      quantityControl.value == null ||
      quantityControl.value === undefined ||
      quantityControl.value === ''
    )
      return;
    this.quantityScanned(scanControl.value, scanControl, quantityControl);
  }

  quantityScanned(
    scannedValue,
    scanControl,
    quantityControl,
    key = undefined,
    fromAuto = false,
    fromToBin = false,
  ) {
    if (key !== undefined && key.keyCode !== 13) {
      return;
    }

    if (this.isReverse) {
      let confirmChoice = confirm(
        this.layoutService
          .translate(
            'You are deleting quantity _QTY_ from item:_ITEM_CODE_, do you want to continue?',
          )
          .replace('_ITEM_CODE_', /*scanControl.value*/ scannedValue)
          .replace('_QTY_', this.scannedQty.toString()),
      );

      if (confirmChoice) {
        let countedQty = this.rowToWorkWith.Properties.find(
          (p) => p.Name === 'UoMCountedQuantity',
        ).ValueAsObject;

        if (countedQty - quantityControl.value < 0) {
          this.message.error(
            this.layoutService.translate(
              'The deleted quantity is more than the currect quantity',
            ),
            { nzDuration: 5000 },
          );
          this.playErrorVoice();
          this.resetScanFields(quantityControl, scanControl);
          return;
        }

        this.rowToWorkWith.Properties.find(
          (p) => p.Name === 'UoMCountedQuantity',
        ).ValueAsObject = countedQty - quantityControl.value;

        if (countedQty - quantityControl.value == 0) {
          this.rowToWorkWith.Properties.find(
            (p) => p.Name === 'Counted',
          ).Value = 'N';
          this.rowToWorkWith.Properties.find(
            (p) => p.Name === 'Counted',
          ).ValueAsObject = 'N';
        }
        this.resetScanFields(quantityControl, scanControl);
      } else {
        this.resetScanFields(quantityControl, scanControl);
      }
    } else {
      if (
        this.recordModel.ObjectKey === 'oStockTransfer' &&
        this.rowToWorkWith['BinActivate'] === 'Y' &&
        this.rowToWorkWith['FromBinActivate'] === 'Y' &&
        !fromToBin
      ) {
        setTimeout(() => {
          this.binLocationToS.focus();
        }, 1000);

        return;
      }

      this.rowToWorkWith['ScannedQty'] += parseInt(quantityControl.value);

      const properties = this.rowToWorkWith.Properties;

      this.quantityFieldPropertyName =
        this.section.AdditionalInformationParsed.QuantityFieldPropertyName;
      if (
        this.quantityFieldPropertyName == null ||
        this.quantityFieldPropertyName === undefined ||
        this.quantityFieldPropertyName === ''
      ) {
        this.quantityFieldPropertyName = 'Quantity';
      }

      let qtyProp = properties.find(
        (p) => p.Name === this.quantityFieldPropertyName,
      );

      let maxAllowedQtyProp = properties.find(
        (p) => p.Name === 'MaxAllowedQty',
      );
      if (maxAllowedQtyProp != null && maxAllowedQtyProp !== undefined) {
        if (
          parseFloat(qtyProp.ValueAsObject) + this.scannedQty >
          parseFloat(maxAllowedQtyProp.ValueAsObject)
        ) {
          this.notificationService.create(
            'warning',
            this.layoutService.translate(
              'The selected quantity ' +
                (parseFloat(qtyProp.ValueAsObject) + this.scannedQty) +
                ' exceeds the allowed quantity ' +
                parseFloat(maxAllowedQtyProp.ValueAsObject),
            ),
            '',
          );

          let audio = new Audio('assets/audio_file.mp3');
          audio.load();
          audio.play();

          this.resetScanFields(quantityControl, scanControl);
          return;
        }
      }

      let binAbs = properties.find((p) => p.Name === 'BinAbs');
      if (binAbs == null || binAbs === undefined) {
        binAbs = properties.find((p) => p.Name === 'BinEntry');
      }

      let numPerSale = 1;
      if (
        this.rowToWorkWith.Properties.find(
          (p) => p.Name === 'UnitsOfMeasurment' || p.Name === 'NumInCnt',
        ) === undefined
      ) {
        numPerSale = 1;
      } else {
        numPerSale = this.rowToWorkWith.Properties.find(
          (p) => p.Name === 'UnitsOfMeasurment' || p.Name === 'NumInCnt',
        ).ValueAsObject as number;
      }

      if (numPerSale == null) {
        numPerSale = 1;
      }

      const warehouseCodeProp = this.rowToWorkWith.Properties.find(
        (prop) => prop.Name === 'WarehouseCode',
      );
      const fromWarehouseCodeProp = this.rowToWorkWith.Properties.find(
        (prop) => prop.Name === 'FromWarehouse',
      );
      let warehouseCode = '';
      let toWarehouseCode = '';
      if (
        fromWarehouseCodeProp == null ||
        fromWarehouseCodeProp === undefined
      ) {
        if (warehouseCodeProp != null && warehouseCodeProp !== undefined) {
          warehouseCode = warehouseCodeProp.ValueAsObject;
        }
      } else {
        warehouseCode = fromWarehouseCodeProp.ValueAsObject;
        toWarehouseCode = warehouseCodeProp.ValueAsObject;
      }

      let itemCode = this.rowToWorkWith.Properties.find(
        (prop) => prop.Name === 'ItemCode',
      )?.ValueAsObject;

      /*let itemDescription = this.rowToWorkWith.Properties.find(
        (prop) =>
          prop.Name === 'ItemDescription' ||
          prop.Name === 'ItemName' ||
          prop.Name == 'ItemDesc'
      ).ValueAsObject;*/

      let itmSerialNumber = this.rowToWorkWith.Properties.find(
        (prop) => prop.Name === 'ITMSerialNumber',
      )?.ValueAsObject as string;

      if (itmSerialNumber == null || itmSerialNumber === undefined) {
        itmSerialNumber = '';
      }

      /*const uomEntry = this.rowToWorkWith.Properties.find(
        (prop) => prop.Name === 'UoMEntry'
      ).ValueAsObject as string;*/

      itmSerialNumber =
        itmSerialNumber.charAt(0) === ','
          ? itmSerialNumber.substring(1)
          : itmSerialNumber;

      if (!this.checkUniqueBatchRule(scanControl, itmSerialNumber)) {
        this.resetScanFields(quantityControl, scanControl);
        return;
      }

      if (
        this.recordModel.ObjectKey === 'oPurchaseDeliveryNotes' ||
        this.recordModel.ObjectKey === 'oStockTransfer'
      ) {
        if (this.isNew) {
          qtyProp.ValueAsObject = this.scannedQty;
          this.isNew = false;
        } else {
          qtyProp.ValueAsObject =
            parseFloat(qtyProp.ValueAsObject) + this.scannedQty;
        }
      } else if (
        this.recordModel.ObjectKey === 'InventoryCounting' ||
        this.recordModel.ObjectKey === 'InventoryPosting'
      ) {
        if (this.global.inCountingNormalItemDisplayConfirmMessage) {
          let confirmChoice = confirm(
            this.layoutService
              .translate(
                'Item _ITEM_CODE_ with _QTY_ is to be counted, you want to proceed?',
              )
              .replace('_ITEM_CODE_', itemCode)
              .replace('_QTY_', this.scannedQty.toString()),
          );
          if (confirmChoice) {
            qtyProp = properties.find((p) => p.Name === 'UoMCountedQuantity');
            //const binEntryProp = properties.find((p) => p.Name === 'BinEntry');

            qtyProp.ValueAsObject =
              Number(qtyProp.ValueAsObject) + Number(this.scannedQty);

            if (this.setCountedAsChecked) {
              this.rowToWorkWith.Properties.find(
                (p) => p.Name === 'Counted',
              ).Value = 'Y';
              this.rowToWorkWith.Properties.find(
                (p) => p.Name === 'Counted',
              ).ValueAsObject = 'Y';
            }
          } else {
            this.resetScanFields(quantityControl, scanControl);
            return;
          }
        } else {
          qtyProp = properties.find((p) => p.Name === 'UoMCountedQuantity');
          //const binEntryProp = properties.find((p) => p.Name === 'BinEntry');

          qtyProp.ValueAsObject =
            Number(qtyProp.ValueAsObject) + Number(this.scannedQty);

          if (this.setCountedAsChecked) {
            this.rowToWorkWith.Properties.find(
              (p) => p.Name === 'Counted',
            ).Value = 'Y';
            this.rowToWorkWith.Properties.find(
              (p) => p.Name === 'Counted',
            ).ValueAsObject = 'Y';
          }
        }
      } else if (this.recordModel.ObjectKey === 'oPickLists') {
        const releasedQuantity = properties.find(
          (p) => p.Name === 'ReleasedQuantity',
        );
        const orig_PickedQuantity = properties.find(
          (p) => p.Name === 'Orig_PickedQuantity',
        );

        qtyProp = properties.find((p) => p.Name === 'PickedQuantity');
        let tempNewVal =
          (qtyProp.ValueAsObject == null ||
          qtyProp.ValueAsObject === undefined ||
          qtyProp.ValueAsObject.toString() === ''
            ? 0
            : parseFloat(qtyProp.ValueAsObject)) + this.scannedQty;
        let tempMaxVal =
          parseFloat(releasedQuantity.ValueAsObject) +
          (orig_PickedQuantity.ValueAsObject == null ||
          orig_PickedQuantity.ValueAsObject === undefined ||
          orig_PickedQuantity.ValueAsObject.toString() === ''
            ? 0
            : parseFloat(orig_PickedQuantity.ValueAsObject));

        if (tempNewVal > tempMaxVal) {
          this.notificationService.create(
            'warning',
            this.layoutService.translate(
              'The selected quantity ' +
                tempNewVal +
                ' exceeds the released quantity' +
                tempMaxVal,
            ),
            '',
          );

          let audio = new Audio('assets/audio_file.mp3');
          audio.load();
          audio.play();

          return;
        }
        qtyProp.ValueAsObject =
          parseFloat(qtyProp.ValueAsObject) + this.scannedQty;

        if (
          this.rowToWorkWith['BinActivate'] === 'Y' &&
          this.rowToWorkWith['ManBtchNum'] !== 'Y' &&
          this.rowToWorkWith['ManSerNum'] !== 'Y'
        ) {
          let itmSerialNumberObj = [];

          if (itmSerialNumber !== '') {
            itmSerialNumberObj = JSON.parse(`[${itmSerialNumber}]`) as any[];
          }

          const existingBin = itmSerialNumberObj.find(
            (b) => b.BinLocation.toString() === binAbs.ValueAsObject.toString(),
          );
          if (existingBin !== undefined) {
            itmSerialNumberObj.find(
              (b) =>
                b.BinLocation.toString() === binAbs.ValueAsObject.toString(),
            ).Quantity = qtyProp.ValueAsObject * 1;
          } else {
            itmSerialNumberObj.push({
              Quantity: qtyProp.ValueAsObject * 1,
              BinLocation: binAbs.ValueAsObject,
              FromBinLocation: binAbs.ValueAsObject,
            });
          }

          const jsonToSave = JSON.stringify(itmSerialNumberObj);

          this.setITMSerialBatchNumberValue(
            jsonToSave.substring(1, jsonToSave.length - 1),
          );
        }
      } else {
        if (this.recordModel.ObjectKey === 'ITM_WMS_SSCC') {
          let palletPercentage = 0;
          let rowPalletPercentage = 0;
          let rowLineCapacity = 0;
          for (let i = 0; i < this.lines.length; i++) {
            if (
              this.lines[i]['ManBtchNum'] != 'Y' &&
              this.lines[i]['ManSerNum'] != 'Y'
            ) {
              continue;
            }
            const lineProps = this.lines[i].Properties;
            let lineQty = Number(
              lineProps.find((p) => p.Name === 'Quantity').ValueAsObject,
            );
            let lineCapacity = Number(
              lineProps.find((p) => p.Name === 'PalletCapacity').ValueAsObject,
            );
            let lineMixed = lineProps.find(
              (p) => p.Name === 'InMixed',
            ).ValueAsObject;
            if (lineMixed != 'Y') {
              continue;
            }
            if (this.lines[i].Id === this.rowToWorkWith.Id) {
              rowPalletPercentage += (lineQty + this.scannedQty) / lineCapacity;
              rowLineCapacity = lineCapacity;
            } else {
              palletPercentage += lineQty / lineCapacity;
            }
          }

          if (
            Number.isFinite(rowPalletPercentage) &&
            palletPercentage + rowPalletPercentage > 1
          ) {
            rowPalletPercentage = 1 - palletPercentage;
            let confirmChoice = confirm(
              this.layoutService.translate(
                'The selected quantity exceeds the pallet size, do you want to continue?',
              ),
            );
            if (!confirmChoice) {
              if (qtyProp.ValueAsObject == 0) {
                this.scannedQty = Math.floor(
                  rowPalletPercentage * rowLineCapacity,
                );
              } else {
                this.scannedQty = Math.floor(
                  rowPalletPercentage * rowLineCapacity - qtyProp.ValueAsObject,
                );
              }
            }
          }
        }
        if (
          qtyProp.ValueAsObject == null ||
          qtyProp.ValueAsObject === undefined ||
          qtyProp.ValueAsObject === ''
        ) {
          qtyProp.ValueAsObject = this.scannedQty;
        } else {
          let newQty = Number(
            accounting.formatNumber(
              parseFloat(qtyProp.ValueAsObject) + Number(this.scannedQty),
              g.companyConfiguration.QuantityDecimal,
              g.companyConfiguration.ThousandSep,
              g.companyConfiguration.DecimalSep,
            ),
          );
          console.log(newQty);
          if (isNaN(newQty)) {
            newQty =
              parseFloat(qtyProp.ValueAsObject) + Number(this.scannedQty);
          }
          qtyProp.ValueAsObject = newQty;
        }
      }

      if (
        this.rowToWorkWith['ManBtchNum'] === 'Y' &&
        this.scanMode !== 'Batch' &&
        this.scanMode !== 'QR'
      ) {
        const property = this.quantityToWorkWith;
        property.DialogVisibleDrawerInitialized = true;
        setTimeout(() => {
          property.DialogVisible = true;
        }, 200);

        this.rowToWorkWith = undefined;
        quantityControl.value = '';
        scanControl.value = '';
        scanControl.disabled = false;
      } else if (this.scanMode !== 'Box' && this.scanMode !== 'NewBox') {
        let valueToSave = itmSerialNumber;

        if (
          this.rowToWorkWith['ManBtchNum'] === 'Y' ||
          this.rowToWorkWith['ManSerNum'] === 'Y'
        ) {
          let baseLine = this.rowToWorkWith.Properties.find(
            (prop) => prop.Name === 'BaseLine',
          )?.ValueAsObject;
          if (baseLine == null || baseLine === undefined || baseLine === '') {
            baseLine = '-1';
          }

          this.layoutService
            .executeQuery(
              this.moduleStructure.module.ObjectType === 'InventoryCounting' ||
                this.moduleStructure.module.ObjectType === 'oReturns'
                ? 2859
                : 2765,
              {
                Scan: this.batchScanFieldVisible
                  ? this.scanBatchControl.nativeElement.value
                  : /*scanControl.value*/ scannedValue,
                BaseEntry: this.recordModel.SourceObjectId,
                ObjectType:
                  this.moduleStructure.module.ObjectType === 'oReturns'
                    ? g.lookForBatchInBaseForReturn
                      ? this.moduleStructure.module.ObjectType
                      : 'oReturns1'
                    : this.moduleStructure.module.ObjectType,
                BaseLine: baseLine,
              },
            )
            .subscribe((result: any) => {
              console.log('batch scanned result', result);

              if (result.length === 0) {
                if (
                  this.rowToWorkWith['ManBtchNum'] === 'N' &&
                  this.rowToWorkWith['ManSerNum'] === 'N' &&
                  this.cumulativeModeForNormalItems
                ) {
                  //this.rowToWorkWith = undefined;
                  quantityControl.value = '';
                  this.scannedQty = undefined;
                  quantityControl.focus();
                  //scanControl.value = '';
                  //scanControl.focus();
                  //this.shouldFocusOnScanControl = true;
                  return;
                } else {
                  this.resetScanFields(quantityControl, scanControl);
                  return;
                }
              }

              let dbBatch = result[0].DistNumber;
              let expDate = result[0].ExpDate;
              let mnfSerial = result[0].MnfSerial;
              let inDate = result[0].InDate;

              console.log('result[0]', result[0]);

              const batchNumbersTemp = JSON.parse(`[${itmSerialNumber}]`);
              batchNumbersTemp.forEach((bn) => {
                bn.Quantity = bn.Quantity / numPerSale;
              });

              if (batchNumbersTemp.length === 0) {
                this.checkQuantityExceedRule(this.scannedQty);

                if (
                  this.rowToWorkWith['FromBinActivate'] === 'Y' &&
                  this.rowToWorkWith['BinActivate'] === 'Y'
                ) {
                  batchNumbersTemp.push({
                    Quantity: this.scannedQty * numPerSale,
                    BatchNumber: dbBatch,
                    /*BatchNumber:
                    this.moduleStructure.module.ObjectType === 'oReturns'
                      ? '-'
                      : dbBatch,*/
                    ExpDate: expDate,
                    AddmisionDate:
                      this.moduleStructure.module.ObjectType !== 'oReturns'
                        ? inDate
                        : moment(new Date()).format(
                            g.companyConfiguration.MomentDateFormat,
                          ),
                    MnfSerial: mnfSerial,
                    //BinLocation: binAbs.ValueAsObject,
                    BinLocation:
                      this.binCode == null ||
                      this.binCode === undefined ||
                      this.binCode === ''
                        ? binAbs.ValueAsObject
                        : this.binCode,
                    //FromBinLocation: binAbs.ValueAsObject,
                    FromBinLocation:
                      this.fromBinCode != null &&
                      this.fromBinCode !== undefined &&
                      this.fromBinCode !== ''
                        ? this.fromBinCode
                        : this.binCode == null ||
                            this.binCode === undefined ||
                            this.binCode === ''
                          ? binAbs.ValueAsObject
                          : this.binCode,
                  });

                  let binLocationProp = this.rowToWorkWith.Properties.find(
                    (p) => p.Name === 'BinLocation',
                  );
                  if (
                    binLocationProp != null &&
                    binLocationProp !== undefined
                  ) {
                    binLocationProp.Value = this.binCode;
                    binLocationProp.ValueAsObject = this.binCode;
                  }
                } else if (
                  (this.rowToWorkWith['FromBinActivate'] == null ||
                    this.rowToWorkWith['FromBinActivate'] === 'N') &&
                  this.rowToWorkWith['BinActivate'] === 'Y'
                ) {
                  batchNumbersTemp.push({
                    Quantity: this.scannedQty * numPerSale,
                    BatchNumber: dbBatch,
                    /*BatchNumber:
                    this.moduleStructure.module.ObjectType === 'oReturns'
                      ? '-'
                      : dbBatch,*/
                    ExpDate: expDate,
                    AddmisionDate:
                      this.moduleStructure.module.ObjectType !== 'oReturns'
                        ? inDate
                        : moment(new Date()).format(
                            g.companyConfiguration.MomentDateFormat,
                          ),
                    MnfSerial: mnfSerial,
                    //BinLocation: binAbs.ValueAsObject,
                    BinLocation:
                      this.binCode == null ||
                      this.binCode === undefined ||
                      this.binCode === ''
                        ? binAbs.ValueAsObject
                        : this.binCode,
                  });

                  let binLocationProp = this.rowToWorkWith.Properties.find(
                    (p) => p.Name === 'BinLocation',
                  );
                  if (
                    binLocationProp != null &&
                    binLocationProp !== undefined
                  ) {
                    binLocationProp.Value = this.binCode;
                    binLocationProp.ValueAsObject = this.binCode;
                  }
                } else if (
                  this.rowToWorkWith['FromBinActivate'] === 'Y' &&
                  (this.rowToWorkWith['BinActivate'] == null ||
                    this.rowToWorkWith['BinActivate'] === 'N')
                ) {
                  batchNumbersTemp.push({
                    Quantity: this.scannedQty * numPerSale,
                    BatchNumber: dbBatch,
                    /*BatchNumber:
                    this.moduleStructure.module.ObjectType === 'oReturns'
                      ? '-'
                      : dbBatch,*/
                    ExpDate: expDate,
                    AddmisionDate:
                      this.moduleStructure.module.ObjectType !== 'oReturns'
                        ? inDate
                        : moment(new Date()).format(
                            g.companyConfiguration.MomentDateFormat,
                          ),
                    MnfSerial: mnfSerial,
                    //BinLocation: binAbs.ValueAsObject,
                    FromBinLocation:
                      this.fromBinCode != null &&
                      this.fromBinCode !== undefined &&
                      this.fromBinCode !== ''
                        ? this.fromBinCode
                        : this.binCode == null ||
                            this.binCode === undefined ||
                            this.binCode === ''
                          ? binAbs.ValueAsObject
                          : this.binCode,
                  });

                  let binLocationProp = this.rowToWorkWith.Properties.find(
                    (p) => p.Name === 'BinLocation',
                  );
                  if (
                    binLocationProp != null &&
                    binLocationProp !== undefined
                  ) {
                    binLocationProp.Value = this.binCode;
                    binLocationProp.ValueAsObject = this.binCode;
                  }
                } else {
                  batchNumbersTemp.push({
                    Quantity: this.scannedQty * numPerSale,
                    BatchNumber: dbBatch,
                    /*BatchNumber:
                    this.moduleStructure.module.ObjectType === 'oReturns'
                      ? '-'
                      : dbBatch,*/
                    ExpDate: expDate,
                    AddmisionDate:
                      this.moduleStructure.module.ObjectType !== 'oReturns'
                        ? inDate
                        : moment(new Date()).format(
                            g.companyConfiguration.MomentDateFormat,
                          ),
                    MnfSerial: mnfSerial,
                  });
                }

                const jsonToSave = JSON.stringify(batchNumbersTemp);
                valueToSave = jsonToSave.substring(1, jsonToSave.length - 1);
              } else {
                let batchTemp = batchNumbersTemp.find(
                  (b) =>
                    ((this.moduleStructure.module.ObjectType !== 'oReturns' &&
                      (b.BatchNumber === dbBatch ||
                        (b.MnfSerial != null && b.MnfSerial === mnfSerial))) ||
                      (this.moduleStructure.module.ObjectType === 'oReturns' &&
                        b.BatchNumber !== '-' &&
                        b.BatchNumber === dbBatch) ||
                      (b.BatchNumber === '-' &&
                        b.MnfSerial != null &&
                        b.MnfSerial === mnfSerial)) &&
                    ((this.rowToWorkWith['BinActivate'] === 'Y' &&
                      b.BinLocation ===
                        (this.binCode == null ||
                        this.binCode === undefined ||
                        this.binCode === ''
                          ? binAbs.ValueAsObject
                          : this.binCode)) ||
                      this.rowToWorkWith['BinActivate'] !== 'Y') &&
                    ((this.rowToWorkWith['FromBinActivate'] === 'Y' &&
                      b.FromBinLocation ===
                        (this.fromBinCode != null &&
                        this.fromBinCode !== undefined &&
                        this.fromBinCode !== ''
                          ? this.fromBinCode
                          : this.binCode == null ||
                              this.binCode === undefined ||
                              this.binCode === ''
                            ? binAbs.ValueAsObject
                            : this.binCode)) ||
                      this.rowToWorkWith['FromBinActivate'] !== 'Y'),
                );

                if (batchTemp != null && batchTemp !== undefined) {
                  batchTemp.Quantity = batchTemp.Quantity + this.scannedQty;

                  this.checkQuantityExceedRule(batchTemp.Quantity);

                  batchNumbersTemp.forEach((bn) => {
                    bn.Quantity = bn.Quantity * numPerSale;
                  });
                } else {
                  this.checkQuantityExceedRule(this.scannedQty);

                  batchNumbersTemp.forEach((bn) => {
                    bn.Quantity = bn.Quantity * numPerSale;
                  });

                  if (
                    this.rowToWorkWith['FromBinActivate'] === 'Y' &&
                    this.rowToWorkWith['BinActivate'] === 'Y'
                  ) {
                    batchNumbersTemp.push({
                      Quantity: this.scannedQty * numPerSale,
                      BatchNumber: dbBatch,
                      /*BatchNumber:
                    this.moduleStructure.module.ObjectType === 'oReturns'
                      ? '-'
                      : dbBatch,*/
                      ExpDate: expDate,
                      AddmisionDate:
                        this.moduleStructure.module.ObjectType !== 'oReturns'
                          ? inDate
                          : moment(new Date()).format(
                              g.companyConfiguration.MomentDateFormat,
                            ),
                      MnfSerial: mnfSerial,
                      //BinLocation: binAbs.ValueAsObject,
                      BinLocation:
                        this.binCode == null ||
                        this.binCode === undefined ||
                        this.binCode === ''
                          ? binAbs.ValueAsObject
                          : this.binCode,
                      //FromBinLocation: binAbs.ValueAsObject,
                      FromBinLocation:
                        this.fromBinCode != null &&
                        this.fromBinCode !== undefined &&
                        this.fromBinCode !== ''
                          ? this.fromBinCode
                          : this.binCode == null ||
                              this.binCode === undefined ||
                              this.binCode === ''
                            ? binAbs.ValueAsObject
                            : this.binCode,
                    });

                    let binLocationProp = this.rowToWorkWith.Properties.find(
                      (p) => p.Name === 'BinLocation',
                    );
                    if (
                      binLocationProp != null &&
                      binLocationProp !== undefined
                    ) {
                      binLocationProp.Value = this.binCode;
                      binLocationProp.ValueAsObject = this.binCode;
                    }
                  } else if (
                    (this.rowToWorkWith['FromBinActivate'] == null ||
                      this.rowToWorkWith['FromBinActivate'] === 'N') &&
                    this.rowToWorkWith['BinActivate'] === 'Y'
                  ) {
                    batchNumbersTemp.push({
                      Quantity: this.scannedQty * numPerSale,
                      BatchNumber: dbBatch,
                      /*BatchNumber:
                    this.moduleStructure.module.ObjectType === 'oReturns'
                      ? '-'
                      : dbBatch,*/
                      ExpDate: expDate,
                      AddmisionDate:
                        this.moduleStructure.module.ObjectType !== 'oReturns'
                          ? inDate
                          : moment(new Date()).format(
                              g.companyConfiguration.MomentDateFormat,
                            ),
                      MnfSerial: mnfSerial,
                      //BinLocation: binAbs.ValueAsObject,
                      BinLocation:
                        this.binCode == null ||
                        this.binCode === undefined ||
                        this.binCode === ''
                          ? binAbs.ValueAsObject
                          : this.binCode,
                    });

                    let binLocationProp = this.rowToWorkWith.Properties.find(
                      (p) => p.Name === 'BinLocation',
                    );
                    if (
                      binLocationProp != null &&
                      binLocationProp !== undefined
                    ) {
                      binLocationProp.Value = this.binCode;
                      binLocationProp.ValueAsObject = this.binCode;
                    }
                  } else if (
                    this.rowToWorkWith['FromBinActivate'] === 'Y' &&
                    (this.rowToWorkWith['BinActivate'] == null ||
                      this.rowToWorkWith['BinActivate'] === 'N')
                  ) {
                    batchNumbersTemp.push({
                      Quantity: this.scannedQty * numPerSale,
                      BatchNumber: dbBatch,
                      /*BatchNumber:
                    this.moduleStructure.module.ObjectType === 'oReturns'
                      ? '-'
                      : dbBatch,*/
                      ExpDate: expDate,
                      AddmisionDate:
                        this.moduleStructure.module.ObjectType !== 'oReturns'
                          ? inDate
                          : moment(new Date()).format(
                              g.companyConfiguration.MomentDateFormat,
                            ),
                      MnfSerial: mnfSerial,
                      //FromBinLocation: binAbs.ValueAsObject,
                      FromBinLocation:
                        this.fromBinCode != null &&
                        this.fromBinCode !== undefined &&
                        this.fromBinCode !== ''
                          ? this.fromBinCode
                          : this.binCode == null ||
                              this.binCode === undefined ||
                              this.binCode === ''
                            ? binAbs.ValueAsObject
                            : this.binCode,
                    });
                  } else {
                    batchNumbersTemp.push({
                      Quantity: this.scannedQty * numPerSale,
                      BatchNumber: dbBatch,
                      /*BatchNumber:
                    this.moduleStructure.module.ObjectType === 'oReturns'
                      ? '-'
                      : dbBatch,*/
                      ExpDate: expDate,
                      AddmisionDate:
                        this.moduleStructure.module.ObjectType !== 'oReturns'
                          ? inDate
                          : moment(new Date()).format(
                              g.companyConfiguration.MomentDateFormat,
                            ),
                      MnfSerial: mnfSerial,
                    });
                  }

                  // const batchValue = {
                  //   Quantity: this.scannedQty * numPerSale,
                  //   BatchNumber:
                  //     /*this.moduleStructure.module.ObjectType === 'oReturns'
                  //   ? '-'
                  //   :*/ dbBatch,
                  //   ExpDate: expDate,
                  //   AddmisionDate:
                  //     this.moduleStructure.module.ObjectType !== 'oReturns'
                  //       ? inDate
                  //       : moment(new Date()).format(
                  //           g.companyConfiguration.MomentDateFormat
                  //         ),
                  //   MnfSerial: mnfSerial,
                  // };

                  // batchNumbersTemp.push(batchValue);
                }

                const jsonToSave = JSON.stringify(batchNumbersTemp);
                valueToSave = jsonToSave.substring(1, jsonToSave.length - 1);
              }

              const itmSerialNumberTemp = JSON.parse(`[${valueToSave}]`);

              let tempQty = 0;
              itmSerialNumberTemp.forEach((bn) => {
                tempQty += Number(bn.Quantity / numPerSale);
              });

              if (
                this.moduleStructure.module.ObjectType ===
                  'InventoryCounting' &&
                this.global.inCountingBatchDisplayDetailMessage
              ) {
                let scanQty = this.scannedQty;
                this.modal.success({
                  nzContent: this.layoutService
                    .translate(
                      '{#BATCH} of the {#ITEMCODE} with {#QTY} has been counted',
                    )
                    .replace('{#BATCH}', /*scanControl.value*/ scannedValue)
                    .replace('{#ITEMCODE}', itemCode)
                    .replace('{#QTY}', scanQty + ''),
                  nzCloseOnNavigation: true,
                });
              }

              this.setITMSerialBatchNumberValue(valueToSave);

              let newQty = Number(
                accounting.formatNumber(
                  tempQty,
                  g.companyConfiguration.QuantityDecimal,
                  g.companyConfiguration.ThousandSep,
                  g.companyConfiguration.DecimalSep,
                ),
              );

              if (isNaN(newQty)) {
                newQty = tempQty;
              }
              qtyProp.ValueAsObject = newQty;

              if (fromAuto) {
                scanControl.disabled = false;
                quantityControl.value = '';
                scanControl.select();
                scanControl.focus();
                //this.shouldFocusOnScanControl = true;
              } else {
                this.resetScanFields(quantityControl, scanControl);
              }
            });
        } else {
          const batchNumbersTemp = JSON.parse(`[${itmSerialNumber}]`);
          batchNumbersTemp.forEach((bn) => {
            bn.Quantity = bn.Quantity / numPerSale;
          });

          if (batchNumbersTemp.length === 0) {
            if (
              this.rowToWorkWith['BinActivate'] === 'Y' &&
              this.rowToWorkWith['FromBinActivate'] === 'Y'
            ) {
              batchNumbersTemp.push({
                Quantity: this.scannedQty * numPerSale,
                BinLocation: this.binCode,
                FromBinLocation: this.fromBinCode,
              });

              const jsonToSave = JSON.stringify(batchNumbersTemp);
              valueToSave = jsonToSave.substring(1, jsonToSave.length - 1);
            }
          } else {
            if (
              this.rowToWorkWith['BinActivate'] === 'Y' &&
              this.rowToWorkWith['FromBinActivate'] === 'Y'
            ) {
              let alreadyFound = batchNumbersTemp.find((bn) => {
                if (
                  bn.BinLocation === this.binCode &&
                  bn.FromBinLocation === this.fromBinCode
                ) {
                  return bn;
                }
              });
              if (alreadyFound !== undefined) {
                alreadyFound.Quantity += this.scannedQty * numPerSale;
              } else {
                batchNumbersTemp.push({
                  Quantity: this.scannedQty * numPerSale,
                  BinLocation: this.binCode,
                  FromBinLocation: this.fromBinCode,
                });
              }

              const jsonToSave = JSON.stringify(batchNumbersTemp);
              valueToSave = jsonToSave.substring(1, jsonToSave.length - 1);
            }
          }

          this.setITMSerialBatchNumberValue(valueToSave);

          let showSuccessMessage =
            this.rowToWorkWith['ManBtchNum'] === 'N' &&
            this.rowToWorkWith['ManSerNum'] === 'N' &&
            this.moduleStructure.module.ObjectType === 'InventoryCounting' &&
            this.global.inCountingNormalItemisplayDetailMessage;

          if (
            this.rowToWorkWith['ManBtchNum'] === 'N' &&
            this.rowToWorkWith['ManSerNum'] === 'N' &&
            ((this.moduleStructure.module.ObjectType !== 'InventoryCounting' &&
              this.cumulativeModeForNormalItems) ||
              (this.moduleStructure.module.ObjectType === 'InventoryCounting' &&
                this.cumulativeModeForNormalItems &&
                !this.global.inCountingDisableCumulativeModeForNormal))
          ) {
            if (showSuccessMessage) {
              let scanValue = /*scanControl.value*/ scannedValue;
              let scanQty = this.scannedQty;
              setTimeout(() => {
                this.modal.success({
                  nzContent: this.layoutService
                    .translate('{#ITEMCODE} with {#QTY} has been counted')
                    .replace('{#ITEMCODE}', scanValue)
                    .replace('{#QTY}', scanQty + ''),
                  nzCloseOnNavigation: true,
                });
              }, 1000);
            }

            //this.rowToWorkWith = undefined;
            quantityControl.value = '';
            this.scannedQty = undefined;
            quantityControl.focus();
            //scanControl.value = '';
            //scanControl.focus();
            //this.shouldFocusOnScanControl = true;
            return;
          } else {
            if (showSuccessMessage) {
              let scanValue = /*scanControl.value*/ scannedValue;
              let scanQty = this.scannedQty;
              setTimeout(() => {
                this.modal.success({
                  nzContent: this.layoutService
                    .translate('{#ITEMCODE} with {#QTY} has been counted')
                    .replace('{#ITEMCODE}', scanValue)
                    .replace('{#QTY}', scanQty + ''),
                  nzCloseOnNavigation: true,
                });
              }, 1000);
            }

            this.resetScanFields(quantityControl, scanControl);
            return;
          }
        }
      }

      if (!fromAuto) {
        if (
          this.moduleStructure.module.ObjectType !== 'InventoryCounting' &&
          this.moduleStructure.module.ObjectType !== 'oInventoryGenEntry' &&
          this.openQuantityToWorkWith !== undefined &&
          this.openQuantityToWorkWith.ValueAsObject !== '' &&
          this.openQuantityToWorkWith.ValueAsObject !== 0 &&
          this.quantityToWorkWith.ValueAsObject >
            this.openQuantityToWorkWith.ValueAsObject
        ) {
          this.notificationService.create(
            'warning',
            this.layoutService.translate(
              'The selected quantity ' +
                this.quantityToWorkWith.ValueAsObject +
                ' exceeds the open quantity' +
                this.openQuantityToWorkWith.ValueAsObject,
            ),
            '',
          );

          let audio = new Audio('assets/audio_file.mp3');
          audio.load();
          audio.play();
        }

        if (
          this.moduleStructure.module.ObjectType !== 'InventoryCounting' &&
          this.moduleStructure.module.ObjectType !== 'oInventoryGenEntry' &&
          this.scanMode !== 'Box' &&
          this.scanMode !== 'NewBox'
        ) {
          let showFullMessage = true;
          for (let i = 0; i < this.lines.length; i++) {
            const properties = this.lines[i].Properties;
            const quantity = properties.find(
              (p) => p.Name === 'Quantity',
            ).ValueAsObject;
            const openQty = properties.find(
              (p) => p.Name === 'OpenQty',
            ).ValueAsObject;
            if (quantity < openQty) {
              showFullMessage = false;
              break;
            }
          }
          if (showFullMessage) {
            this.notificationService.create(
              'success',
              this.layoutService.translate(
                'You have scanned all open quantities',
              ),
              '',
            );
          }
        }
        if (this.scanMode === 'Box' || this.scanMode === 'NewBox') {
          this.resetScanFields(quantityControl, scanControl);
          return;
        }
      }
    }
  }

  quantityScannedQR(
    scanControl,
    quantityControl,
    batch,
    key = undefined,
    fromAuto = false,
  ) {
    if (key !== undefined && key.keyCode !== 13) {
      return;
    }

    this.rowToWorkWith['ScannedQty'] += parseInt(quantityControl.value);

    const properties = this.rowToWorkWith.Properties;

    this.quantityFieldPropertyName =
      this.section.AdditionalInformationParsed.QuantityFieldPropertyName;
    if (
      this.quantityFieldPropertyName == null ||
      this.quantityFieldPropertyName === undefined ||
      this.quantityFieldPropertyName === ''
    ) {
      this.quantityFieldPropertyName = 'Quantity';
    }

    let qtyProp = properties.find(
      (p) => p.Name === this.quantityFieldPropertyName,
    );

    let binAbs = properties.find((p) => p.Name === 'BinAbs');
    if (binAbs == null || binAbs === undefined) {
      binAbs = properties.find((p) => p.Name === 'BinEntry');
    }

    let numPerSale = 1;
    if (
      this.rowToWorkWith.Properties.find(
        (p) => p.Name === 'UnitsOfMeasurment' || p.Name === 'NumInCnt',
      ) === undefined
    ) {
      numPerSale = 1;
    } else {
      numPerSale = this.rowToWorkWith.Properties.find(
        (p) => p.Name === 'UnitsOfMeasurment' || p.Name === 'NumInCnt',
      ).ValueAsObject as number;
    }

    if (numPerSale == null) {
      numPerSale = 1;
    }

    const warehouseCodeProp = this.rowToWorkWith.Properties.find(
      (prop) => prop.Name === 'WarehouseCode',
    );
    const fromWarehouseCodeProp = this.rowToWorkWith.Properties.find(
      (prop) => prop.Name === 'FromWarehouse',
    );
    let warehouseCode = '';
    let toWarehouseCode = '';
    if (fromWarehouseCodeProp == null || fromWarehouseCodeProp === undefined) {
      if (warehouseCodeProp != null && warehouseCodeProp !== undefined) {
        warehouseCode = warehouseCodeProp.ValueAsObject;
      }
    } else {
      warehouseCode = fromWarehouseCodeProp.ValueAsObject;
      toWarehouseCode = warehouseCodeProp.ValueAsObject;
    }

    let itemCode = this.rowToWorkWith.Properties.find(
      (prop) => prop.Name === 'ItemCode',
    )?.ValueAsObject;

    /*let itemDescription = this.rowToWorkWith.Properties.find(
        (prop) =>
          prop.Name === 'ItemDescription' ||
          prop.Name === 'ItemName' ||
          prop.Name == 'ItemDesc'
      ).ValueAsObject;*/

    let itmSerialNumber = this.rowToWorkWith.Properties.find(
      (prop) => prop.Name === 'ITMSerialNumber',
    )?.ValueAsObject as string;

    if (itmSerialNumber == null || itmSerialNumber === undefined) {
      itmSerialNumber = '';
    }

    /*const uomEntry = this.rowToWorkWith.Properties.find(
        (prop) => prop.Name === 'UoMEntry'
      ).ValueAsObject as string;*/

    itmSerialNumber =
      itmSerialNumber.charAt(0) === ','
        ? itmSerialNumber.substring(1)
        : itmSerialNumber;

    if (!this.checkUniqueBatchRule(scanControl, itmSerialNumber)) {
      this.resetScanFields(quantityControl, scanControl);
      return;
    }

    if (
      this.recordModel.ObjectKey === 'oPurchaseDeliveryNotes' ||
      this.recordModel.ObjectKey === 'oStockTransfer'
    ) {
      if (this.isNew) {
        qtyProp.ValueAsObject = this.scannedQty;
        this.isNew = false;
      } else {
        qtyProp.ValueAsObject =
          parseFloat(qtyProp.ValueAsObject) + this.scannedQty;
      }
    } else if (
      this.recordModel.ObjectKey === 'InventoryCounting' ||
      this.recordModel.ObjectKey === 'InventoryPosting'
    ) {
      qtyProp = properties.find((p) => p.Name === 'UoMCountedQuantity');
      //const binEntryProp = properties.find((p) => p.Name === 'BinEntry');

      qtyProp.ValueAsObject =
        Number(qtyProp.ValueAsObject) + Number(this.scannedQty);

      if (this.setCountedAsChecked) {
        this.rowToWorkWith.Properties.find((p) => p.Name === 'Counted').Value =
          'Y';
        this.rowToWorkWith.Properties.find(
          (p) => p.Name === 'Counted',
        ).ValueAsObject = 'Y';
      }
    } else if (this.recordModel.ObjectKey === 'oPickLists') {
      qtyProp = properties.find((p) => p.Name === 'PickedQuantity');
      qtyProp.ValueAsObject =
        parseFloat(qtyProp.ValueAsObject) + this.scannedQty;

      if (
        this.rowToWorkWith['BinActivate'] === 'Y' &&
        this.rowToWorkWith['ManBtchNum'] !== 'Y' &&
        this.rowToWorkWith['ManSerNum'] !== 'Y'
      ) {
        let itmSerialNumberObj = [];

        if (itmSerialNumber !== '') {
          itmSerialNumberObj = JSON.parse(`[${itmSerialNumber}]`) as any[];
        }

        const existingBin = itmSerialNumberObj.find(
          (b) => b.BinLocation.toString() === binAbs.ValueAsObject.toString(),
        );
        if (existingBin !== undefined) {
          itmSerialNumberObj.find(
            (b) => b.BinLocation.toString() === binAbs.ValueAsObject.toString(),
          ).Quantity = qtyProp.ValueAsObject * 1;
        } else {
          itmSerialNumberObj.push({
            Quantity: qtyProp.ValueAsObject * 1,
            BinLocation: binAbs.ValueAsObject,
            FromBinLocation: binAbs.ValueAsObject,
          });
        }

        const jsonToSave = JSON.stringify(itmSerialNumberObj);

        this.setITMSerialBatchNumberValue(
          jsonToSave.substring(1, jsonToSave.length - 1),
        );
      }
    } else {
      if (this.recordModel.ObjectKey === 'ITM_WMS_SSCC') {
        let palletPercentage = 0;
        let rowPalletPercentage = 0;
        let rowLineCapacity = 0;
        for (let i = 0; i < this.lines.length; i++) {
          if (
            this.lines[i]['ManBtchNum'] != 'Y' &&
            this.lines[i]['ManSerNum'] != 'Y'
          ) {
            continue;
          }
          const lineProps = this.lines[i].Properties;
          let lineQty = Number(
            lineProps.find((p) => p.Name === 'Quantity').ValueAsObject,
          );
          let lineCapacity = Number(
            lineProps.find((p) => p.Name === 'PalletCapacity').ValueAsObject,
          );
          let lineMixed = lineProps.find(
            (p) => p.Name === 'InMixed',
          ).ValueAsObject;
          if (lineMixed != 'Y') {
            continue;
          }
          if (this.lines[i].Id === this.rowToWorkWith.Id) {
            rowPalletPercentage += (lineQty + this.scannedQty) / lineCapacity;
            rowLineCapacity = lineCapacity;
          } else {
            palletPercentage += lineQty / lineCapacity;
          }
        }

        if (palletPercentage + rowPalletPercentage > 1) {
          rowPalletPercentage = 1 - palletPercentage;
          let confirmChoice = confirm(
            this.layoutService.translate(
              'The selected quantity exceeds the pallet size, do you want to continue?',
            ),
          );
          if (!confirmChoice) {
            if (qtyProp.ValueAsObject == 0) {
              this.scannedQty = Math.floor(
                rowPalletPercentage * rowLineCapacity,
              );
            } else {
              this.scannedQty = Math.floor(
                rowPalletPercentage * rowLineCapacity - qtyProp.ValueAsObject,
              );
            }
          }
        }
      }
      if (
        qtyProp.ValueAsObject == null ||
        qtyProp.ValueAsObject === undefined ||
        qtyProp.ValueAsObject === ''
      ) {
        qtyProp.ValueAsObject = this.scannedQty;
      } else {
        qtyProp.ValueAsObject =
          parseFloat(qtyProp.ValueAsObject) + Number(this.scannedQty);
      }
    }

    if (this.scanMode !== 'Box' && this.scanMode !== 'NewBox') {
      let valueToSave = itmSerialNumber;

      if (
        this.rowToWorkWith['ManBtchNum'] === 'Y' ||
        this.rowToWorkWith['ManSerNum'] === 'Y'
      ) {
        let baseLine = this.rowToWorkWith.Properties.find(
          (prop) => prop.Name === 'BaseLine',
        )?.ValueAsObject;
        if (baseLine == null || baseLine === undefined || baseLine === '') {
          baseLine = '-1';
        }

        this.layoutService
          .executeQuery(
            this.moduleStructure.module.ObjectType === 'InventoryCounting' ||
              this.moduleStructure.module.ObjectType === 'oReturns'
              ? 2859
              : 2765,
            {
              Scan: batch,
              BaseEntry: this.recordModel.SourceObjectId,
              ObjectType:
                this.moduleStructure.module.ObjectType === 'oReturns'
                  ? g.lookForBatchInBaseForReturn
                    ? this.moduleStructure.module.ObjectType
                    : 'oReturns1'
                  : this.moduleStructure.module.ObjectType,
              BaseLine: baseLine,
            },
          )
          .subscribe((result: any) => {
            console.log('batch scanned result', result);

            if (result.length === 0) {
              if (
                this.rowToWorkWith['ManBtchNum'] === 'N' &&
                this.rowToWorkWith['ManSerNum'] === 'N' &&
                this.cumulativeModeForNormalItems
              ) {
                //this.rowToWorkWith = undefined;
                quantityControl.value = '';
                this.scannedQty = undefined;
                //quantityControl.focus();
                //scanControl.value = '';
                //scanControl.focus();
                //this.shouldFocusOnScanControl = true;
                return;
              } else {
                this.resetScanFields(quantityControl, scanControl);
                return;
              }
            }

            let dbBatch = result[0].DistNumber;
            let expDate = result[0].ExpDate;
            let mnfSerial = result[0].MnfSerial;
            let inDate = result[0].InDate;

            console.log('result[0]', result[0]);
            console.log('Number(numPerSale)', Number(numPerSale));
            if (
              numPerSale == null ||
              numPerSale === undefined ||
              Number(numPerSale) === 0 ||
              isNaN(numPerSale)
            ) {
              numPerSale = 1;
            }

            const batchNumbersTemp = JSON.parse(`[${itmSerialNumber}]`);
            batchNumbersTemp.forEach((bn) => {
              bn.Quantity = bn.Quantity / numPerSale;
            });

            if (batchNumbersTemp.length === 0) {
              //this.checkQuantityExceedRule(Number(this.scannedQty));

              if (this.rowToWorkWith['BinActivate'] === 'Y') {
                batchNumbersTemp.push({
                  Quantity: Number(this.scannedQty) * numPerSale,
                  BatchNumber: dbBatch,
                  /*BatchNumber:
                    this.moduleStructure.module.ObjectType === 'oReturns'
                      ? '-'
                      : dbBatch,*/
                  ExpDate: expDate,
                  AddmisionDate:
                    this.moduleStructure.module.ObjectType !== 'oReturns'
                      ? inDate
                      : moment(new Date()).format(
                          g.companyConfiguration.MomentDateFormat,
                        ),
                  MnfSerial: mnfSerial,
                  BinLocation: binAbs.ValueAsObject,
                  FromBinLocation: binAbs.ValueAsObject,
                });
              } else {
                batchNumbersTemp.push({
                  Quantity: Number(this.scannedQty) * Number(numPerSale),
                  BatchNumber: dbBatch,
                  /*BatchNumber:
                    this.moduleStructure.module.ObjectType === 'oReturns'
                      ? '-'
                      : dbBatch,*/
                  ExpDate: expDate,
                  AddmisionDate:
                    this.moduleStructure.module.ObjectType !== 'oReturns'
                      ? inDate
                      : moment(new Date()).format(
                          g.companyConfiguration.MomentDateFormat,
                        ),
                  MnfSerial: mnfSerial,
                });
              }

              const jsonToSave = JSON.stringify(batchNumbersTemp);
              valueToSave = jsonToSave.substring(1, jsonToSave.length - 1);
            } else {
              let batchTemp = batchNumbersTemp.find(
                (b) =>
                  (this.moduleStructure.module.ObjectType !== 'oReturns' &&
                    (b.BatchNumber === dbBatch ||
                      (b.MnfSerial != null &&
                        b.MnfSerial !== '' &&
                        b.MnfSerial === mnfSerial))) ||
                  (this.moduleStructure.module.ObjectType === 'oReturns' &&
                    b.BatchNumber !== '-' &&
                    b.BatchNumber === dbBatch) ||
                  (b.BatchNumber === '-' &&
                    b.MnfSerial != null &&
                    b.MnfSerial === mnfSerial),
              );

              if (batchTemp != null && batchTemp !== undefined) {
                batchTemp.Quantity =
                  batchTemp.Quantity + Number(this.scannedQty);

                this.checkQuantityExceedRule(batchTemp.Quantity);

                batchNumbersTemp.forEach((bn) => {
                  bn.Quantity = bn.Quantity * numPerSale;
                });
              } else {
                this.checkQuantityExceedRule(Number(this.scannedQty));

                batchNumbersTemp.forEach((bn) => {
                  bn.Quantity = bn.Quantity * numPerSale;
                });
                const batchValue = {
                  Quantity: Number(this.scannedQty) * numPerSale,
                  BatchNumber:
                    /*this.moduleStructure.module.ObjectType === 'oReturns'
                    ? '-'
                    :*/ dbBatch,
                  ExpDate: expDate,
                  AddmisionDate:
                    this.moduleStructure.module.ObjectType !== 'oReturns'
                      ? inDate
                      : moment(new Date()).format(
                          g.companyConfiguration.MomentDateFormat,
                        ),
                  MnfSerial: mnfSerial,
                };

                batchNumbersTemp.push(batchValue);
              }

              const jsonToSave = JSON.stringify(batchNumbersTemp);
              valueToSave = jsonToSave.substring(1, jsonToSave.length - 1);
            }

            const itmSerialNumberTemp = JSON.parse(`[${valueToSave}]`);

            let tempQty = 0;
            itmSerialNumberTemp.forEach((bn) => {
              tempQty += Number(bn.Quantity / numPerSale);
            });

            if (
              this.moduleStructure.module.ObjectType === 'InventoryCounting' &&
              this.global.inCountingBatchDisplayDetailMessage
            ) {
              let scanQty = Number(this.scannedQty);
              this.modal.success({
                nzContent: this.layoutService
                  .translate(
                    '{#BATCH} of the {#ITEMCODE} with {#QTY} has been counted',
                  )
                  .replace('{#BATCH}', scanControl.value)
                  .replace('{#ITEMCODE}', itemCode)
                  .replace('{#QTY}', scanQty + ''),
                nzCloseOnNavigation: true,
              });
            }

            this.setITMSerialBatchNumberValue(valueToSave);

            let newQty = Number(
              accounting.formatNumber(
                tempQty,
                g.companyConfiguration.QuantityDecimal,
                g.companyConfiguration.ThousandSep,
                g.companyConfiguration.DecimalSep,
              ),
            );

            if (isNaN(newQty)) {
              newQty = tempQty;
            }
            qtyProp.ValueAsObject = newQty;

            if (fromAuto) {
              scanControl.disabled = false;
              quantityControl.value = '';
              scanControl.select();
              scanControl.focus();
              //this.shouldFocusOnScanControl = true;
            } else {
              this.resetScanFields(quantityControl, scanControl);
            }
          });
      } else {
        const batchNumbersTemp = JSON.parse(`[${itmSerialNumber}]`);
        batchNumbersTemp.forEach((bn) => {
          bn.Quantity = bn.Quantity / numPerSale;
        });

        if (batchNumbersTemp.length === 0) {
          if (
            this.rowToWorkWith['BinActivate'] === 'Y' &&
            this.rowToWorkWith['FromBinActivate'] === 'Y'
          ) {
            batchNumbersTemp.push({
              Quantity: this.scannedQty * numPerSale,
              BinLocation: this.binCode,
              FromBinLocation: this.fromBinCode,
            });

            const jsonToSave = JSON.stringify(batchNumbersTemp);
            valueToSave = jsonToSave.substring(1, jsonToSave.length - 1);
          }
        } else {
          if (
            this.rowToWorkWith['BinActivate'] === 'Y' &&
            this.rowToWorkWith['FromBinActivate'] === 'Y'
          ) {
            let alreadyFound = batchNumbersTemp.find((bn) => {
              if (
                bn.BinLocation === this.binCode &&
                bn.FromBinLocation === this.fromBinCode
              ) {
                return bn;
              }
            });
            if (alreadyFound !== undefined) {
              alreadyFound.Quantity += this.scannedQty * numPerSale;
            } else {
              batchNumbersTemp.push({
                Quantity: this.scannedQty * numPerSale,
                BinLocation: this.binCode,
                FromBinLocation: this.fromBinCode,
              });
            }

            const jsonToSave = JSON.stringify(batchNumbersTemp);
            valueToSave = jsonToSave.substring(1, jsonToSave.length - 1);
          }
        }

        this.setITMSerialBatchNumberValue(valueToSave);

        let showSuccessMessage =
          this.rowToWorkWith['ManBtchNum'] === 'N' &&
          this.rowToWorkWith['ManSerNum'] === 'N' &&
          this.moduleStructure.module.ObjectType === 'InventoryCounting' &&
          this.global.inCountingNormalItemisplayDetailMessage;

        if (
          this.rowToWorkWith['ManBtchNum'] === 'N' &&
          this.rowToWorkWith['ManSerNum'] === 'N' &&
          ((this.moduleStructure.module.ObjectType !== 'InventoryCounting' &&
            this.cumulativeModeForNormalItems) ||
            (this.moduleStructure.module.ObjectType === 'InventoryCounting' &&
              this.cumulativeModeForNormalItems &&
              !this.global.inCountingDisableCumulativeModeForNormal))
        ) {
          if (showSuccessMessage) {
            let scanValue = scanControl.value;
            let scanQty = this.scannedQty;
            setTimeout(() => {
              this.modal.success({
                nzContent: this.layoutService
                  .translate('{#ITEMCODE} with {#QTY} has been counted')
                  .replace('{#ITEMCODE}', scanValue)
                  .replace('{#QTY}', scanQty + ''),
                nzCloseOnNavigation: true,
              });
            }, 1000);
          }

          //this.rowToWorkWith = undefined;
          quantityControl.value = '';
          this.scannedQty = undefined;
          //quantityControl.focus();
          //scanControl.value = '';
          //scanControl.focus();
          //this.shouldFocusOnScanControl = true;
          return;
        } else {
          if (showSuccessMessage) {
            let scanValue = scanControl.value;
            let scanQty = this.scannedQty;
            setTimeout(() => {
              this.modal.success({
                nzContent: this.layoutService
                  .translate('{#ITEMCODE} with {#QTY} has been counted')
                  .replace('{#ITEMCODE}', scanValue)
                  .replace('{#QTY}', scanQty + ''),
                nzCloseOnNavigation: true,
              });
            }, 1000);
          }

          this.resetScanFields(quantityControl, scanControl);
          return;
        }
      }
    }

    if (!fromAuto) {
      if (
        this.moduleStructure.module.ObjectType !== 'InventoryCounting' &&
        this.moduleStructure.module.ObjectType !== 'oInventoryGenEntry' &&
        this.openQuantityToWorkWith !== undefined &&
        this.openQuantityToWorkWith.ValueAsObject !== '' &&
        this.openQuantityToWorkWith.ValueAsObject !== 0 &&
        this.quantityToWorkWith.ValueAsObject >
          this.openQuantityToWorkWith.ValueAsObject
      ) {
        this.notificationService.create(
          'warning',
          this.layoutService.translate(
            'The selected quantity ' +
              this.quantityToWorkWith.ValueAsObject +
              ' exceeds the open quantity' +
              this.openQuantityToWorkWith.ValueAsObject,
          ),
          '',
        );

        let audio = new Audio('assets/audio_file.mp3');
        audio.load();
        audio.play();
      }

      if (
        this.moduleStructure.module.ObjectType !== 'InventoryCounting' &&
        this.moduleStructure.module.ObjectType !== 'oInventoryGenEntry' &&
        this.scanMode !== 'Box' &&
        this.scanMode !== 'NewBox'
      ) {
        let showFullMessage = true;
        for (let i = 0; i < this.lines.length; i++) {
          const properties = this.lines[i].Properties;
          const quantity = properties.find(
            (p) => p.Name === 'Quantity',
          ).ValueAsObject;
          const openQty = properties.find(
            (p) => p.Name === 'OpenQty',
          ).ValueAsObject;
          if (quantity < openQty) {
            showFullMessage = false;
            break;
          }
        }
        if (showFullMessage) {
          this.notificationService.create(
            'success',
            this.layoutService.translate(
              'You have scanned all open quantities',
            ),
            '',
          );
        }
      }
      if (this.scanMode === 'Box' || this.scanMode === 'NewBox') {
        this.resetScanFields(quantityControl, scanControl);
        return;
      }
    }
  }

  doExecuteScanOfItem(
    scannedValue,
    itemCode,
    scanControl,
    quantityControl,
    managedBySerial,
    managedByBatch,
    scannedBarcode,
  ) {
    this.allowAddNewItemsInPackage = g.allowAddNewItemsInPackage;

    console.log('doExecuteScanOfItem', itemCode);
    for (let i = 0; i < this.lines.length; i++) {
      const properties = this.lines[i].Properties;
      const itemProp = properties.find((p) => p.Name === 'ItemCode');

      if (
        itemProp != null &&
        itemProp !== undefined &&
        itemCode === itemProp.ValueAsObject
      ) {
        if (
          this.recordModel.ObjectKey !== 'InventoryCounting' &&
          this.recordModel.ObjectKey !== 'oInventoryGenEntry' &&
          this.recordModel.ObjectKey !== 'oInventoryGenExit' &&
          this.recordModel.ObjectKey !== 'oInventoryTransferRequest'
        ) {
          const quantityProp = properties.find(
            (p) => p.Name === 'Quantity' || p.Name == 'PickedQuantity',
          ).ValueAsObject;
          const openQtyProp = properties.find(
            (p) => p.Name === 'OpenQty' || p.Name == 'ReleasedQuantity',
          ).ValueAsObject;
          if (quantityProp === openQtyProp) {
            continue;
          }
        }
        this.rowToWorkWith = this.lines[i];
        break;
      }
    }

    if (this.rowToWorkWith === null) {
      for (let i = 0; i < this.lines.length; i++) {
        const properties = this.lines[i].Properties;
        const itemProp = properties.find((p) => p.Name === 'ItemCode');

        if (
          itemProp != null &&
          itemProp !== undefined &&
          itemCode === itemProp.ValueAsObject
        ) {
          this.rowToWorkWith = this.lines[i];
          break;
        }
      }
    }
    this.isNew = false;
    if (
      this.rowToWorkWith === null &&
      this.recordModel.ObjectKey === 'ITM_WMS_SSCC' &&
      !this.allowAddNewItemsInPackage
    ) {
      this.message.error(
        this.layoutService.translate(
          "Can't find a product related to the scanned barcode.",
        ),
        { nzDuration: 5000 },
      );
      this.playErrorVoice();
      this.resetScanFields(quantityControl, scanControl);
      return;
    }
    if (this.rowToWorkWith === null) {
      if (
        this.recordModel.ObjectKey === 'oPickLists' /*||
        this.recordModel.ObjectKey === 'oInventoryGenEntry'*/
      ) {
        this.message.error(
          this.layoutService.translate(
            `We couldn't find any result for the scanned value ${scanControl.value}. `,
          ),
          { nzDuration: 5000 },
        );

        // modal for error
        /*this.modal.error({
          nzTitle: this.layoutService.translate(
            `We couldn't find any result for the scanned value ${scanControl.value}.`,
          ),
          nzContent: '',
          nzCancelText: null,
        });*/
        /*alert(
          this.layoutService.translate(
            `We couldn't find any result for the scanned value ${scanControl.value}.`,
          ),
        );*/

        (document.activeElement as HTMLElement)?.blur();
        this.isModalOpen = true;
        this.modal.error({
          nzTitle: this.layoutService.translate(
            `We couldn't find any result for the scanned value ${scanControl.value}.`,
          ),
          nzContent: '',
          nzCancelText: null,
          nzMaskClosable: false,
          nzKeyboard: false,
          nzClosable: false,
          nzOkText: 'OK',
          nzAutofocus: 'ok',
          nzOnOk: () => {
            this.isModalOpen = false;
            setTimeout(() => {
              this.scanBatchControl?.nativeElement.focus();
            },500);
          },
        });

        this.playErrorVoice();
        this.resetScanFields(quantityControl, scanControl);
        return;
      }
      const lineNum = this.addLineToTable();

      /*const scannedBarcodeField = (this.lines[
        this.lines.length - 1
      ].Properties.find((p) => p.Name === 'ScannedBarcode').ValueAsObject =
        scannedBarcode);*/

      const itemCodeEle = this.lines[lineNum].Properties.find(
        (p) => p.Name === 'ItemCode',
      );

      this.layoutService
        .getModuleHeaderData(4, itemCode, '', false)
        .subscribe((d) => {
          this.moduleStructure.module.Sections.forEach((section) => {
            if (
              section.XmlTagName === 'Document_Lines' ||
              section.XmlTagName === 'StockTransfer_Lines' ||
              section.XmlTagName ===
                'InventoryCountingLines|InventoryCountingLine'
            ) {
              for (let i = 0; i < section.Fields.length; i++) {
                const field = section.Fields[i];

                if (field.LinkedModule === '4') {
                  const value = d[field.LinkedField];

                  for (
                    let j = 0;
                    j < this.lines[lineNum].Properties.length;
                    j++
                  ) {
                    const property = this.lines[lineNum].Properties[j];

                    if (property.Name === field.PropertyName) {
                      property.ValueAsObject = value;

                      this.layoutService.triggerFieldValueChanged({
                        recordProperty: property,
                        formId: '',
                        line: this.lines[lineNum].Id,
                        recordModel: this.recordModel,
                        sectionTagName: section.XmlTagName,
                        moduleStructure: this.moduleStructure,
                      });
                    }
                  }
                }
              }
            }
          });
          this.rowToWorkWith = this.lines[lineNum];
          this.isNew = true;
          if (this.checkDONTDisplayNotificationForNewItemRule()) {
            this.notificationService.create(
              'warning',
              this.layoutService.translate(
                'You are going to add a new item #' + itemCode,
              ),
              '',
            );

            // modal for info
            /*this.modal.info({
              nzTitle: this.layoutService.translate(
                'You are going to add a new item #' + itemCode,
              ),
              nzContent: '',
              nzCancelText: null,
            });*/
            /*alert(
              this.layoutService.translate(
                'You are going to add a new item #' + itemCode,
              ),
            );*/

            (document.activeElement as HTMLElement)?.blur();
            this.isModalOpen = true;
            this.modal.info({
              nzTitle: this.layoutService.translate(
                'You are going to add a new item #' + itemCode,
              ),
              nzContent: '',
              nzCancelText: null,
              nzMaskClosable: false,
              nzKeyboard: false,
              nzClosable: false,
              nzOkText: 'OK',
              nzAutofocus: 'ok',
              nzOnOk: () => {
                this.isModalOpen = false;
                setTimeout(() => {
                  this.scanBatchControl?.nativeElement.focus();
                },500);
              },
            });
          }

          this.rowToWorkWith['isNew'] = true;

          if (scannedBarcode !== undefined) {
            const rowToWorkWith = this.rowToWorkWith;
            const component = this;

            // setTimeout(() => {
            //   LayoutService.setValue(
            //     scannedBarcodeField,
            //     scannedBarcode,
            //     component.layoutService,
            //     component.recordModel,
            //     rowToWorkWith.Id,
            //     component.section.XmlTagName,
            //     component.moduleStructure
            //   );
            // }, 200);
          }

          if (managedBySerial === 'Y') {
            this.rowToWorkWith['ManBtchNum'] = 'N';
            this.rowToWorkWith['ManSerNum'] = 'Y';
            //this.scannedQty = 1;

            this.checkBinLocations();

            /*setTimeout(function () {
              serialNumberControl.focus();
            }, 200);*/

            this.scannedQty = undefined;
            const comp = this;

            setTimeout(function () {
              comp.focusAfterScan(scanControl, scannedValue, quantityControl);
            }, 1000);
          } else if (managedByBatch === 'Y') {
            this.rowToWorkWith['ManBtchNum'] = 'Y';
            this.rowToWorkWith['ManSerNum'] = 'N';

            this.checkBinLocations();

            this.scannedQty = undefined;
            const comp = this;
            setTimeout(function () {
              comp.focusAfterScan(scanControl, scannedValue, quantityControl);
            }, 1000);
          } else {
            this.rowToWorkWith['ManBtchNum'] = 'N';
            this.rowToWorkWith['ManSerNum'] = 'N';

            if (this.rowToWorkWith['ScannedQty'] === undefined) {
              this.rowToWorkWith['ScannedQty'] = 0;
            }

            if (this.autoIncrease) {
              let qtyProp = this.rowToWorkWith.Properties.find(
                (p) => p.Name === 'Quantity',
              );

              if (
                this.recordModel.ObjectKey === 'InventoryCounting' ||
                this.recordModel.ObjectKey === 'InventoryPosting'
              ) {
                qtyProp = this.rowToWorkWith.Properties.find(
                  (p) => p.Name === 'UoMCountedQuantity',
                );
              }

              if (!this.isNew) {
                qtyProp.ValueAsObject = Number(qtyProp.ValueAsObject) + 1;
              } else {
                qtyProp.ValueAsObject = 1;
              }

              setTimeout(() => {
                if (
                  this.recordModel.ObjectKey === 'InventoryCounting' ||
                  this.recordModel.ObjectKey === 'InventoryPosting'
                ) {
                  if (this.setCountedAsChecked) {
                    this.lines[lineNum].Properties.find(
                      (p) => p.Name === 'Counted',
                    ).Value = 'Y';
                    this.lines[lineNum].Properties.find(
                      (p) => p.Name === 'Counted',
                    ).ValueAsObject = 'Y';
                  }
                }
              }, 1000);

              //to be checked later
              //this.resetScanFields(quantityControl, scanControl);
              this.resetQuantityFields(quantityControl);
            } else {
              setTimeout(function () {
                comp.checkBinLocations();
              }, 1500);

              const comp = this;
              setTimeout(function () {
                comp.focusAfterScan(scanControl, scannedValue, quantityControl);
              }, 1000);
            }
          }
        });
    } else {
      if (managedBySerial === 'Y') {
        this.rowToWorkWith['ManBtchNum'] = 'N';
        this.rowToWorkWith['ManSerNum'] = 'Y';

        //this.scannedQty = 1;

        this.checkBinLocations();

        /*setTimeout(function () {
          serialNumberControl.focus();
        }, 200);*/

        this.scannedQty = undefined;
        const comp = this;

        setTimeout(function () {
          comp.focusAfterScan(scanControl, scannedValue, quantityControl);
        }, 1000);
      } else if (managedByBatch === 'Y') {
        this.rowToWorkWith['ManBtchNum'] = 'Y';
        this.rowToWorkWith['ManSerNum'] = 'N';

        this.checkBinLocations();
        const batchToWorkWithProp = this.rowToWorkWith.Properties.find(
          (p) => p.Name === 'BatchNumber',
        );
        if (
          this.recordModel.ObjectKey ===
            'oPickLists' /* && another condition*/ &&
          batchToWorkWithProp != null &&
          batchToWorkWithProp !== undefined &&
          batchToWorkWithProp.Value !== ''
        ) {
          this.batchScanFieldVisible = true;
          setTimeout(() => {
            this.scanBatchControl.nativeElement.focus();
          }, 1000);
        } else {
          this.scannedQty = undefined;
          const comp = this;
          setTimeout(function () {
            comp.focusAfterScan(scanControl, scannedValue, quantityControl);
          }, 1000);
        }
      } else {
        this.rowToWorkWith['ManBtchNum'] = 'N';
        this.rowToWorkWith['ManSerNum'] = 'N';

        if (this.rowToWorkWith['ScannedQty'] === undefined) {
          this.rowToWorkWith['ScannedQty'] = 0;
        }

        if (this.autoIncrease) {
          let qtyProp = this.rowToWorkWith.Properties.find(
            (p) => p.Name === 'Quantity',
          );

          if (
            this.recordModel.ObjectKey === 'InventoryCounting' ||
            this.recordModel.ObjectKey === 'InventoryPosting'
          ) {
            qtyProp = this.rowToWorkWith.Properties.find(
              (p) => p.Name === 'UoMCountedQuantity',
            );
          }

          if (!this.isNew) {
            qtyProp.ValueAsObject = Number(qtyProp.ValueAsObject) + 1;
          }

          if (
            this.recordModel.ObjectKey === 'InventoryCounting' ||
            this.recordModel.ObjectKey === 'InventoryPosting'
          ) {
            if (this.setCountedAsChecked) {
              this.rowToWorkWith.Properties.find(
                (p) => p.Name === 'Counted',
              ).Value = 'Y';
              this.rowToWorkWith.Properties.find(
                (p) => p.Name === 'Counted',
              ).ValueAsObject = 'Y';
            }
          }

          // to be checked later
          //this.resetScanFields(quantityControl, scanControl);
          this.resetQuantityFields(quantityControl);
        } else {
          this.checkBinLocations();
          const comp = this;
          setTimeout(function () {
            comp.focusAfterScan(scanControl, scannedValue, quantityControl);
          }, 1000);
        }
      }
    }
  }

  doExecuteScanOfBatchNew(
    scannedValue,
    itemCode,
    batchNumber,
    quantityControl,
    batchWarehouse,
  ) {
    if (this.recordModel.ObjectKey === 'oPickLists') {
      this.message.error(
        this.layoutService.translate(
          `We couldn't find any result for the scanned value. `,
        ),
        { nzDuration: 5000 },
      );
      this.playErrorVoice();
      return;
    }
    const lineNum = this.addLineToTable();

    const itemCodeEle = this.lines[this.lines.length - 1].Properties.find(
      (p) => p.Name === 'ItemCode',
    );

    this.layoutService
      .getModuleHeaderData(4, itemCode, '', false)
      .subscribe((d1) => {
        this.moduleStructure.module.Sections.forEach((section) => {
          if (
            section.XmlTagName === 'Document_Lines' ||
            section.XmlTagName === 'StockTransfer_Lines' ||
            section.XmlTagName ===
              'InventoryCountingLines|InventoryCountingLine'
          ) {
            section.Fields.forEach((field) => {
              if (field.LinkedModule === '4') {
                const value = d1[field.LinkedField];

                this.lines[this.lines.length - 1].Properties.forEach(
                  (property) => {
                    if (property.Name === field.PropertyName) {
                      property.ValueAsObject = value;
                      this.layoutService.triggerFieldValueChanged({
                        recordProperty: property,
                        formId: '',
                        line: this.lines[this.lines.length - 1].Id,
                        recordModel: this.recordModel,
                        sectionTagName: section.XmlTagName,
                        moduleStructure: this.moduleStructure,
                      });
                    }
                  },
                );
              }
            });
          }
        });
        this.rowToWorkWith = this.lines[this.lines.length - 1];
        if (this.recordModel.ObjectKey === 'InventoryCounting') {
          const headerLine = this.recordModel.Categories.find(
            (cat) => cat.Id === 'InventoryCounting',
          ).Lines[0];
          const headerWhs = headerLine.Properties.find(
            (p) => p.Name === 'CountingInWhs',
          ).ValueAsObject;

          this.rowToWorkWith.Properties.find(
            (p) => p.Name === 'WarehouseCode',
          ).ValueAsObject = headerWhs;
        }
        if (
          this.recordModel.ObjectKey === 'oInventoryTransferRequest' ||
          this.recordModel.ObjectKey === 'oStockTransfer'
        ) {
          this.rowToWorkWith.Properties.find(
            (p) => p.Name === 'FromWarehouse',
          ).ValueAsObject = batchWarehouse;

          this.layoutService.triggerFieldValueChanged({
            recordProperty: this.rowToWorkWith.Properties.find(
              (p) => p.Name === 'FromWarehouse',
            ),
            formId: '',
            line: this.lines[this.lines.length - 1].Id,
            recordModel: this.recordModel,
            sectionTagName: 'StockTransfer_Lines',
            moduleStructure: this.moduleStructure,
          });
        } else if (
          this.recordModel.ObjectKey === 'oDeliveryNotes' ||
          this.recordModel.ObjectKey === 'oInventoryGenExit'
        ) {
          this.rowToWorkWith.Properties.find(
            (p) => p.Name === 'WarehouseCode',
          ).ValueAsObject = batchWarehouse;

          this.layoutService.triggerFieldValueChanged({
            recordProperty: this.rowToWorkWith.Properties.find(
              (p) => p.Name === 'WarehouseCode',
            ),
            formId: '',
            line: this.lines[this.lines.length - 1].Id,
            recordModel: this.recordModel,
            sectionTagName: 'Document_Lines',
            moduleStructure: this.moduleStructure,
          });
        }

        this.isNew = true;

        if (this.checkDONTDisplayNotificationForNewItemRule()) {
          this.notificationService.create(
            'warning',
            this.layoutService.translate(
              'You are going to add a new item #' + itemCode,
            ),
            '',
          );
        }

        this.rowToWorkWith['ManBtchNum'] = 'Y';
        this.rowToWorkWith['ManSerNum'] = 'N';
        const comp = this;
        setTimeout(() => {
          comp.checkBinLocations();
          comp.scannedQty = null;
          comp.batchNumber = batchNumber;

          setTimeout(function () {
            comp.focusAfterScan(undefined, scannedValue, quantityControl);
          }, 1000);
        }, 1000);
      });
  }

  doExecuteScanOfBatchNewForQR(
    itemCode,
    batchNumber,
    quantityControl,
    batchWarehouse,
    quantityVal,
  ) {
    this.addLineToTable();
    const itemCodeEle = this.lines[this.lines.length - 1].Properties.find(
      (p) => p.Name === 'ItemCode',
    );

    this.layoutService
      .getModuleHeaderData(4, itemCode, '', false)
      .subscribe((d1) => {
        this.moduleStructure.module.Sections.forEach((section) => {
          if (
            section.XmlTagName === 'Document_Lines' ||
            section.XmlTagName === 'StockTransfer_Lines' ||
            section.XmlTagName ===
              'InventoryCountingLines|InventoryCountingLine'
          ) {
            section.Fields.forEach((field) => {
              if (field.LinkedModule === '4') {
                const value = d1[field.LinkedField];

                this.lines[this.lines.length - 1].Properties.forEach(
                  (property) => {
                    if (property.Name === field.PropertyName) {
                      property.ValueAsObject = value;
                      this.layoutService.triggerFieldValueChanged({
                        recordProperty: property,
                        formId: '',
                        line: this.lines[this.lines.length - 1].Id,
                        recordModel: this.recordModel,
                        sectionTagName: section.XmlTagName,
                        moduleStructure: this.moduleStructure,
                      });
                    }
                  },
                );
              }
            });
          }
        });
        this.rowToWorkWith = this.lines[this.lines.length - 1];
        if (this.recordModel.ObjectKey === 'InventoryCounting') {
          const headerLine = this.recordModel.Categories.find(
            (cat) => cat.Id === 'InventoryCounting',
          ).Lines[0];
          const headerWhs = headerLine.Properties.find(
            (p) => p.Name === 'CountingInWhs',
          ).ValueAsObject;

          this.rowToWorkWith.Properties.find(
            (p) => p.Name === 'WarehouseCode',
          ).ValueAsObject = headerWhs;
        } else if (
          this.recordModel.ObjectKey === 'oInventoryTransferRequest' ||
          this.recordModel.ObjectKey === 'oStockTransfer'
        ) {
          this.rowToWorkWith.Properties.find(
            (p) => p.Name === 'FromWarehouse',
          ).ValueAsObject = batchWarehouse;

          this.layoutService.triggerFieldValueChanged({
            recordProperty: this.rowToWorkWith.Properties.find(
              (p) => p.Name === 'FromWarehouse',
            ),
            formId: '',
            line: this.lines[this.lines.length - 1].Id,
            recordModel: this.recordModel,
            sectionTagName: 'StockTransfer_Lines',
            moduleStructure: this.moduleStructure,
          });
        } else if (
          this.recordModel.ObjectKey === 'oDeliveryNotes' ||
          this.recordModel.ObjectKey === 'oInventoryGenExit'
        ) {
          this.rowToWorkWith.Properties.find(
            (p) => p.Name === 'WarehouseCode',
          ).ValueAsObject = batchWarehouse;

          this.layoutService.triggerFieldValueChanged({
            recordProperty: this.rowToWorkWith.Properties.find(
              (p) => p.Name === 'WarehouseCode',
            ),
            formId: '',
            line: this.lines[this.lines.length - 1].Id,
            recordModel: this.recordModel,
            sectionTagName: 'Document_Lines',
            moduleStructure: this.moduleStructure,
          });
        }

        this.isNew = true;

        if (this.checkDONTDisplayNotificationForNewItemRule()) {
          this.notificationService.create(
            'warning',
            this.layoutService.translate(
              'You are going to add a new item #' + itemCode,
            ),
            '',
          );
        }

        this.rowToWorkWith['ManBtchNum'] = 'Y';
        this.rowToWorkWith['ManSerNum'] = 'N';
        const comp = this;
        /*this.checkBinLocations();
        this.scannedQty = null;
        this.batchNumber = batchNumber;
        setTimeout(function () {
          comp.focusAfterScanQR(
            quantityControl,
            batchNumber,
            Number(quantityVal),
          );
        }, 1000);*/
        setTimeout(() => {
          comp.checkBinLocations();
          comp.scannedQty = null;
          comp.batchNumber = batchNumber;

          setTimeout(function () {
            comp.focusAfterScanQR(
              quantityControl,
              batchNumber,
              Number(quantityVal),
            );
          }, 1000);
        }, 1000);
      });
  }

  editRow(data: RecordLine, visible: boolean) {
    if (visible) {
      data.IsEditModeDrawerInitialized = true;
      setTimeout(() => {
        data.IsEditMode = true;
      }, 200);
    } else {
      data.IsEditMode = false;
      setTimeout(() => {
        data.IsEditModeDrawerInitialized = false;
      }, 50);
    }
  }

  deleteItemWhenReverseScan(quantityControl, scanControl) {
    this.deleteRow(this.rowToWorkWith.Id);
    this.resetScanFields(quantityControl, scanControl);
  }

  deleteRow(id: number): void {
    let recordCategory: RecordCategory = null;
    this.recordModel.Categories.forEach((category) => {
      if (category.Id === this.section.XmlTagName) {
        recordCategory = category;
      }
    });

    if (recordCategory !== null) {
      if (this.maxLineNum === 0) {
        this.maxLineNum =
          Math.max.apply(
            Math,
            recordCategory.Lines.map(
              (o) =>
                o.Properties.find(
                  (prop) => prop.Name === this.section.KeyPropertyName,
                ).ValueAsObject,
            ),
          ) + 1;
      }

      const lineToDelete = recordCategory.Lines.find((d) => d.Id === id);
      const lineToDeleteIndex = recordCategory.Lines.findIndex(
        (d) => d.Id === id,
      );

      recordCategory.Lines.splice(lineToDeleteIndex, 1);

      const lineNumberValue = lineToDelete.Properties.find(
        (prop) => prop.Name === this.section.KeyPropertyName,
      ).ValueAsObject;

      if (
        recordCategory.LineToDelete == null ||
        recordCategory.LineToDelete === undefined ||
        recordCategory.LineToDelete === ''
      ) {
        recordCategory.LineToDelete = lineNumberValue;
      } else {
        recordCategory.LineToDelete =
          recordCategory.LineToDelete + ',' + lineNumberValue;
      }

      recordCategory.KeyPropertyName = this.section.KeyPropertyName;
      recordCategory.PropertyNameInParent = this.section.PropertyNameInParent;

      this.deletedLines.push(lineToDelete);

      for (let i = 0; i < recordCategory.Lines.length; i++) {
        recordCategory.Lines[i].Id = i;
      }

      this.layoutService.triggerDeleteRow(
        recordCategory,
        lineToDelete,
        lineToDeleteIndex,
        this.recordModel,
        this.moduleStructure,
      );
    }

    recordCategory.DeletedLines = this.deletedLines;

    recordCategory.Lines = [...recordCategory.Lines];
    this.lines = recordCategory.Lines;

    if (this.recordModel.ObjectKey === 'ITM_WMS_BOX_DCLR_1') {
      const headerLine = this.recordModel.Categories.find(
        (cat) => cat.Id === 'ITM_WMS_BOX_DCLR',
      ).Lines[0];
      const boxCurrentItemCode = headerLine.Properties.find(
        (p) => p.Name === 'U_ITEM_CODE',
      ).ValueAsObject;
      const qtyToLoad = headerLine.Properties.find(
        (p) => p.Name === 'BOX_COUNT',
      );
      const remQtyToLoad = headerLine.Properties.find(
        (p) => p.Name === 'REM_BOX_COUNT',
      );
      remQtyToLoad.ValueAsObject =
        Number(qtyToLoad.ValueAsObject) -
        this.lines.filter(
          (line) =>
            line.Properties.find((p) => p.Name === 'U_ITEM_CODE')
              ?.ValueAsObject === boxCurrentItemCode,
        ).length;
    }

    this.updatePaginatedLines();
  }

  checkBinLocations() {
    const properties = this.rowToWorkWith.Properties;
    const fromBinActivateProp = properties.find(
      (p) => p.Name === 'FromBinActivate',
    );
    const binActivateProp = properties.find((p) => p.Name === 'BinActivate');
    if (binActivateProp !== undefined) {
      this.rowToWorkWith['BinActivate'] = binActivateProp.ValueAsObject;
    } else {
      this.rowToWorkWith['BinActivate'] = 'N';
    }
    if (fromBinActivateProp !== undefined) {
      this.rowToWorkWith['FromBinActivate'] = fromBinActivateProp.ValueAsObject;
    } else {
      this.rowToWorkWith['FromBinActivate'] = 'N';
    }

    const toBinActivateProp = properties.find(
      (p) => p.Name === 'ToBinActivate',
    );

    if (toBinActivateProp !== undefined) {
      this.rowToWorkWith['ToBinActivate'] = toBinActivateProp.ValueAsObject;
    } else {
      this.rowToWorkWith['ToBinActivate'] = 'N';
    }

    this.fromBinOptions = [];
    this.fromBinCode = '';
    this.binOptions = [];
    this.binCode = '';

    //this.toBinOptions = [];
    //this.toBinCode = '';

    if (this.rowToWorkWith['BinActivate'] === 'Y') {
      const paramsNames = g.queriesData[2448];
      //const vals: string[] = [];
      const vals: { [key: string]: any } = {};
      const whsProp = properties.find((p) => p.Name === 'WarehouseCode');
      //vals.push(whsProp.ValueAsObject);
      vals['DocumentLinesBinAllocations.WhsCode'] = whsProp.ValueAsObject;

      this.layoutService.executeQuery(2448, vals).subscribe((d: any) => {
        this.binOptions = d;
      });

      /*this.layoutService
        .getSelectValues(
          this.moduleStructure,
          '',
          0,
          2448, // bin locations for warehoust
          paramsNames,
          vals
        )
        .subscribe((d: any) => {
          this.binOptions = d.Values.rowsArray;
        });*/
    }
    if (this.rowToWorkWith['FromBinActivate'] === 'Y') {
      const paramsNames = g.queriesData[2448];
      const vals: { [key: string]: any } = {};
      const whsProp = properties.find((p) => p.Name === 'FromWarehouse');
      vals['DocumentLinesBinAllocations.WhsCode'] = whsProp.ValueAsObject;

      this.layoutService.executeQuery(2448, vals).subscribe((d: any) => {
        this.fromBinOptions = d;
      });

      /*this.layoutService
        .getSelectValues(
          this.moduleStructure,
          '',
          0,
          2448, // bin locations for warehoust
          paramsNames,
          vals
        )
        .subscribe((d: any) => {
          this.fromBinOptions = d.Values.rowsArray;
        });*/
    }
  }

  checkUniqueBatchRule(scanControl, itmSerialNumber): boolean {
    let isTransferModule =
      this.recordModel.ObjectKey === 'oStockTransfer' ||
      this.recordModel.ObjectKey === 'oInventoryTransferRequest';

    let uniqueBatchModeTransfer =
      g.uniqueBatchModeGoodIssue && isTransferModule;

    let isCountingModule =
      this.recordModel.ObjectKey === 'InventoryCounting' ||
      this.recordModel.ObjectKey === 'InventoryPosting';

    this.uniqueBatchModeCounting =
      this.uniqueBatchModeCounting && isCountingModule;

    let isGoodsIssue = this.recordModel.ObjectKey === 'oInventoryGenExit';
    this.uniqueBatchModeGoodIssue = g.uniqueBatchModeGoodIssue && isGoodsIssue;

    let continueAdding = true;
    const batchNumbersTemp = JSON.parse(`[${itmSerialNumber}]`);
    for (let i = 0; i < batchNumbersTemp.length; i++) {
      let bn = batchNumbersTemp[i];
      if (bn.BatchNumber === scanControl.value && Number(bn.Quantity) !== 0) {
        continueAdding = false;
        break;
      }
    }
    if (
      !continueAdding &&
      (this.uniqueBatchModeCounting ||
        this.uniqueBatchModeGoodIssue ||
        uniqueBatchModeTransfer)
    ) {
      this.message.error(
        this.layoutService.translate('You Already scanned the batch: ') +
          scanControl.value,
        { nzDuration: 5000 },
      );
      this.playErrorVoice();
      return false;
    }

    return true;
  }

  checkDONTDisplayNotificationForNewItemRule(): boolean {
    var docsToCheck = g.DontDisplayNotificationForNewItem.split(',');
    return docsToCheck.indexOf(this.recordModel.ObjectKey) === -1;
  }

  checkHideLinesWithZeroQtyForDocsRule(): boolean {
    var docsToCheck = g.hideLinesWithZeroQtyForDocs.split(',');
    return docsToCheck.indexOf(this.recordModel.ObjectKey) !== -1;
  }

  setITMSerialBatchNumberValue(valueToSave) {
    this.rowToWorkWith.Properties.find(
      (prop) => prop.Name === 'ITMSerialNumber',
    ).ValueAsObject = valueToSave;
  }

  resetScanFields(quantityControl, scanControl) {
    this.rowToWorkWith = undefined;
    if (quantityControl !== undefined) {
      quantityControl.value = '';
      this.scannedQty = null;
    }
    if (this.scanBatchControl !== undefined) {
      this.scanBatchControl.nativeElement.value = '';
      this.batchScanFieldVisible = false;
    }
    if (this.scanBinControl !== undefined) {
      this.scanBinControl.nativeElement.value = '';
      this.binScanFieldVisible = false;
    }
    if (scanControl !== undefined) {
      scanControl.value = '';
      scanControl.disabled = false;
      if (typeof scanControl.focus === 'function') {
        scanControl.focus();
      }

      if (scanControl?.nativeElement) {
        scanControl.nativeElement.value = '';
        scanControl.nativeElement.disabled = false;
        scanControl.nativeElement.focus();
      }
      //this.shouldFocusOnScanControl = true;
      this.offLoadingPallet = '';
    }

    if (this.scanOffLoadingItemControl !== undefined) {
      this.scanOffLoadingItemControl.nativeElement.value = '';
      this.offLoadingItemScanFieldVisible = false;
    }
    if (this.scanOffLoadingUOMControl !== undefined) {
      this.offLoadingUOM = '';
      this.offLoadingUOMOptions = [];
      this.offLoadingUOMScanFieldVisible = false;
    }
    if (this.offloadQuantityControl !== undefined) {
      this.offLoadingQtyScanFieldVisible = false;
    }
  }

  resetQuantityFields(quantityControl) {
    this.rowToWorkWith = undefined;
    if (quantityControl !== undefined) {
      quantityControl.value = '';
      this.scannedQty = null;
    }
  }

  checkQuantityExceedRule(scannedQuantity) {
    if (
      scannedQuantity > this.batchNumberAvaQty &&
      this.moduleStructure.module.ObjectType !== 'oReturns' &&
      this.moduleStructure.module.ObjectType !== 'oPickLists' &&
      this.moduleStructure.module.ObjectType !== 'InventoryCounting' &&
      this.moduleStructure.module.ObjectType !== 'oStockTransfer'
    ) {
      scannedQuantity = this.batchNumberAvaQty;
      this.message.error(
        this.layoutService.translate(
          'Selected quantity exceeds the available quantity in the batch.',
        ),
        { nzDuration: 5000 },
      );
      this.playErrorVoice();
    }
  }

  showConfirmationForNormalItem(): boolean {
    let modules = g.showConfirmationForNormalItem.split(',');
    let res = modules.indexOf(this.recordModel.ObjectKey) !== -1;
    return res;
  }

  showConfirmationForNewBatch(): boolean {
    let modules = g.showConfirmationForNewBatch.split(',');
    let res = modules.indexOf(this.recordModel.ObjectKey) !== -1;
    return res;
  }

  setBinLocation() {
    if (
      this.recordModel.ObjectKey === 'oPickLists' &&
      this.rowToWorkWith['BinActivate'] === 'Y'
    ) {
      const baseItemProp = this.rowToWorkWith.Properties.find(
        (p) => p.Name === 'ItemCode',
      );

      for (let i = 0; i < this.lines.length; i++) {
        const properties = this.lines[i].Properties;
        const itemProp = properties.find((p) => p.Name === 'ItemCode');
        const binAbs = properties.find((p) => p.Name === 'BinAbs');
        const batchNumber = properties.find((p) => p.Name === 'BatchNumber');

        if (
          itemProp != null &&
          itemProp !== undefined &&
          baseItemProp.ValueAsObject === itemProp.ValueAsObject &&
          batchNumber != null &&
          batchNumber !== undefined &&
          this.batchNumber === batchNumber.ValueAsObject
        ) {
          if (binAbs != null && binAbs !== undefined) {
            this.binCode = binAbs.ValueAsObject.toString();
          }
          break;
        }
      }
    }
  }

  numberParser(value: string) {
    if (value == null) {
      return '';
    } else {
      return value.replace('%', '').replace(' ', '');
    }
  }

  formatterQuantity(value: number): string {
    if (value == null || isNaN(value)) {
      value = 0;
    }

    return accounting.formatNumber(
      value,
      g.companyConfiguration.QuantityDecimal,
      g.companyConfiguration.ThousandSep,
      g.companyConfiguration.DecimalSep,
    );
  }
}
